function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object') exports["vue-slick-carousel"] = factory();else root["vue-slick-carousel"] = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && _typeof2(value) === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "fb15");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "00ee":
      /***/
      function ee(module, exports, __webpack_require__) {
        var wellKnownSymbol = __webpack_require__("b622");

        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var test = {};
        test[TO_STRING_TAG] = 'z';
        module.exports = String(test) === '[object z]';
        /***/
      },

      /***/
      "0366":
      /***/
      function _(module, exports, __webpack_require__) {
        var aFunction = __webpack_require__("1c0b"); // optional / simple context binding


        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 0:
              return function () {
                return fn.call(that);
              };

            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "0497":
      /***/
      function _(module, exports) {
        var camel2hyphen = function camel2hyphen(str) {
          return str.replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          }).toLowerCase();
        };

        module.exports = camel2hyphen;
        /***/
      },

      /***/
      "057f":
      /***/
      function f(module, exports, __webpack_require__) {
        var toIndexedObject = __webpack_require__("fc6a");

        var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

        var toString = {}.toString;
        var windowNames = (typeof window === "undefined" ? "undefined" : _typeof2(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return nativeGetOwnPropertyNames(it);
          } catch (error) {
            return windowNames.slice();
          }
        }; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
        };
        /***/

      },

      /***/
      "06cf":
      /***/
      function cf(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var propertyIsEnumerableModule = __webpack_require__("d1e7");

        var createPropertyDescriptor = __webpack_require__("5c6c");

        var toIndexedObject = __webpack_require__("fc6a");

        var toPrimitive = __webpack_require__("c04e");

        var has = __webpack_require__("5135");

        var IE8_DOM_DEFINE = __webpack_require__("0cfb");

        var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor

        exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
          O = toIndexedObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return nativeGetOwnPropertyDescriptor(O, P);
          } catch (error) {
            /* empty */
          }
          if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "07ac":
      /***/
      function ac(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var $values = __webpack_require__("6f53").values; // `Object.values` method
        // https://tc39.github.io/ecma262/#sec-object.values


        $({
          target: 'Object',
          stat: true
        }, {
          values: function values(O) {
            return $values(O);
          }
        });
        /***/
      },

      /***/
      "0cfb":
      /***/
      function cfb(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var fails = __webpack_require__("d039");

        var createElement = __webpack_require__("cc12"); // Thank's IE8 for his funny defineProperty


        module.exports = !DESCRIPTORS && !fails(function () {
          return Object.defineProperty(createElement('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "1276":
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");

        var isRegExp = __webpack_require__("44e7");

        var anObject = __webpack_require__("825a");

        var requireObjectCoercible = __webpack_require__("1d80");

        var speciesConstructor = __webpack_require__("4840");

        var advanceStringIndex = __webpack_require__("8aa5");

        var toLength = __webpack_require__("50c4");

        var callRegExpExec = __webpack_require__("14c3");

        var regexpExec = __webpack_require__("9263");

        var fails = __webpack_require__("d039");

        var arrayPush = [].push;
        var min = Math.min;
        var MAX_UINT32 = 0xFFFFFFFF; // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError

        var SUPPORTS_Y = !fails(function () {
          return !RegExp(MAX_UINT32, 'y');
        }); // @@split logic

        fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
          var internalSplit;

          if ('abbc'.split(/(b)*/)[1] == 'c' || 'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
            // based on es5-shim implementation, need to rework it
            internalSplit = function internalSplit(separator, limit) {
              var string = String(requireObjectCoercible(this));
              var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
              if (lim === 0) return [];
              if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

              if (!isRegExp(separator)) {
                return nativeSplit.call(string, separator, lim);
              }

              var output = [];
              var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
              var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

              var separatorCopy = new RegExp(separator.source, flags + 'g');
              var match, lastIndex, lastLength;

              while (match = regexpExec.call(separatorCopy, string)) {
                lastIndex = separatorCopy.lastIndex;

                if (lastIndex > lastLastIndex) {
                  output.push(string.slice(lastLastIndex, match.index));
                  if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
                  lastLength = match[0].length;
                  lastLastIndex = lastIndex;
                  if (output.length >= lim) break;
                }

                if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
              }

              if (lastLastIndex === string.length) {
                if (lastLength || !separatorCopy.test('')) output.push('');
              } else output.push(string.slice(lastLastIndex));

              return output.length > lim ? output.slice(0, lim) : output;
            }; // Chakra, V8

          } else if ('0'.split(undefined, 0).length) {
            internalSplit = function internalSplit(separator, limit) {
              return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
            };
          } else internalSplit = nativeSplit;

          return [// `String.prototype.split` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.split
          function split(separator, limit) {
            var O = requireObjectCoercible(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
          }, // `RegExp.prototype[@@split]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
          //
          // NOTE: This cannot be properly polyfilled in engines that don't support
          // the 'y' flag.
          function (regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g'); // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.

            var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
            var p = 0;
            var q = 0;
            var A = [];

            while (q < S.length) {
              splitter.lastIndex = SUPPORTS_Y ? q : 0;
              var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
              var e;

              if (z === null || (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
                q = advanceStringIndex(S, q, unicodeMatching);
              } else {
                A.push(S.slice(p, q));
                if (A.length === lim) return A;

                for (var i = 1; i <= z.length - 1; i++) {
                  A.push(z[i]);
                  if (A.length === lim) return A;
                }

                q = p = e;
              }
            }

            A.push(S.slice(p));
            return A;
          }];
        }, !SUPPORTS_Y);
        /***/
      },

      /***/
      "13d5":
      /***/
      function d5(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var $reduce = __webpack_require__("d58f").left;

        var arrayMethodIsStrict = __webpack_require__("a640");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var STRICT_METHOD = arrayMethodIsStrict('reduce');
        var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', {
          1: 0
        }); // `Array.prototype.reduce` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.reduce

        $({
          target: 'Array',
          proto: true,
          forced: !STRICT_METHOD || !USES_TO_LENGTH
        }, {
          reduce: function reduce(callbackfn
          /* , initialValue */
          ) {
            return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "14c3":
      /***/
      function c3(module, exports, __webpack_require__) {
        var classof = __webpack_require__("c6b6");

        var regexpExec = __webpack_require__("9263"); // `RegExpExec` abstract operation
        // https://tc39.github.io/ecma262/#sec-regexpexec


        module.exports = function (R, S) {
          var exec = R.exec;

          if (typeof exec === 'function') {
            var result = exec.call(R, S);

            if (_typeof2(result) !== 'object') {
              throw TypeError('RegExp exec method returned something other than an Object or null');
            }

            return result;
          }

          if (classof(R) !== 'RegExp') {
            throw TypeError('RegExp#exec called on incompatible receiver');
          }

          return regexpExec.call(R, S);
        };
        /***/

      },

      /***/
      "159b":
      /***/
      function b(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var DOMIterables = __webpack_require__("fdbc");

        var forEach = __webpack_require__("17c2");

        var createNonEnumerableProperty = __webpack_require__("9112");

        for (var COLLECTION_NAME in DOMIterables) {
          var Collection = global[COLLECTION_NAME];
          var CollectionPrototype = Collection && Collection.prototype; // some Chrome versions have non-configurable methods on DOMTokenList

          if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
            createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
          } catch (error) {
            CollectionPrototype.forEach = forEach;
          }
        }
        /***/

      },

      /***/
      "17c2":
      /***/
      function c2(module, exports, __webpack_require__) {
        "use strict";

        var $forEach = __webpack_require__("b727").forEach;

        var arrayMethodIsStrict = __webpack_require__("a640");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var STRICT_METHOD = arrayMethodIsStrict('forEach');
        var USES_TO_LENGTH = arrayMethodUsesToLength('forEach'); // `Array.prototype.forEach` method implementation
        // https://tc39.github.io/ecma262/#sec-array.prototype.foreach

        module.exports = !STRICT_METHOD || !USES_TO_LENGTH ? function forEach(callbackfn
        /* , thisArg */
        ) {
          return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        } : [].forEach;
        /***/
      },

      /***/
      "1be4":
      /***/
      function be4(module, exports, __webpack_require__) {
        var getBuiltIn = __webpack_require__("d066");

        module.exports = getBuiltIn('document', 'documentElement');
        /***/
      },

      /***/
      "1c0b":
      /***/
      function c0b(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') {
            throw TypeError(String(it) + ' is not a function');
          }

          return it;
        };
        /***/

      },

      /***/
      "1c7e":
      /***/
      function c7e(module, exports, __webpack_require__) {
        var wellKnownSymbol = __webpack_require__("b622");

        var ITERATOR = wellKnownSymbol('iterator');
        var SAFE_CLOSING = false;

        try {
          var called = 0;
          var iteratorWithReturn = {
            next: function next() {
              return {
                done: !!called++
              };
            },
            'return': function _return() {
              SAFE_CLOSING = true;
            }
          };

          iteratorWithReturn[ITERATOR] = function () {
            return this;
          }; // eslint-disable-next-line no-throw-literal


          Array.from(iteratorWithReturn, function () {
            throw 2;
          });
        } catch (error) {
          /* empty */
        }

        module.exports = function (exec, SKIP_CLOSING) {
          if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
          var ITERATION_SUPPORT = false;

          try {
            var object = {};

            object[ITERATOR] = function () {
              return {
                next: function next() {
                  return {
                    done: ITERATION_SUPPORT = true
                  };
                }
              };
            };

            exec(object);
          } catch (error) {
            /* empty */
          }

          return ITERATION_SUPPORT;
        };
        /***/

      },

      /***/
      "1d80":
      /***/
      function d80(module, exports) {
        // `RequireObjectCoercible` abstract operation
        // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on " + it);
          return it;
        };
        /***/

      },

      /***/
      "1dde":
      /***/
      function dde(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039");

        var wellKnownSymbol = __webpack_require__("b622");

        var V8_VERSION = __webpack_require__("2d00");

        var SPECIES = wellKnownSymbol('species');

        module.exports = function (METHOD_NAME) {
          // We can't use this feature detection in V8 since it causes
          // deoptimization and serious performance degradation
          // https://github.com/zloirock/core-js/issues/677
          return V8_VERSION >= 51 || !fails(function () {
            var array = [];
            var constructor = array.constructor = {};

            constructor[SPECIES] = function () {
              return {
                foo: 1
              };
            };

            return array[METHOD_NAME](Boolean).foo !== 1;
          });
        };
        /***/

      },

      /***/
      "217d":
      /***/
      function d(module, exports) {
        /**
         * Helper function for iterating over a collection
         *
         * @param collection
         * @param fn
         */
        function each(collection, fn) {
          var i = 0,
              length = collection.length,
              cont;

          for (i; i < length; i++) {
            cont = fn(collection[i], i);

            if (cont === false) {
              break; //allow early exit
            }
          }
        }
        /**
         * Helper function for determining whether target object is an array
         *
         * @param target the object under test
         * @return {Boolean} true if array, false otherwise
         */


        function isArray(target) {
          return Object.prototype.toString.apply(target) === '[object Array]';
        }
        /**
         * Helper function for determining whether target object is a function
         *
         * @param target the object under test
         * @return {Boolean} true if function, false otherwise
         */


        function isFunction(target) {
          return typeof target === 'function';
        }

        module.exports = {
          isFunction: isFunction,
          isArray: isArray,
          each: each
        };
        /***/
      },

      /***/
      "23cb":
      /***/
      function cb(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__("a691");

        var max = Math.max;
        var min = Math.min; // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

        module.exports = function (index, length) {
          var integer = toInteger(index);
          return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
        /***/

      },

      /***/
      "23e7":
      /***/
      function e7(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var getOwnPropertyDescriptor = __webpack_require__("06cf").f;

        var createNonEnumerableProperty = __webpack_require__("9112");

        var redefine = __webpack_require__("6eeb");

        var setGlobal = __webpack_require__("ce4e");

        var copyConstructorProperties = __webpack_require__("e893");

        var isForced = __webpack_require__("94ca");
        /*
          options.target      - name of the target object
          options.global      - target is the global object
          options.stat        - export as static methods of target
          options.proto       - export as prototype methods of target
          options.real        - real prototype method for the `pure` version
          options.forced      - export even if the native feature is available
          options.bind        - bind methods to the target, required for the `pure` version
          options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
          options.unsafe      - use the simple assignment of property instead of delete + defineProperty
          options.sham        - add a flag to not completely full polyfills
          options.enumerable  - export as enumerable property
          options.noTargetGet - prevent calling a getter on target
        */


        module.exports = function (options, source) {
          var TARGET = options.target;
          var GLOBAL = options.global;
          var STATIC = options.stat;
          var FORCED, target, key, targetProperty, sourceProperty, descriptor;

          if (GLOBAL) {
            target = global;
          } else if (STATIC) {
            target = global[TARGET] || setGlobal(TARGET, {});
          } else {
            target = (global[TARGET] || {}).prototype;
          }

          if (target) for (key in source) {
            sourceProperty = source[key];

            if (options.noTargetGet) {
              descriptor = getOwnPropertyDescriptor(target, key);
              targetProperty = descriptor && descriptor.value;
            } else targetProperty = target[key];

            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

            if (!FORCED && targetProperty !== undefined) {
              if (_typeof2(sourceProperty) === _typeof2(targetProperty)) continue;
              copyConstructorProperties(sourceProperty, targetProperty);
            } // add a flag to not completely full polyfills


            if (options.sham || targetProperty && targetProperty.sham) {
              createNonEnumerableProperty(sourceProperty, 'sham', true);
            } // extend global


            redefine(target, key, sourceProperty, options);
          }
        };
        /***/

      },

      /***/
      "241c":
      /***/
      function c(module, exports, __webpack_require__) {
        var internalObjectKeys = __webpack_require__("ca84");

        var enumBugKeys = __webpack_require__("7839");

        var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertynames

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return internalObjectKeys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "25f0":
      /***/
      function f0(module, exports, __webpack_require__) {
        "use strict";

        var redefine = __webpack_require__("6eeb");

        var anObject = __webpack_require__("825a");

        var fails = __webpack_require__("d039");

        var flags = __webpack_require__("ad6d");

        var TO_STRING = 'toString';
        var RegExpPrototype = RegExp.prototype;
        var nativeToString = RegExpPrototype[TO_STRING];
        var NOT_GENERIC = fails(function () {
          return nativeToString.call({
            source: 'a',
            flags: 'b'
          }) != '/a/b';
        }); // FF44- RegExp#toString has a wrong name

        var INCORRECT_NAME = nativeToString.name != TO_STRING; // `RegExp.prototype.toString` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring

        if (NOT_GENERIC || INCORRECT_NAME) {
          redefine(RegExp.prototype, TO_STRING, function toString() {
            var R = anObject(this);
            var p = String(R.source);
            var rf = R.flags;
            var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
            return '/' + p + '/' + f;
          }, {
            unsafe: true
          });
        }
        /***/

      },

      /***/
      "2d00":
      /***/
      function d00(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var userAgent = __webpack_require__("342f");

        var process = global.process;
        var versions = process && process.versions;
        var v8 = versions && versions.v8;
        var match, version;

        if (v8) {
          match = v8.split('.');
          version = match[0] + match[1];
        } else if (userAgent) {
          match = userAgent.match(/Edge\/(\d+)/);

          if (!match || match[1] >= 74) {
            match = userAgent.match(/Chrome\/(\d+)/);
            if (match) version = match[1];
          }
        }

        module.exports = version && +version;
        /***/
      },

      /***/
      "342f":
      /***/
      function f(module, exports, __webpack_require__) {
        var getBuiltIn = __webpack_require__("d066");

        module.exports = getBuiltIn('navigator', 'userAgent') || '';
        /***/
      },

      /***/
      "35a1":
      /***/
      function a1(module, exports, __webpack_require__) {
        var classof = __webpack_require__("f5df");

        var Iterators = __webpack_require__("3f8c");

        var wellKnownSymbol = __webpack_require__("b622");

        var ITERATOR = wellKnownSymbol('iterator');

        module.exports = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "37e8":
      /***/
      function e8(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var definePropertyModule = __webpack_require__("9bf2");

        var anObject = __webpack_require__("825a");

        var objectKeys = __webpack_require__("df75"); // `Object.defineProperties` method
        // https://tc39.github.io/ecma262/#sec-object.defineproperties


        module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = objectKeys(Properties);
          var length = keys.length;
          var index = 0;
          var key;

          while (length > index) {
            definePropertyModule.f(O, key = keys[index++], Properties[key]);
          }

          return O;
        };
        /***/
      },

      /***/
      "3b81":
      /***/
      function b81(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "3bbe":
      /***/
      function bbe(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d");

        module.exports = function (it) {
          if (!isObject(it) && it !== null) {
            throw TypeError("Can't set " + String(it) + ' as a prototype');
          }

          return it;
        };
        /***/

      },

      /***/
      "3ca3":
      /***/
      function ca3(module, exports, __webpack_require__) {
        "use strict";

        var charAt = __webpack_require__("6547").charAt;

        var InternalStateModule = __webpack_require__("69f3");

        var defineIterator = __webpack_require__("7dd0");

        var STRING_ITERATOR = 'String Iterator';
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
        // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator

        defineIterator(String, 'String', function (iterated) {
          setInternalState(this, {
            type: STRING_ITERATOR,
            string: String(iterated),
            index: 0
          }); // `%StringIteratorPrototype%.next` method
          // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
        }, function next() {
          var state = getInternalState(this);
          var string = state.string;
          var index = state.index;
          var point;
          if (index >= string.length) return {
            value: undefined,
            done: true
          };
          point = charAt(string, index);
          state.index += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/
      },

      /***/
      "3f8c":
      /***/
      function f8c(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "4160":
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var forEach = __webpack_require__("17c2"); // `Array.prototype.forEach` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.foreach


        $({
          target: 'Array',
          proto: true,
          forced: [].forEach != forEach
        }, {
          forEach: forEach
        });
        /***/
      },

      /***/
      "428f":
      /***/
      function f(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        module.exports = global;
        /***/
      },

      /***/
      "42a0":
      /***/
      function a0(module, exports) {
        /**
         * lodash (Custom Build) <https://lodash.com/>
         * Build: `lodash modularize exports="npm" -o ./`
         * Copyright jQuery Foundation and other contributors <https://jquery.org/>
         * Released under MIT license <https://lodash.com/license>
         * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
         * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
         */

        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;
        /** `Object#toString` result references. */

        var argsTag = '[object Arguments]',
            funcTag = '[object Function]',
            genTag = '[object GeneratorFunction]';
        /** Used to detect unsigned integer values. */

        var reIsUint = /^(?:0|[1-9]\d*)$/;
        /**
         * A faster alternative to `Function#apply`, this function invokes `func`
         * with the `this` binding of `thisArg` and the arguments of `args`.
         *
         * @private
         * @param {Function} func The function to invoke.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} args The arguments to invoke `func` with.
         * @returns {*} Returns the result of `func`.
         */

        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);

            case 1:
              return func.call(thisArg, args[0]);

            case 2:
              return func.call(thisArg, args[0], args[1]);

            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }

          return func.apply(thisArg, args);
        }
        /**
         * The base implementation of `_.times` without support for iteratee shorthands
         * or max array length checks.
         *
         * @private
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         */


        function baseTimes(n, iteratee) {
          var index = -1,
              result = Array(n);

          while (++index < n) {
            result[index] = iteratee(index);
          }

          return result;
        }
        /**
         * Creates a unary function that invokes `func` with its argument transformed.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {Function} transform The argument transform.
         * @returns {Function} Returns the new function.
         */


        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var objectToString = objectProto.toString;
        /** Built-in value references. */

        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeKeys = overArg(Object.keys, Object),
            nativeMax = Math.max;
        /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */

        var nonEnumShadows = !propertyIsEnumerable.call({
          'valueOf': 1
        }, 'valueOf');
        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */

        function arrayLikeKeys(value, inherited) {
          // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
          // Safari 9 makes `arguments.length` enumerable in strict mode.
          var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
          var length = result.length,
              skipIndexes = !!length;

          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */


        function assignValue(object, key, value) {
          var objValue = object[key];

          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
            object[key] = value;
          }
        }
        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */


        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }

          var result = [];

          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */


        function baseRest(func, start) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);

            while (++index < length) {
              array[index] = args[start + index];
            }

            index = -1;
            var otherArgs = Array(start + 1);

            while (++index < start) {
              otherArgs[index] = args[index];
            }

            otherArgs[start] = array;
            return apply(func, this, otherArgs);
          };
        }
        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */


        function copyObject(source, props, object, customizer) {
          object || (object = {});
          var index = -1,
              length = props.length;

          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
            assignValue(object, key, newValue === undefined ? source[key] : newValue);
          }

          return object;
        }
        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */


        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
                length = sources.length,
                customizer = length > 1 ? sources[length - 1] : undefined,
                guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }

            object = Object(object);

            while (++index < length) {
              var source = sources[index];

              if (source) {
                assigner(object, source, index, customizer);
              }
            }

            return object;
          });
        }
        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */


        function isIndex(value, length) {
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */


        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }

          var type = _typeof2(index);

          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }

          return false;
        }
        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */


        function isPrototype(value) {
          var Ctor = value && value.constructor,
              proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */


        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */


        function isArguments(value) {
          // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
          return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
        }
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */


        var isArray = Array.isArray;
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */

        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */


        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */


        function isFunction(value) {
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 8-9 which returns 'object' for typed array and other constructors.
          var tag = isObject(value) ? objectToString.call(value) : '';
          return tag == funcTag || tag == genTag;
        }
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */


        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */


        function isObject(value) {
          var type = _typeof2(value);

          return !!value && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */


        function isObjectLike(value) {
          return !!value && _typeof2(value) == 'object';
        }
        /**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */


        var assign = createAssigner(function (object, source) {
          if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }

          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */

        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }

        module.exports = assign;
        /***/
      },

      /***/
      "44ad":
      /***/
      function ad(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039");

        var classof = __webpack_require__("c6b6");

        var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

        module.exports = fails(function () {
          // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
          // eslint-disable-next-line no-prototype-builtins
          return !Object('z').propertyIsEnumerable(0);
        }) ? function (it) {
          return classof(it) == 'String' ? split.call(it, '') : Object(it);
        } : Object;
        /***/
      },

      /***/
      "44d2":
      /***/
      function d2(module, exports, __webpack_require__) {
        var wellKnownSymbol = __webpack_require__("b622");

        var create = __webpack_require__("7c73");

        var definePropertyModule = __webpack_require__("9bf2");

        var UNSCOPABLES = wellKnownSymbol('unscopables');
        var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
        // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

        if (ArrayPrototype[UNSCOPABLES] == undefined) {
          definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null)
          });
        } // add a key to Array.prototype[@@unscopables]


        module.exports = function (key) {
          ArrayPrototype[UNSCOPABLES][key] = true;
        };
        /***/

      },

      /***/
      "44e7":
      /***/
      function e7(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d");

        var classof = __webpack_require__("c6b6");

        var wellKnownSymbol = __webpack_require__("b622");

        var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
        // https://tc39.github.io/ecma262/#sec-isregexp

        module.exports = function (it) {
          var isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
        };
        /***/

      },

      /***/
      "466d":
      /***/
      function d(module, exports, __webpack_require__) {
        "use strict";

        var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");

        var anObject = __webpack_require__("825a");

        var toLength = __webpack_require__("50c4");

        var requireObjectCoercible = __webpack_require__("1d80");

        var advanceStringIndex = __webpack_require__("8aa5");

        var regExpExec = __webpack_require__("14c3"); // @@match logic


        fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
          return [// `String.prototype.match` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.match
          function match(regexp) {
            var O = requireObjectCoercible(this);
            var matcher = regexp == undefined ? undefined : regexp[MATCH];
            return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
          }, // `RegExp.prototype[@@match]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
          function (regexp) {
            var res = maybeCallNative(nativeMatch, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;

            while ((result = regExpExec(rx, S)) !== null) {
              var matchStr = String(result[0]);
              A[n] = matchStr;
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              n++;
            }

            return n === 0 ? null : A;
          }];
        });
        /***/
      },

      /***/
      "4840":
      /***/
      function _(module, exports, __webpack_require__) {
        var anObject = __webpack_require__("825a");

        var aFunction = __webpack_require__("1c0b");

        var wellKnownSymbol = __webpack_require__("b622");

        var SPECIES = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
        // https://tc39.github.io/ecma262/#sec-speciesconstructor

        module.exports = function (O, defaultConstructor) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
        };
        /***/

      },

      /***/
      "4930":
      /***/
      function _(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039");

        module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
          // Chrome 38 Symbol has incorrect toString conversion
          // eslint-disable-next-line no-undef
          return !String(Symbol());
        });
        /***/
      },

      /***/
      "4d64":
      /***/
      function d64(module, exports, __webpack_require__) {
        var toIndexedObject = __webpack_require__("fc6a");

        var toLength = __webpack_require__("50c4");

        var toAbsoluteIndex = __webpack_require__("23cb"); // `Array.prototype.{ indexOf, includes }` methods implementation


        var createMethod = function createMethod(IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
          };
        };

        module.exports = {
          // `Array.prototype.includes` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.includes
          includes: createMethod(true),
          // `Array.prototype.indexOf` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
          indexOf: createMethod(false)
        };
        /***/
      },

      /***/
      "4de4":
      /***/
      function de4(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var $filter = __webpack_require__("b727").filter;

        var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter'); // Edge 14- issue

        var USES_TO_LENGTH = arrayMethodUsesToLength('filter'); // `Array.prototype.filter` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.filter
        // with adding support of @@species

        $({
          target: 'Array',
          proto: true,
          forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
        }, {
          filter: function filter(callbackfn
          /* , thisArg */
          ) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "4df4":
      /***/
      function df4(module, exports, __webpack_require__) {
        "use strict";

        var bind = __webpack_require__("0366");

        var toObject = __webpack_require__("7b0b");

        var callWithSafeIterationClosing = __webpack_require__("9bdd");

        var isArrayIteratorMethod = __webpack_require__("e95a");

        var toLength = __webpack_require__("50c4");

        var createProperty = __webpack_require__("8418");

        var getIteratorMethod = __webpack_require__("35a1"); // `Array.from` method implementation
        // https://tc39.github.io/ecma262/#sec-array.from


        module.exports = function from(arrayLike
        /* , mapfn = undefined, thisArg = undefined */
        ) {
          var O = toObject(arrayLike);
          var C = typeof this == 'function' ? this : Array;
          var argumentsLength = arguments.length;
          var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iteratorMethod = getIteratorMethod(O);
          var index = 0;
          var length, result, step, iterator, next, value;
          if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2); // if the target is not iterable or it's an array with the default iterator - use a simple case

          if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
            iterator = iteratorMethod.call(O);
            next = iterator.next;
            result = new C();

            for (; !(step = next.call(iterator)).done; index++) {
              value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
              createProperty(result, index, value);
            }
          } else {
            length = toLength(O.length);
            result = new C(length);

            for (; length > index; index++) {
              value = mapping ? mapfn(O[index], index) : O[index];
              createProperty(result, index, value);
            }
          }

          result.length = index;
          return result;
        };
        /***/

      },

      /***/
      "50c4":
      /***/
      function c4(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__("a691");

        var min = Math.min; // `ToLength` abstract operation
        // https://tc39.github.io/ecma262/#sec-tolength

        module.exports = function (argument) {
          return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "5135":
      /***/
      function _(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "5692":
      /***/
      function _(module, exports, __webpack_require__) {
        var IS_PURE = __webpack_require__("c430");

        var store = __webpack_require__("c6cd");

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: '3.6.4',
          mode: IS_PURE ? 'pure' : 'global',
          copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "56ef":
      /***/
      function ef(module, exports, __webpack_require__) {
        var getBuiltIn = __webpack_require__("d066");

        var getOwnPropertyNamesModule = __webpack_require__("241c");

        var getOwnPropertySymbolsModule = __webpack_require__("7418");

        var anObject = __webpack_require__("825a"); // all object keys, includes non-enumerable and symbols


        module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
          var keys = getOwnPropertyNamesModule.f(anObject(it));
          var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
          return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
        };
        /***/

      },

      /***/
      "5899":
      /***/
      function _(module, exports) {
        // a string of all valid unicode whitespaces
        // eslint-disable-next-line max-len
        module.exports = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        /***/
      },

      /***/
      "58a8":
      /***/
      function a8(module, exports, __webpack_require__) {
        var requireObjectCoercible = __webpack_require__("1d80");

        var whitespaces = __webpack_require__("5899");

        var whitespace = '[' + whitespaces + ']';
        var ltrim = RegExp('^' + whitespace + whitespace + '*');
        var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

        var createMethod = function createMethod(TYPE) {
          return function ($this) {
            var string = String(requireObjectCoercible($this));
            if (TYPE & 1) string = string.replace(ltrim, '');
            if (TYPE & 2) string = string.replace(rtrim, '');
            return string;
          };
        };

        module.exports = {
          // `String.prototype.{ trimLeft, trimStart }` methods
          // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
          start: createMethod(1),
          // `String.prototype.{ trimRight, trimEnd }` methods
          // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
          end: createMethod(2),
          // `String.prototype.trim` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.trim
          trim: createMethod(3)
        };
        /***/
      },

      /***/
      "5c6c":
      /***/
      function c6c(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "60da":
      /***/
      function da(module, exports, __webpack_require__) {
        "use strict";

        var DESCRIPTORS = __webpack_require__("83ab");

        var fails = __webpack_require__("d039");

        var objectKeys = __webpack_require__("df75");

        var getOwnPropertySymbolsModule = __webpack_require__("7418");

        var propertyIsEnumerableModule = __webpack_require__("d1e7");

        var toObject = __webpack_require__("7b0b");

        var IndexedObject = __webpack_require__("44ad");

        var nativeAssign = Object.assign;
        var defineProperty = Object.defineProperty; // `Object.assign` method
        // https://tc39.github.io/ecma262/#sec-object.assign

        module.exports = !nativeAssign || fails(function () {
          // should have correct order of operations (Edge bug)
          if (DESCRIPTORS && nativeAssign({
            b: 1
          }, nativeAssign(defineProperty({}, 'a', {
            enumerable: true,
            get: function get() {
              defineProperty(this, 'b', {
                value: 3,
                enumerable: false
              });
            }
          }), {
            b: 2
          })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

          var A = {};
          var B = {}; // eslint-disable-next-line no-undef

          var symbol = Symbol();
          var alphabet = 'abcdefghijklmnopqrst';
          A[symbol] = 7;
          alphabet.split('').forEach(function (chr) {
            B[chr] = chr;
          });
          return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
        }) ? function assign(target, source) {
          // eslint-disable-line no-unused-vars
          var T = toObject(target);
          var argumentsLength = arguments.length;
          var index = 1;
          var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
          var propertyIsEnumerable = propertyIsEnumerableModule.f;

          while (argumentsLength > index) {
            var S = IndexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
              key = keys[j++];
              if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
            }
          }

          return T;
        } : nativeAssign;
        /***/
      },

      /***/
      "6547":
      /***/
      function _(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__("a691");

        var requireObjectCoercible = __webpack_require__("1d80"); // `String.prototype.{ codePointAt, at }` methods implementation


        var createMethod = function createMethod(CONVERT_TO_STRING) {
          return function ($this, pos) {
            var S = String(requireObjectCoercible($this));
            var position = toInteger(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = S.charCodeAt(position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
          };
        };

        module.exports = {
          // `String.prototype.codePointAt` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
          codeAt: createMethod(false),
          // `String.prototype.at` method
          // https://github.com/mathiasbynens/String.prototype.at
          charAt: createMethod(true)
        };
        /***/
      },

      /***/
      "65f0":
      /***/
      function f0(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d");

        var isArray = __webpack_require__("e8b5");

        var wellKnownSymbol = __webpack_require__("b622");

        var SPECIES = wellKnownSymbol('species'); // `ArraySpeciesCreate` abstract operation
        // https://tc39.github.io/ecma262/#sec-arrayspeciescreate

        module.exports = function (originalArray, length) {
          var C;

          if (isArray(originalArray)) {
            C = originalArray.constructor; // cross-realm fallback

            if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
              C = C[SPECIES];
              if (C === null) C = undefined;
            }
          }

          return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
        };
        /***/

      },

      /***/
      "69f3":
      /***/
      function f3(module, exports, __webpack_require__) {
        var NATIVE_WEAK_MAP = __webpack_require__("7f9a");

        var global = __webpack_require__("da84");

        var isObject = __webpack_require__("861d");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var objectHas = __webpack_require__("5135");

        var sharedKey = __webpack_require__("f772");

        var hiddenKeys = __webpack_require__("d012");

        var WeakMap = global.WeakMap;
        var set, get, has;

        var enforce = function enforce(it) {
          return has(it) ? get(it) : set(it, {});
        };

        var getterFor = function getterFor(TYPE) {
          return function (it) {
            var state;

            if (!isObject(it) || (state = get(it)).type !== TYPE) {
              throw TypeError('Incompatible receiver, ' + TYPE + ' required');
            }

            return state;
          };
        };

        if (NATIVE_WEAK_MAP) {
          var store = new WeakMap();
          var wmget = store.get;
          var wmhas = store.has;
          var wmset = store.set;

          set = function set(it, metadata) {
            wmset.call(store, it, metadata);
            return metadata;
          };

          get = function get(it) {
            return wmget.call(store, it) || {};
          };

          has = function has(it) {
            return wmhas.call(store, it);
          };
        } else {
          var STATE = sharedKey('state');
          hiddenKeys[STATE] = true;

          set = function set(it, metadata) {
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
          };

          get = function get(it) {
            return objectHas(it, STATE) ? it[STATE] : {};
          };

          has = function has(it) {
            return objectHas(it, STATE);
          };
        }

        module.exports = {
          set: set,
          get: get,
          has: has,
          enforce: enforce,
          getterFor: getterFor
        };
        /***/
      },

      /***/
      "6dd8":
      /***/
      function dd8(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          /**
          * A collection of shims that provide minimal functionality of the ES6 collections.
          *
          * These implementations are not meant to be used outside of the ResizeObserver
          * modules as they cover only a limited range of use cases.
          */

          /* eslint-disable require-jsdoc, valid-jsdoc */
          var MapShim = function () {
            if (typeof Map !== 'undefined') {
              return Map;
            }
            /**
             * Returns index in provided array that matches the specified key.
             *
             * @param {Array<Array>} arr
             * @param {*} key
             * @returns {number}
             */


            function getIndex(arr, key) {
              var result = -1;
              arr.some(function (entry, index) {
                if (entry[0] === key) {
                  result = index;
                  return true;
                }

                return false;
              });
              return result;
            }

            return (
              /** @class */
              function () {
                function class_1() {
                  this.__entries__ = [];
                }

                Object.defineProperty(class_1.prototype, "size", {
                  /**
                   * @returns {boolean}
                   */
                  get: function get() {
                    return this.__entries__.length;
                  },
                  enumerable: true,
                  configurable: true
                });
                /**
                 * @param {*} key
                 * @returns {*}
                 */

                class_1.prototype.get = function (key) {
                  var index = getIndex(this.__entries__, key);
                  var entry = this.__entries__[index];
                  return entry && entry[1];
                };
                /**
                 * @param {*} key
                 * @param {*} value
                 * @returns {void}
                 */


                class_1.prototype.set = function (key, value) {
                  var index = getIndex(this.__entries__, key);

                  if (~index) {
                    this.__entries__[index][1] = value;
                  } else {
                    this.__entries__.push([key, value]);
                  }
                };
                /**
                 * @param {*} key
                 * @returns {void}
                 */


                class_1.prototype["delete"] = function (key) {
                  var entries = this.__entries__;
                  var index = getIndex(entries, key);

                  if (~index) {
                    entries.splice(index, 1);
                  }
                };
                /**
                 * @param {*} key
                 * @returns {void}
                 */


                class_1.prototype.has = function (key) {
                  return !!~getIndex(this.__entries__, key);
                };
                /**
                 * @returns {void}
                 */


                class_1.prototype.clear = function () {
                  this.__entries__.splice(0);
                };
                /**
                 * @param {Function} callback
                 * @param {*} [ctx=null]
                 * @returns {void}
                 */


                class_1.prototype.forEach = function (callback, ctx) {
                  if (ctx === void 0) {
                    ctx = null;
                  }

                  for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                  }
                };

                return class_1;
              }()
            );
          }();
          /**
           * Detects whether window and document objects are available in current environment.
           */


          var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

          var global$1 = function () {
            if (typeof global !== 'undefined' && global.Math === Math) {
              return global;
            }

            if (typeof self !== 'undefined' && self.Math === Math) {
              return self;
            }

            if (typeof window !== 'undefined' && window.Math === Math) {
              return window;
            } // eslint-disable-next-line no-new-func


            return Function('return this')();
          }();
          /**
           * A shim for the requestAnimationFrame which falls back to the setTimeout if
           * first one is not supported.
           *
           * @returns {number} Requests' identifier.
           */


          var requestAnimationFrame$1 = function () {
            if (typeof requestAnimationFrame === 'function') {
              // It's required to use a bounded function because IE sometimes throws
              // an "Invalid calling object" error if rAF is invoked without the global
              // object on the left hand side.
              return requestAnimationFrame.bind(global$1);
            }

            return function (callback) {
              return setTimeout(function () {
                return callback(Date.now());
              }, 1000 / 60);
            };
          }(); // Defines minimum timeout before adding a trailing call.


          var trailingTimeout = 2;
          /**
           * Creates a wrapper function which ensures that provided callback will be
           * invoked only once during the specified delay period.
           *
           * @param {Function} callback - Function to be invoked after the delay period.
           * @param {number} delay - Delay after which to invoke callback.
           * @returns {Function}
           */

          function throttle(callback, delay) {
            var leadingCall = false,
                trailingCall = false,
                lastCallTime = 0;
            /**
             * Invokes the original callback function and schedules new invocation if
             * the "proxy" was called during current request.
             *
             * @returns {void}
             */

            function resolvePending() {
              if (leadingCall) {
                leadingCall = false;
                callback();
              }

              if (trailingCall) {
                proxy();
              }
            }
            /**
             * Callback invoked after the specified delay. It will further postpone
             * invocation of the original function delegating it to the
             * requestAnimationFrame.
             *
             * @returns {void}
             */


            function timeoutCallback() {
              requestAnimationFrame$1(resolvePending);
            }
            /**
             * Schedules invocation of the original function.
             *
             * @returns {void}
             */


            function proxy() {
              var timeStamp = Date.now();

              if (leadingCall) {
                // Reject immediately following calls.
                if (timeStamp - lastCallTime < trailingTimeout) {
                  return;
                } // Schedule new call to be in invoked when the pending one is resolved.
                // This is important for "transitions" which never actually start
                // immediately so there is a chance that we might miss one if change
                // happens amids the pending invocation.


                trailingCall = true;
              } else {
                leadingCall = true;
                trailingCall = false;
                setTimeout(timeoutCallback, delay);
              }

              lastCallTime = timeStamp;
            }

            return proxy;
          } // Minimum delay before invoking the update of observers.


          var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
          // might affect dimensions of observed elements.

          var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

          var mutationObserverSupported = typeof MutationObserver !== 'undefined';
          /**
           * Singleton controller class which handles updates of ResizeObserver instances.
           */

          var ResizeObserverController =
          /** @class */
          function () {
            /**
             * Creates a new instance of ResizeObserverController.
             *
             * @private
             */
            function ResizeObserverController() {
              /**
               * Indicates whether DOM listeners have been added.
               *
               * @private {boolean}
               */
              this.connected_ = false;
              /**
               * Tells that controller has subscribed for Mutation Events.
               *
               * @private {boolean}
               */

              this.mutationEventsAdded_ = false;
              /**
               * Keeps reference to the instance of MutationObserver.
               *
               * @private {MutationObserver}
               */

              this.mutationsObserver_ = null;
              /**
               * A list of connected observers.
               *
               * @private {Array<ResizeObserverSPI>}
               */

              this.observers_ = [];
              this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
              this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
            }
            /**
             * Adds observer to observers list.
             *
             * @param {ResizeObserverSPI} observer - Observer to be added.
             * @returns {void}
             */


            ResizeObserverController.prototype.addObserver = function (observer) {
              if (!~this.observers_.indexOf(observer)) {
                this.observers_.push(observer);
              } // Add listeners if they haven't been added yet.


              if (!this.connected_) {
                this.connect_();
              }
            };
            /**
             * Removes observer from observers list.
             *
             * @param {ResizeObserverSPI} observer - Observer to be removed.
             * @returns {void}
             */


            ResizeObserverController.prototype.removeObserver = function (observer) {
              var observers = this.observers_;
              var index = observers.indexOf(observer); // Remove observer if it's present in registry.

              if (~index) {
                observers.splice(index, 1);
              } // Remove listeners if controller has no connected observers.


              if (!observers.length && this.connected_) {
                this.disconnect_();
              }
            };
            /**
             * Invokes the update of observers. It will continue running updates insofar
             * it detects changes.
             *
             * @returns {void}
             */


            ResizeObserverController.prototype.refresh = function () {
              var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
              // be future ones caused by CSS transitions.

              if (changesDetected) {
                this.refresh();
              }
            };
            /**
             * Updates every observer from observers list and notifies them of queued
             * entries.
             *
             * @private
             * @returns {boolean} Returns "true" if any observer has detected changes in
             *      dimensions of it's elements.
             */


            ResizeObserverController.prototype.updateObservers_ = function () {
              // Collect observers that have active observations.
              var activeObservers = this.observers_.filter(function (observer) {
                return observer.gatherActive(), observer.hasActive();
              }); // Deliver notifications in a separate cycle in order to avoid any
              // collisions between observers, e.g. when multiple instances of
              // ResizeObserver are tracking the same element and the callback of one
              // of them changes content dimensions of the observed target. Sometimes
              // this may result in notifications being blocked for the rest of observers.

              activeObservers.forEach(function (observer) {
                return observer.broadcastActive();
              });
              return activeObservers.length > 0;
            };
            /**
             * Initializes DOM listeners.
             *
             * @private
             * @returns {void}
             */


            ResizeObserverController.prototype.connect_ = function () {
              // Do nothing if running in a non-browser environment or if listeners
              // have been already added.
              if (!isBrowser || this.connected_) {
                return;
              } // Subscription to the "Transitionend" event is used as a workaround for
              // delayed transitions. This way it's possible to capture at least the
              // final state of an element.


              document.addEventListener('transitionend', this.onTransitionEnd_);
              window.addEventListener('resize', this.refresh);

              if (mutationObserverSupported) {
                this.mutationsObserver_ = new MutationObserver(this.refresh);
                this.mutationsObserver_.observe(document, {
                  attributes: true,
                  childList: true,
                  characterData: true,
                  subtree: true
                });
              } else {
                document.addEventListener('DOMSubtreeModified', this.refresh);
                this.mutationEventsAdded_ = true;
              }

              this.connected_ = true;
            };
            /**
             * Removes DOM listeners.
             *
             * @private
             * @returns {void}
             */


            ResizeObserverController.prototype.disconnect_ = function () {
              // Do nothing if running in a non-browser environment or if listeners
              // have been already removed.
              if (!isBrowser || !this.connected_) {
                return;
              }

              document.removeEventListener('transitionend', this.onTransitionEnd_);
              window.removeEventListener('resize', this.refresh);

              if (this.mutationsObserver_) {
                this.mutationsObserver_.disconnect();
              }

              if (this.mutationEventsAdded_) {
                document.removeEventListener('DOMSubtreeModified', this.refresh);
              }

              this.mutationsObserver_ = null;
              this.mutationEventsAdded_ = false;
              this.connected_ = false;
            };
            /**
             * "Transitionend" event handler.
             *
             * @private
             * @param {TransitionEvent} event
             * @returns {void}
             */


            ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
              var _b = _a.propertyName,
                  propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

              var isReflowProperty = transitionKeys.some(function (key) {
                return !!~propertyName.indexOf(key);
              });

              if (isReflowProperty) {
                this.refresh();
              }
            };
            /**
             * Returns instance of the ResizeObserverController.
             *
             * @returns {ResizeObserverController}
             */


            ResizeObserverController.getInstance = function () {
              if (!this.instance_) {
                this.instance_ = new ResizeObserverController();
              }

              return this.instance_;
            };
            /**
             * Holds reference to the controller's instance.
             *
             * @private {ResizeObserverController}
             */


            ResizeObserverController.instance_ = null;
            return ResizeObserverController;
          }();
          /**
           * Defines non-writable/enumerable properties of the provided target object.
           *
           * @param {Object} target - Object for which to define properties.
           * @param {Object} props - Properties to be defined.
           * @returns {Object} Target object.
           */


          var defineConfigurable = function defineConfigurable(target, props) {
            for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
              var key = _a[_i];
              Object.defineProperty(target, key, {
                value: props[key],
                enumerable: false,
                writable: false,
                configurable: true
              });
            }

            return target;
          };
          /**
           * Returns the global object associated with provided element.
           *
           * @param {Object} target
           * @returns {Object}
           */


          var getWindowOf = function getWindowOf(target) {
            // Assume that the element is an instance of Node, which means that it
            // has the "ownerDocument" property from which we can retrieve a
            // corresponding global object.
            var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
            // provided element.

            return ownerGlobal || global$1;
          }; // Placeholder of an empty content rectangle.


          var emptyRect = createRectInit(0, 0, 0, 0);
          /**
           * Converts provided string to a number.
           *
           * @param {number|string} value
           * @returns {number}
           */

          function toFloat(value) {
            return parseFloat(value) || 0;
          }
          /**
           * Extracts borders size from provided styles.
           *
           * @param {CSSStyleDeclaration} styles
           * @param {...string} positions - Borders positions (top, right, ...)
           * @returns {number}
           */


          function getBordersSize(styles) {
            var positions = [];

            for (var _i = 1; _i < arguments.length; _i++) {
              positions[_i - 1] = arguments[_i];
            }

            return positions.reduce(function (size, position) {
              var value = styles['border-' + position + '-width'];
              return size + toFloat(value);
            }, 0);
          }
          /**
           * Extracts paddings sizes from provided styles.
           *
           * @param {CSSStyleDeclaration} styles
           * @returns {Object} Paddings box.
           */


          function getPaddings(styles) {
            var positions = ['top', 'right', 'bottom', 'left'];
            var paddings = {};

            for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
              var position = positions_1[_i];
              var value = styles['padding-' + position];
              paddings[position] = toFloat(value);
            }

            return paddings;
          }
          /**
           * Calculates content rectangle of provided SVG element.
           *
           * @param {SVGGraphicsElement} target - Element content rectangle of which needs
           *      to be calculated.
           * @returns {DOMRectInit}
           */


          function getSVGContentRect(target) {
            var bbox = target.getBBox();
            return createRectInit(0, 0, bbox.width, bbox.height);
          }
          /**
           * Calculates content rectangle of provided HTMLElement.
           *
           * @param {HTMLElement} target - Element for which to calculate the content rectangle.
           * @returns {DOMRectInit}
           */


          function getHTMLElementContentRect(target) {
            // Client width & height properties can't be
            // used exclusively as they provide rounded values.
            var clientWidth = target.clientWidth,
                clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
            // detached elements. Though elements with width & height properties less
            // than 0.5 will be discarded as well.
            //
            // Without it we would need to implement separate methods for each of
            // those cases and it's not possible to perform a precise and performance
            // effective test for hidden elements. E.g. even jQuery's ':visible' filter
            // gives wrong results for elements with width & height less than 0.5.

            if (!clientWidth && !clientHeight) {
              return emptyRect;
            }

            var styles = getWindowOf(target).getComputedStyle(target);
            var paddings = getPaddings(styles);
            var horizPad = paddings.left + paddings.right;
            var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
            // only dimensions available to JS that contain non-rounded values. It could
            // be possible to utilize the getBoundingClientRect if only it's data wasn't
            // affected by CSS transformations let alone paddings, borders and scroll bars.

            var width = toFloat(styles.width),
                height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
            // model is applied (except for IE).

            if (styles.boxSizing === 'border-box') {
              // Following conditions are required to handle Internet Explorer which
              // doesn't include paddings and borders to computed CSS dimensions.
              //
              // We can say that if CSS dimensions + paddings are equal to the "client"
              // properties then it's either IE, and thus we don't need to subtract
              // anything, or an element merely doesn't have paddings/borders styles.
              if (Math.round(width + horizPad) !== clientWidth) {
                width -= getBordersSize(styles, 'left', 'right') + horizPad;
              }

              if (Math.round(height + vertPad) !== clientHeight) {
                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
              }
            } // Following steps can't be applied to the document's root element as its
            // client[Width/Height] properties represent viewport area of the window.
            // Besides, it's as well not necessary as the <html> itself neither has
            // rendered scroll bars nor it can be clipped.


            if (!isDocumentElement(target)) {
              // In some browsers (only in Firefox, actually) CSS width & height
              // include scroll bars size which can be removed at this step as scroll
              // bars are the only difference between rounded dimensions + paddings
              // and "client" properties, though that is not always true in Chrome.
              var vertScrollbar = Math.round(width + horizPad) - clientWidth;
              var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
              // E.g. for an element with content width of 314.2px it sometimes gives
              // the client width of 315px and for the width of 314.7px it may give
              // 314px. And it doesn't happen all the time. So just ignore this delta
              // as a non-relevant.

              if (Math.abs(vertScrollbar) !== 1) {
                width -= vertScrollbar;
              }

              if (Math.abs(horizScrollbar) !== 1) {
                height -= horizScrollbar;
              }
            }

            return createRectInit(paddings.left, paddings.top, width, height);
          }
          /**
           * Checks whether provided element is an instance of the SVGGraphicsElement.
           *
           * @param {Element} target - Element to be checked.
           * @returns {boolean}
           */


          var isSVGGraphicsElement = function () {
            // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
            // interface.
            if (typeof SVGGraphicsElement !== 'undefined') {
              return function (target) {
                return target instanceof getWindowOf(target).SVGGraphicsElement;
              };
            } // If it's so, then check that element is at least an instance of the
            // SVGElement and that it has the "getBBox" method.
            // eslint-disable-next-line no-extra-parens


            return function (target) {
              return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
            };
          }();
          /**
           * Checks whether provided element is a document element (<html>).
           *
           * @param {Element} target - Element to be checked.
           * @returns {boolean}
           */


          function isDocumentElement(target) {
            return target === getWindowOf(target).document.documentElement;
          }
          /**
           * Calculates an appropriate content rectangle for provided html or svg element.
           *
           * @param {Element} target - Element content rectangle of which needs to be calculated.
           * @returns {DOMRectInit}
           */


          function getContentRect(target) {
            if (!isBrowser) {
              return emptyRect;
            }

            if (isSVGGraphicsElement(target)) {
              return getSVGContentRect(target);
            }

            return getHTMLElementContentRect(target);
          }
          /**
           * Creates rectangle with an interface of the DOMRectReadOnly.
           * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
           *
           * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
           * @returns {DOMRectReadOnly}
           */


          function createReadOnlyRect(_a) {
            var x = _a.x,
                y = _a.y,
                width = _a.width,
                height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

            var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
            var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

            defineConfigurable(rect, {
              x: x,
              y: y,
              width: width,
              height: height,
              top: y,
              right: x + width,
              bottom: height + y,
              left: x
            });
            return rect;
          }
          /**
           * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
           * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
           *
           * @param {number} x - X coordinate.
           * @param {number} y - Y coordinate.
           * @param {number} width - Rectangle's width.
           * @param {number} height - Rectangle's height.
           * @returns {DOMRectInit}
           */


          function createRectInit(x, y, width, height) {
            return {
              x: x,
              y: y,
              width: width,
              height: height
            };
          }
          /**
           * Class that is responsible for computations of the content rectangle of
           * provided DOM element and for keeping track of it's changes.
           */


          var ResizeObservation =
          /** @class */
          function () {
            /**
             * Creates an instance of ResizeObservation.
             *
             * @param {Element} target - Element to be observed.
             */
            function ResizeObservation(target) {
              /**
               * Broadcasted width of content rectangle.
               *
               * @type {number}
               */
              this.broadcastWidth = 0;
              /**
               * Broadcasted height of content rectangle.
               *
               * @type {number}
               */

              this.broadcastHeight = 0;
              /**
               * Reference to the last observed content rectangle.
               *
               * @private {DOMRectInit}
               */

              this.contentRect_ = createRectInit(0, 0, 0, 0);
              this.target = target;
            }
            /**
             * Updates content rectangle and tells whether it's width or height properties
             * have changed since the last broadcast.
             *
             * @returns {boolean}
             */


            ResizeObservation.prototype.isActive = function () {
              var rect = getContentRect(this.target);
              this.contentRect_ = rect;
              return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
            };
            /**
             * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
             * from the corresponding properties of the last observed content rectangle.
             *
             * @returns {DOMRectInit} Last observed content rectangle.
             */


            ResizeObservation.prototype.broadcastRect = function () {
              var rect = this.contentRect_;
              this.broadcastWidth = rect.width;
              this.broadcastHeight = rect.height;
              return rect;
            };

            return ResizeObservation;
          }();

          var ResizeObserverEntry =
          /** @class */
          function () {
            /**
             * Creates an instance of ResizeObserverEntry.
             *
             * @param {Element} target - Element that is being observed.
             * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
             */
            function ResizeObserverEntry(target, rectInit) {
              var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
              // and are also not enumerable in the native implementation.
              //
              // Property accessors are not being used as they'd require to define a
              // private WeakMap storage which may cause memory leaks in browsers that
              // don't support this type of collections.

              defineConfigurable(this, {
                target: target,
                contentRect: contentRect
              });
            }

            return ResizeObserverEntry;
          }();

          var ResizeObserverSPI =
          /** @class */
          function () {
            /**
             * Creates a new instance of ResizeObserver.
             *
             * @param {ResizeObserverCallback} callback - Callback function that is invoked
             *      when one of the observed elements changes it's content dimensions.
             * @param {ResizeObserverController} controller - Controller instance which
             *      is responsible for the updates of observer.
             * @param {ResizeObserver} callbackCtx - Reference to the public
             *      ResizeObserver instance which will be passed to callback function.
             */
            function ResizeObserverSPI(callback, controller, callbackCtx) {
              /**
               * Collection of resize observations that have detected changes in dimensions
               * of elements.
               *
               * @private {Array<ResizeObservation>}
               */
              this.activeObservations_ = [];
              /**
               * Registry of the ResizeObservation instances.
               *
               * @private {Map<Element, ResizeObservation>}
               */

              this.observations_ = new MapShim();

              if (typeof callback !== 'function') {
                throw new TypeError('The callback provided as parameter 1 is not a function.');
              }

              this.callback_ = callback;
              this.controller_ = controller;
              this.callbackCtx_ = callbackCtx;
            }
            /**
             * Starts observing provided element.
             *
             * @param {Element} target - Element to be observed.
             * @returns {void}
             */


            ResizeObserverSPI.prototype.observe = function (target) {
              if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
              } // Do nothing if current environment doesn't have the Element interface.


              if (typeof Element === 'undefined' || !(Element instanceof Object)) {
                return;
              }

              if (!(target instanceof getWindowOf(target).Element)) {
                throw new TypeError('parameter 1 is not of type "Element".');
              }

              var observations = this.observations_; // Do nothing if element is already being observed.

              if (observations.has(target)) {
                return;
              }

              observations.set(target, new ResizeObservation(target));
              this.controller_.addObserver(this); // Force the update of observations.

              this.controller_.refresh();
            };
            /**
             * Stops observing provided element.
             *
             * @param {Element} target - Element to stop observing.
             * @returns {void}
             */


            ResizeObserverSPI.prototype.unobserve = function (target) {
              if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
              } // Do nothing if current environment doesn't have the Element interface.


              if (typeof Element === 'undefined' || !(Element instanceof Object)) {
                return;
              }

              if (!(target instanceof getWindowOf(target).Element)) {
                throw new TypeError('parameter 1 is not of type "Element".');
              }

              var observations = this.observations_; // Do nothing if element is not being observed.

              if (!observations.has(target)) {
                return;
              }

              observations["delete"](target);

              if (!observations.size) {
                this.controller_.removeObserver(this);
              }
            };
            /**
             * Stops observing all elements.
             *
             * @returns {void}
             */


            ResizeObserverSPI.prototype.disconnect = function () {
              this.clearActive();
              this.observations_.clear();
              this.controller_.removeObserver(this);
            };
            /**
             * Collects observation instances the associated element of which has changed
             * it's content rectangle.
             *
             * @returns {void}
             */


            ResizeObserverSPI.prototype.gatherActive = function () {
              var _this = this;

              this.clearActive();
              this.observations_.forEach(function (observation) {
                if (observation.isActive()) {
                  _this.activeObservations_.push(observation);
                }
              });
            };
            /**
             * Invokes initial callback function with a list of ResizeObserverEntry
             * instances collected from active resize observations.
             *
             * @returns {void}
             */


            ResizeObserverSPI.prototype.broadcastActive = function () {
              // Do nothing if observer doesn't have active observations.
              if (!this.hasActive()) {
                return;
              }

              var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

              var entries = this.activeObservations_.map(function (observation) {
                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
              });
              this.callback_.call(ctx, entries, ctx);
              this.clearActive();
            };
            /**
             * Clears the collection of active observations.
             *
             * @returns {void}
             */


            ResizeObserverSPI.prototype.clearActive = function () {
              this.activeObservations_.splice(0);
            };
            /**
             * Tells whether observer has active observations.
             *
             * @returns {boolean}
             */


            ResizeObserverSPI.prototype.hasActive = function () {
              return this.activeObservations_.length > 0;
            };

            return ResizeObserverSPI;
          }(); // Registry of internal observers. If WeakMap is not available use current shim
          // for the Map collection as it has all required methods and because WeakMap
          // can't be fully polyfilled anyway.


          var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
          /**
           * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
           * exposing only those methods and properties that are defined in the spec.
           */

          var ResizeObserver =
          /** @class */
          function () {
            /**
             * Creates a new instance of ResizeObserver.
             *
             * @param {ResizeObserverCallback} callback - Callback that is invoked when
             *      dimensions of the observed elements change.
             */
            function ResizeObserver(callback) {
              if (!(this instanceof ResizeObserver)) {
                throw new TypeError('Cannot call a class as a function.');
              }

              if (!arguments.length) {
                throw new TypeError('1 argument required, but only 0 present.');
              }

              var controller = ResizeObserverController.getInstance();
              var observer = new ResizeObserverSPI(callback, controller, this);
              observers.set(this, observer);
            }

            return ResizeObserver;
          }(); // Expose public methods of ResizeObserver.


          ['observe', 'unobserve', 'disconnect'].forEach(function (method) {
            ResizeObserver.prototype[method] = function () {
              var _a;

              return (_a = observers.get(this))[method].apply(_a, arguments);
            };
          });

          var index = function () {
            // Export existing implementation if available.
            if (typeof global$1.ResizeObserver !== 'undefined') {
              return global$1.ResizeObserver;
            }

            return ResizeObserver;
          }();
          /* harmony default export */


          __webpack_exports__["a"] = index;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));
        /***/
      },

      /***/
      "6ea2":
      /***/
      function ea2(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("890c");
        /* harmony import */


        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
        /* unused harmony reexport * */

        /* unused harmony default export */


        var _unused_webpack_default_export = _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a;
        /***/
      },

      /***/
      "6eeb":
      /***/
      function eeb(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var has = __webpack_require__("5135");

        var setGlobal = __webpack_require__("ce4e");

        var inspectSource = __webpack_require__("8925");

        var InternalStateModule = __webpack_require__("69f3");

        var getInternalState = InternalStateModule.get;
        var enforceInternalState = InternalStateModule.enforce;
        var TEMPLATE = String(String).split('String');
        (module.exports = function (O, key, value, options) {
          var unsafe = options ? !!options.unsafe : false;
          var simple = options ? !!options.enumerable : false;
          var noTargetGet = options ? !!options.noTargetGet : false;

          if (typeof value == 'function') {
            if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
            enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
          }

          if (O === global) {
            if (simple) O[key] = value;else setGlobal(key, value);
            return;
          } else if (!unsafe) {
            delete O[key];
          } else if (!noTargetGet && O[key]) {
            simple = true;
          }

          if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, 'toString', function toString() {
          return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
        });
        /***/
      },

      /***/
      "6f53":
      /***/
      function f53(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var objectKeys = __webpack_require__("df75");

        var toIndexedObject = __webpack_require__("fc6a");

        var propertyIsEnumerable = __webpack_require__("d1e7").f; // `Object.{ entries, values }` methods implementation


        var createMethod = function createMethod(TO_ENTRIES) {
          return function (it) {
            var O = toIndexedObject(it);
            var keys = objectKeys(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;

            while (length > i) {
              key = keys[i++];

              if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
                result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
              }
            }

            return result;
          };
        };

        module.exports = {
          // `Object.entries` method
          // https://tc39.github.io/ecma262/#sec-object.entries
          entries: createMethod(true),
          // `Object.values` method
          // https://tc39.github.io/ecma262/#sec-object.values
          values: createMethod(false)
        };
        /***/
      },

      /***/
      "7156":
      /***/
      function _(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d");

        var setPrototypeOf = __webpack_require__("d2bb"); // makes subclassing work correct for wrapped built-ins


        module.exports = function ($this, dummy, Wrapper) {
          var NewTarget, NewTargetPrototype;
          if ( // it can work only with native `setPrototypeOf`
          setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
          typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
          return $this;
        };
        /***/

      },

      /***/
      "7418":
      /***/
      function _(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "746f":
      /***/
      function f(module, exports, __webpack_require__) {
        var path = __webpack_require__("428f");

        var has = __webpack_require__("5135");

        var wrappedWellKnownSymbolModule = __webpack_require__("e538");

        var defineProperty = __webpack_require__("9bf2").f;

        module.exports = function (NAME) {
          var _Symbol = path.Symbol || (path.Symbol = {});

          if (!has(_Symbol, NAME)) defineProperty(_Symbol, NAME, {
            value: wrappedWellKnownSymbolModule.f(NAME)
          });
        };
        /***/

      },

      /***/
      "7839":
      /***/
      function _(module, exports) {
        // IE8- don't enum bug keys
        module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
        /***/
      },

      /***/
      "7b0b":
      /***/
      function b0b(module, exports, __webpack_require__) {
        var requireObjectCoercible = __webpack_require__("1d80"); // `ToObject` abstract operation
        // https://tc39.github.io/ecma262/#sec-toobject


        module.exports = function (argument) {
          return Object(requireObjectCoercible(argument));
        };
        /***/

      },

      /***/
      "7c73":
      /***/
      function c73(module, exports, __webpack_require__) {
        var anObject = __webpack_require__("825a");

        var defineProperties = __webpack_require__("37e8");

        var enumBugKeys = __webpack_require__("7839");

        var hiddenKeys = __webpack_require__("d012");

        var html = __webpack_require__("1be4");

        var documentCreateElement = __webpack_require__("cc12");

        var sharedKey = __webpack_require__("f772");

        var GT = '>';
        var LT = '<';
        var PROTOTYPE = 'prototype';
        var SCRIPT = 'script';
        var IE_PROTO = sharedKey('IE_PROTO');

        var EmptyConstructor = function EmptyConstructor() {
          /* empty */
        };

        var scriptTag = function scriptTag(content) {
          return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
        }; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


        var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
          activeXDocument.write(scriptTag(''));
          activeXDocument.close();
          var temp = activeXDocument.parentWindow.Object;
          activeXDocument = null; // avoid memory leak

          return temp;
        }; // Create object with fake `null` prototype: use iframe Object with cleared prototype


        var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = documentCreateElement('iframe');
          var JS = 'java' + SCRIPT + ':';
          var iframeDocument;
          iframe.style.display = 'none';
          html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

          iframe.src = String(JS);
          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(scriptTag('document.F=Object'));
          iframeDocument.close();
          return iframeDocument.F;
        }; // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug


        var activeXDocument;

        var _NullProtoObject = function NullProtoObject() {
          try {
            /* global ActiveXObject */
            activeXDocument = document.domain && new ActiveXObject('htmlfile');
          } catch (error) {
            /* ignore */
          }

          _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
          var length = enumBugKeys.length;

          while (length--) {
            delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
          }

          return _NullProtoObject();
        };

        hiddenKeys[IE_PROTO] = true; // `Object.create` method
        // https://tc39.github.io/ecma262/#sec-object.create

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            EmptyConstructor[PROTOTYPE] = anObject(O);
            result = new EmptyConstructor();
            EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _NullProtoObject();

          return Properties === undefined ? result : defineProperties(result, Properties);
        };
        /***/

      },

      /***/
      "7dd0":
      /***/
      function dd0(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var createIteratorConstructor = __webpack_require__("9ed3");

        var getPrototypeOf = __webpack_require__("e163");

        var setPrototypeOf = __webpack_require__("d2bb");

        var setToStringTag = __webpack_require__("d44e");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var redefine = __webpack_require__("6eeb");

        var wellKnownSymbol = __webpack_require__("b622");

        var IS_PURE = __webpack_require__("c430");

        var Iterators = __webpack_require__("3f8c");

        var IteratorsCore = __webpack_require__("ae93");

        var IteratorPrototype = IteratorsCore.IteratorPrototype;
        var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
        var ITERATOR = wellKnownSymbol('iterator');
        var KEYS = 'keys';
        var VALUES = 'values';
        var ENTRIES = 'entries';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
          createIteratorConstructor(IteratorConstructor, NAME, next);

          var getIterationMethod = function getIterationMethod(KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

            switch (KIND) {
              case KEYS:
                return function keys() {
                  return new IteratorConstructor(this, KIND);
                };

              case VALUES:
                return function values() {
                  return new IteratorConstructor(this, KIND);
                };

              case ENTRIES:
                return function entries() {
                  return new IteratorConstructor(this, KIND);
                };
            }

            return function () {
              return new IteratorConstructor(this);
            };
          };

          var TO_STRING_TAG = NAME + ' Iterator';
          var INCORRECT_VALUES_NAME = false;
          var IterablePrototype = Iterable.prototype;
          var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
          var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
          var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
          var CurrentIteratorPrototype, methods, KEY; // fix native

          if (anyNativeIterator) {
            CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));

            if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
              if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) {
                  setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
                  createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
                }
              } // Set @@toStringTag to native iterators


              setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
              if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;

            defaultIterator = function values() {
              return nativeIterator.call(this);
            };
          } // define iterator


          if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
            createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
          }

          Iterators[NAME] = defaultIterator; // export additional methods

          if (DEFAULT) {
            methods = {
              values: getIterationMethod(VALUES),
              keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
              entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) for (KEY in methods) {
              if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                redefine(IterablePrototype, KEY, methods[KEY]);
              }
            } else $({
              target: NAME,
              proto: true,
              forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "7f9a":
      /***/
      function f9a(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var inspectSource = __webpack_require__("8925");

        var WeakMap = global.WeakMap;
        module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));
        /***/
      },

      /***/
      "825a":
      /***/
      function a(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d");

        module.exports = function (it) {
          if (!isObject(it)) {
            throw TypeError(String(it) + ' is not an object');
          }

          return it;
        };
        /***/

      },

      /***/
      "83ab":
      /***/
      function ab(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039"); // Thank's IE8 for his funny defineProperty


        module.exports = !fails(function () {
          return Object.defineProperty({}, 1, {
            get: function get() {
              return 7;
            }
          })[1] != 7;
        });
        /***/
      },

      /***/
      "8418":
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var toPrimitive = __webpack_require__("c04e");

        var definePropertyModule = __webpack_require__("9bf2");

        var createPropertyDescriptor = __webpack_require__("5c6c");

        module.exports = function (object, key, value) {
          var propertyKey = toPrimitive(key);
          if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
        };
        /***/

      },

      /***/
      "861d":
      /***/
      function d(module, exports) {
        module.exports = function (it) {
          return _typeof2(it) === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "88bc":
      /***/
      function bc(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /**
          * lodash (Custom Build) <https://lodash.com/>
          * Build: `lodash modularize exports="npm" -o ./`
          * Copyright jQuery Foundation and other contributors <https://jquery.org/>
          * Released under MIT license <https://lodash.com/license>
          * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
          * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
          */

          /** Used as references for various `Number` constants. */
          var INFINITY = 1 / 0,
              MAX_SAFE_INTEGER = 9007199254740991;
          /** `Object#toString` result references. */

          var argsTag = '[object Arguments]',
              funcTag = '[object Function]',
              genTag = '[object GeneratorFunction]',
              symbolTag = '[object Symbol]';
          /** Detect free variable `global` from Node.js. */

          var freeGlobal = _typeof2(global) == 'object' && global && global.Object === Object && global;
          /** Detect free variable `self`. */

          var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof2(self)) == 'object' && self && self.Object === Object && self;
          /** Used as a reference to the global object. */

          var root = freeGlobal || freeSelf || Function('return this')();
          /**
           * A faster alternative to `Function#apply`, this function invokes `func`
           * with the `this` binding of `thisArg` and the arguments of `args`.
           *
           * @private
           * @param {Function} func The function to invoke.
           * @param {*} thisArg The `this` binding of `func`.
           * @param {Array} args The arguments to invoke `func` with.
           * @returns {*} Returns the result of `func`.
           */

          function apply(func, thisArg, args) {
            switch (args.length) {
              case 0:
                return func.call(thisArg);

              case 1:
                return func.call(thisArg, args[0]);

              case 2:
                return func.call(thisArg, args[0], args[1]);

              case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
            }

            return func.apply(thisArg, args);
          }
          /**
           * A specialized version of `_.map` for arrays without support for iteratee
           * shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns the new mapped array.
           */


          function arrayMap(array, iteratee) {
            var index = -1,
                length = array ? array.length : 0,
                result = Array(length);

            while (++index < length) {
              result[index] = iteratee(array[index], index, array);
            }

            return result;
          }
          /**
           * Appends the elements of `values` to `array`.
           *
           * @private
           * @param {Array} array The array to modify.
           * @param {Array} values The values to append.
           * @returns {Array} Returns `array`.
           */


          function arrayPush(array, values) {
            var index = -1,
                length = values.length,
                offset = array.length;

            while (++index < length) {
              array[offset + index] = values[index];
            }

            return array;
          }
          /** Used for built-in method references. */


          var objectProto = Object.prototype;
          /** Used to check objects for own properties. */

          var hasOwnProperty = objectProto.hasOwnProperty;
          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */

          var objectToString = objectProto.toString;
          /** Built-in value references. */

          var _Symbol2 = root.Symbol,
              propertyIsEnumerable = objectProto.propertyIsEnumerable,
              spreadableSymbol = _Symbol2 ? _Symbol2.isConcatSpreadable : undefined;
          /* Built-in method references for those with the same name as other `lodash` methods. */

          var nativeMax = Math.max;
          /**
           * The base implementation of `_.flatten` with support for restricting flattening.
           *
           * @private
           * @param {Array} array The array to flatten.
           * @param {number} depth The maximum recursion depth.
           * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
           * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
           * @param {Array} [result=[]] The initial result value.
           * @returns {Array} Returns the new flattened array.
           */

          function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1,
                length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);

            while (++index < length) {
              var value = array[index];

              if (depth > 0 && predicate(value)) {
                if (depth > 1) {
                  // Recursively flatten arrays (susceptible to call stack limits).
                  baseFlatten(value, depth - 1, predicate, isStrict, result);
                } else {
                  arrayPush(result, value);
                }
              } else if (!isStrict) {
                result[result.length] = value;
              }
            }

            return result;
          }
          /**
           * The base implementation of `_.pick` without support for individual
           * property identifiers.
           *
           * @private
           * @param {Object} object The source object.
           * @param {string[]} props The property identifiers to pick.
           * @returns {Object} Returns the new object.
           */


          function basePick(object, props) {
            object = Object(object);
            return basePickBy(object, props, function (value, key) {
              return key in object;
            });
          }
          /**
           * The base implementation of  `_.pickBy` without support for iteratee shorthands.
           *
           * @private
           * @param {Object} object The source object.
           * @param {string[]} props The property identifiers to pick from.
           * @param {Function} predicate The function invoked per property.
           * @returns {Object} Returns the new object.
           */


          function basePickBy(object, props, predicate) {
            var index = -1,
                length = props.length,
                result = {};

            while (++index < length) {
              var key = props[index],
                  value = object[key];

              if (predicate(value, key)) {
                result[key] = value;
              }
            }

            return result;
          }
          /**
           * The base implementation of `_.rest` which doesn't validate or coerce arguments.
           *
           * @private
           * @param {Function} func The function to apply a rest parameter to.
           * @param {number} [start=func.length-1] The start position of the rest parameter.
           * @returns {Function} Returns the new function.
           */


          function baseRest(func, start) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function () {
              var args = arguments,
                  index = -1,
                  length = nativeMax(args.length - start, 0),
                  array = Array(length);

              while (++index < length) {
                array[index] = args[start + index];
              }

              index = -1;
              var otherArgs = Array(start + 1);

              while (++index < start) {
                otherArgs[index] = args[index];
              }

              otherArgs[start] = array;
              return apply(func, this, otherArgs);
            };
          }
          /**
           * Checks if `value` is a flattenable `arguments` object or array.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
           */


          function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
          }
          /**
           * Converts `value` to a string key if it's not a string or symbol.
           *
           * @private
           * @param {*} value The value to inspect.
           * @returns {string|symbol} Returns the key.
           */


          function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) {
              return value;
            }

            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
          }
          /**
           * Checks if `value` is likely an `arguments` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an `arguments` object,
           *  else `false`.
           * @example
           *
           * _.isArguments(function() { return arguments; }());
           * // => true
           *
           * _.isArguments([1, 2, 3]);
           * // => false
           */


          function isArguments(value) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
          }
          /**
           * Checks if `value` is classified as an `Array` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an array, else `false`.
           * @example
           *
           * _.isArray([1, 2, 3]);
           * // => true
           *
           * _.isArray(document.body.children);
           * // => false
           *
           * _.isArray('abc');
           * // => false
           *
           * _.isArray(_.noop);
           * // => false
           */


          var isArray = Array.isArray;
          /**
           * Checks if `value` is array-like. A value is considered array-like if it's
           * not a function and has a `value.length` that's an integer greater than or
           * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
           * @example
           *
           * _.isArrayLike([1, 2, 3]);
           * // => true
           *
           * _.isArrayLike(document.body.children);
           * // => true
           *
           * _.isArrayLike('abc');
           * // => true
           *
           * _.isArrayLike(_.noop);
           * // => false
           */

          function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
          }
          /**
           * This method is like `_.isArrayLike` except that it also checks if `value`
           * is an object.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an array-like object,
           *  else `false`.
           * @example
           *
           * _.isArrayLikeObject([1, 2, 3]);
           * // => true
           *
           * _.isArrayLikeObject(document.body.children);
           * // => true
           *
           * _.isArrayLikeObject('abc');
           * // => false
           *
           * _.isArrayLikeObject(_.noop);
           * // => false
           */


          function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
          }
          /**
           * Checks if `value` is classified as a `Function` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a function, else `false`.
           * @example
           *
           * _.isFunction(_);
           * // => true
           *
           * _.isFunction(/abc/);
           * // => false
           */


          function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 8-9 which returns 'object' for typed array and other constructors.
            var tag = isObject(value) ? objectToString.call(value) : '';
            return tag == funcTag || tag == genTag;
          }
          /**
           * Checks if `value` is a valid array-like length.
           *
           * **Note:** This method is loosely based on
           * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
           * @example
           *
           * _.isLength(3);
           * // => true
           *
           * _.isLength(Number.MIN_VALUE);
           * // => false
           *
           * _.isLength(Infinity);
           * // => false
           *
           * _.isLength('3');
           * // => false
           */


          function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
          }
          /**
           * Checks if `value` is the
           * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
           * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an object, else `false`.
           * @example
           *
           * _.isObject({});
           * // => true
           *
           * _.isObject([1, 2, 3]);
           * // => true
           *
           * _.isObject(_.noop);
           * // => true
           *
           * _.isObject(null);
           * // => false
           */


          function isObject(value) {
            var type = _typeof2(value);

            return !!value && (type == 'object' || type == 'function');
          }
          /**
           * Checks if `value` is object-like. A value is object-like if it's not `null`
           * and has a `typeof` result of "object".
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
           * @example
           *
           * _.isObjectLike({});
           * // => true
           *
           * _.isObjectLike([1, 2, 3]);
           * // => true
           *
           * _.isObjectLike(_.noop);
           * // => false
           *
           * _.isObjectLike(null);
           * // => false
           */


          function isObjectLike(value) {
            return !!value && _typeof2(value) == 'object';
          }
          /**
           * Checks if `value` is classified as a `Symbol` primitive or object.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
           * @example
           *
           * _.isSymbol(Symbol.iterator);
           * // => true
           *
           * _.isSymbol('abc');
           * // => false
           */


          function isSymbol(value) {
            return _typeof2(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
          }
          /**
           * Creates an object composed of the picked `object` properties.
           *
           * @static
           * @since 0.1.0
           * @memberOf _
           * @category Object
           * @param {Object} object The source object.
           * @param {...(string|string[])} [props] The property identifiers to pick.
           * @returns {Object} Returns the new object.
           * @example
           *
           * var object = { 'a': 1, 'b': '2', 'c': 3 };
           *
           * _.pick(object, ['a', 'c']);
           * // => { 'a': 1, 'c': 3 }
           */


          var pick = baseRest(function (object, props) {
            return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
          });
          module.exports = pick;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));
        /***/
      },

      /***/
      "890c":
      /***/
      function c(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "8925":
      /***/
      function _(module, exports, __webpack_require__) {
        var store = __webpack_require__("c6cd");

        var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

        if (typeof store.inspectSource != 'function') {
          store.inspectSource = function (it) {
            return functionToString.call(it);
          };
        }

        module.exports = store.inspectSource;
        /***/
      },

      /***/
      "8aa5":
      /***/
      function aa5(module, exports, __webpack_require__) {
        "use strict";

        var charAt = __webpack_require__("6547").charAt; // `AdvanceStringIndex` abstract operation
        // https://tc39.github.io/ecma262/#sec-advancestringindex


        module.exports = function (S, index, unicode) {
          return index + (unicode ? charAt(S, index).length : 1);
        };
        /***/

      },

      /***/
      "8e95":
      /***/
      function e95(module, exports, __webpack_require__) {
        var MediaQueryDispatch = __webpack_require__("c195");

        module.exports = new MediaQueryDispatch();
        /***/
      },

      /***/
      "9020":
      /***/
      function _(module, exports) {
        /**
         * Delegate to handle a media query being matched and unmatched.
         *
         * @param {object} options
         * @param {function} options.match callback for when the media query is matched
         * @param {function} [options.unmatch] callback for when the media query is unmatched
         * @param {function} [options.setup] one-time callback triggered the first time a query is matched
         * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
         * @constructor
         */
        function QueryHandler(options) {
          this.options = options;
          !options.deferSetup && this.setup();
        }

        QueryHandler.prototype = {
          constructor: QueryHandler,

          /**
           * coordinates setup of the handler
           *
           * @function
           */
          setup: function setup() {
            if (this.options.setup) {
              this.options.setup();
            }

            this.initialised = true;
          },

          /**
           * coordinates setup and triggering of the handler
           *
           * @function
           */
          on: function on() {
            !this.initialised && this.setup();
            this.options.match && this.options.match();
          },

          /**
           * coordinates the unmatch event for the handler
           *
           * @function
           */
          off: function off() {
            this.options.unmatch && this.options.unmatch();
          },

          /**
           * called when a handler is to be destroyed.
           * delegates to the destroy or unmatch callbacks, depending on availability.
           *
           * @function
           */
          destroy: function destroy() {
            this.options.destroy ? this.options.destroy() : this.off();
          },

          /**
           * determines equality by reference.
           * if object is supplied compare options, if function, compare match callback
           *
           * @function
           * @param {object || function} [target] the target for comparison
           */
          equals: function equals(target) {
            return this.options === target || this.options.match === target;
          }
        };
        module.exports = QueryHandler;
        /***/
      },

      /***/
      "90e3":
      /***/
      function e3(module, exports) {
        var id = 0;
        var postfix = Math.random();

        module.exports = function (key) {
          return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
        };
        /***/

      },

      /***/
      "9112":
      /***/
      function _(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var definePropertyModule = __webpack_require__("9bf2");

        var createPropertyDescriptor = __webpack_require__("5c6c");

        module.exports = DESCRIPTORS ? function (object, key, value) {
          return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "9263":
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var regexpFlags = __webpack_require__("ad6d");

        var stickyHelpers = __webpack_require__("9f7f");

        var nativeExec = RegExp.prototype.exec; // This always refers to the native implementation, because the
        // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
        // which loads this file before patching the method.

        var nativeReplace = String.prototype.replace;
        var patchedExec = nativeExec;

        var UPDATES_LAST_INDEX_WRONG = function () {
          var re1 = /a/;
          var re2 = /b*/g;
          nativeExec.call(re1, 'a');
          nativeExec.call(re2, 'a');
          return re1.lastIndex !== 0 || re2.lastIndex !== 0;
        }();

        var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

        if (PATCH) {
          patchedExec = function exec(str) {
            var re = this;
            var lastIndex, reCopy, match, i;
            var sticky = UNSUPPORTED_Y && re.sticky;
            var flags = regexpFlags.call(re);
            var source = re.source;
            var charsAdded = 0;
            var strCopy = str;

            if (sticky) {
              flags = flags.replace('y', '');

              if (flags.indexOf('g') === -1) {
                flags += 'g';
              }

              strCopy = String(str).slice(re.lastIndex); // Support anchored sticky behavior.

              if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
                source = '(?: ' + source + ')';
                strCopy = ' ' + strCopy;
                charsAdded++;
              } // ^(? + rx + ) is needed, in combination with some str slicing, to
              // simulate the 'y' flag.


              reCopy = new RegExp('^(?:' + source + ')', flags);
            }

            if (NPCG_INCLUDED) {
              reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
            }

            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
            match = nativeExec.call(sticky ? reCopy : re, strCopy);

            if (sticky) {
              if (match) {
                match.input = match.input.slice(charsAdded);
                match[0] = match[0].slice(charsAdded);
                match.index = re.lastIndex;
                re.lastIndex += match[0].length;
              } else re.lastIndex = 0;
            } else if (UPDATES_LAST_INDEX_WRONG && match) {
              re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
            }

            if (NPCG_INCLUDED && match && match.length > 1) {
              // Fix browsers whose `exec` methods don't consistently return `undefined`
              // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
              nativeReplace.call(match[0], reCopy, function () {
                for (i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
            }

            return match;
          };
        }

        module.exports = patchedExec;
        /***/
      },

      /***/
      "94ca":
      /***/
      function ca(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039");

        var replacement = /#|\.prototype\./;

        var isForced = function isForced(feature, detection) {
          var value = data[normalize(feature)];
          return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
        };

        var normalize = isForced.normalize = function (string) {
          return String(string).replace(replacement, '.').toLowerCase();
        };

        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';
        module.exports = isForced;
        /***/
      },

      /***/
      "99af":
      /***/
      function af(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var fails = __webpack_require__("d039");

        var isArray = __webpack_require__("e8b5");

        var isObject = __webpack_require__("861d");

        var toObject = __webpack_require__("7b0b");

        var toLength = __webpack_require__("50c4");

        var createProperty = __webpack_require__("8418");

        var arraySpeciesCreate = __webpack_require__("65f0");

        var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

        var wellKnownSymbol = __webpack_require__("b622");

        var V8_VERSION = __webpack_require__("2d00");

        var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
        var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
        var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/679

        var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
          var array = [];
          array[IS_CONCAT_SPREADABLE] = false;
          return array.concat()[0] !== array;
        });
        var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

        var isConcatSpreadable = function isConcatSpreadable(O) {
          if (!isObject(O)) return false;
          var spreadable = O[IS_CONCAT_SPREADABLE];
          return spreadable !== undefined ? !!spreadable : isArray(O);
        };

        var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.concat
        // with adding support of @@isConcatSpreadable and @@species

        $({
          target: 'Array',
          proto: true,
          forced: FORCED
        }, {
          concat: function concat(arg) {
            // eslint-disable-line no-unused-vars
            var O = toObject(this);
            var A = arraySpeciesCreate(O, 0);
            var n = 0;
            var i, k, length, len, E;

            for (i = -1, length = arguments.length; i < length; i++) {
              E = i === -1 ? O : arguments[i];

              if (isConcatSpreadable(E)) {
                len = toLength(E.length);
                if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

                for (k = 0; k < len; k++, n++) {
                  if (k in E) createProperty(A, n, E[k]);
                }
              } else {
                if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                createProperty(A, n++, E);
              }
            }

            A.length = n;
            return A;
          }
        });
        /***/
      },

      /***/
      "9bdd":
      /***/
      function bdd(module, exports, __webpack_require__) {
        var anObject = __webpack_require__("825a"); // call something on iterator step with safe closing on error


        module.exports = function (iterator, fn, value, ENTRIES) {
          try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (error) {
            var returnMethod = iterator['return'];
            if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
            throw error;
          }
        };
        /***/

      },

      /***/
      "9bf2":
      /***/
      function bf2(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var IE8_DOM_DEFINE = __webpack_require__("0cfb");

        var anObject = __webpack_require__("825a");

        var toPrimitive = __webpack_require__("c04e");

        var nativeDefineProperty = Object.defineProperty; // `Object.defineProperty` method
        // https://tc39.github.io/ecma262/#sec-object.defineproperty

        exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return nativeDefineProperty(O, P, Attributes);
          } catch (error) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "9ed3":
      /***/
      function ed3(module, exports, __webpack_require__) {
        "use strict";

        var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;

        var create = __webpack_require__("7c73");

        var createPropertyDescriptor = __webpack_require__("5c6c");

        var setToStringTag = __webpack_require__("d44e");

        var Iterators = __webpack_require__("3f8c");

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (IteratorConstructor, NAME, next) {
          var TO_STRING_TAG = NAME + ' Iterator';
          IteratorConstructor.prototype = create(IteratorPrototype, {
            next: createPropertyDescriptor(1, next)
          });
          setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
          Iterators[TO_STRING_TAG] = returnThis;
          return IteratorConstructor;
        };
        /***/

      },

      /***/
      "9f7f":
      /***/
      function f7f(module, exports, __webpack_require__) {
        "use strict";

        var fails = __webpack_require__("d039"); // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
        // so we use an intermediate function.


        function RE(s, f) {
          return RegExp(s, f);
        }

        exports.UNSUPPORTED_Y = fails(function () {
          // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
          var re = RE('a', 'y');
          re.lastIndex = 2;
          return re.exec('abcd') != null;
        });
        exports.BROKEN_CARET = fails(function () {
          // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
          var re = RE('^r', 'gy');
          re.lastIndex = 2;
          return re.exec('str') != null;
        });
        /***/
      },

      /***/
      "a15b":
      /***/
      function a15b(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var IndexedObject = __webpack_require__("44ad");

        var toIndexedObject = __webpack_require__("fc6a");

        var arrayMethodIsStrict = __webpack_require__("a640");

        var nativeJoin = [].join;
        var ES3_STRINGS = IndexedObject != Object;
        var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.join

        $({
          target: 'Array',
          proto: true,
          forced: ES3_STRINGS || !STRICT_METHOD
        }, {
          join: function join(separator) {
            return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
          }
        });
        /***/
      },

      /***/
      "a48b":
      /***/
      function a48b(module, exports, __webpack_require__) {
        var camel2hyphen = __webpack_require__("0497");

        var isDimension = function isDimension(feature) {
          var re = /[height|width]$/;
          return re.test(feature);
        };

        var obj2mq = function obj2mq(obj) {
          var mq = '';
          var features = Object.keys(obj);
          features.forEach(function (feature, index) {
            var value = obj[feature];
            feature = camel2hyphen(feature); // Add px to dimension features

            if (isDimension(feature) && typeof value === 'number') {
              value = value + 'px';
            }

            if (value === true) {
              mq += feature;
            } else if (value === false) {
              mq += 'not ' + feature;
            } else {
              mq += '(' + feature + ': ' + value + ')';
            }

            if (index < features.length - 1) {
              mq += ' and ';
            }
          });
          return mq;
        };

        var json2mq = function json2mq(query) {
          var mq = '';

          if (typeof query === 'string') {
            return query;
          } // Handling array of media queries


          if (query instanceof Array) {
            query.forEach(function (q, index) {
              mq += obj2mq(q);

              if (index < query.length - 1) {
                mq += ', ';
              }
            });
            return mq;
          } // Handling single media query


          return obj2mq(query);
        };

        module.exports = json2mq;
        /***/
      },

      /***/
      "a4d3":
      /***/
      function a4d3(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var global = __webpack_require__("da84");

        var getBuiltIn = __webpack_require__("d066");

        var IS_PURE = __webpack_require__("c430");

        var DESCRIPTORS = __webpack_require__("83ab");

        var NATIVE_SYMBOL = __webpack_require__("4930");

        var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

        var fails = __webpack_require__("d039");

        var has = __webpack_require__("5135");

        var isArray = __webpack_require__("e8b5");

        var isObject = __webpack_require__("861d");

        var anObject = __webpack_require__("825a");

        var toObject = __webpack_require__("7b0b");

        var toIndexedObject = __webpack_require__("fc6a");

        var toPrimitive = __webpack_require__("c04e");

        var createPropertyDescriptor = __webpack_require__("5c6c");

        var nativeObjectCreate = __webpack_require__("7c73");

        var objectKeys = __webpack_require__("df75");

        var getOwnPropertyNamesModule = __webpack_require__("241c");

        var getOwnPropertyNamesExternal = __webpack_require__("057f");

        var getOwnPropertySymbolsModule = __webpack_require__("7418");

        var getOwnPropertyDescriptorModule = __webpack_require__("06cf");

        var definePropertyModule = __webpack_require__("9bf2");

        var propertyIsEnumerableModule = __webpack_require__("d1e7");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var redefine = __webpack_require__("6eeb");

        var shared = __webpack_require__("5692");

        var sharedKey = __webpack_require__("f772");

        var hiddenKeys = __webpack_require__("d012");

        var uid = __webpack_require__("90e3");

        var wellKnownSymbol = __webpack_require__("b622");

        var wrappedWellKnownSymbolModule = __webpack_require__("e538");

        var defineWellKnownSymbol = __webpack_require__("746f");

        var setToStringTag = __webpack_require__("d44e");

        var InternalStateModule = __webpack_require__("69f3");

        var $forEach = __webpack_require__("b727").forEach;

        var HIDDEN = sharedKey('hidden');
        var SYMBOL = 'Symbol';
        var PROTOTYPE = 'prototype';
        var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(SYMBOL);
        var ObjectPrototype = Object[PROTOTYPE];
        var $Symbol = global.Symbol;
        var $stringify = getBuiltIn('JSON', 'stringify');
        var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        var nativeDefineProperty = definePropertyModule.f;
        var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
        var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
        var AllSymbols = shared('symbols');
        var ObjectPrototypeSymbols = shared('op-symbols');
        var StringToSymbolRegistry = shared('string-to-symbol-registry');
        var SymbolToStringRegistry = shared('symbol-to-string-registry');
        var WellKnownSymbolsStore = shared('wks');
        var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

        var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDescriptor = DESCRIPTORS && fails(function () {
          return nativeObjectCreate(nativeDefineProperty({}, 'a', {
            get: function get() {
              return nativeDefineProperty(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (O, P, Attributes) {
          var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
          if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
          nativeDefineProperty(O, P, Attributes);

          if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
            nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
          }
        } : nativeDefineProperty;

        var wrap = function wrap(tag, description) {
          var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
          setInternalState(symbol, {
            type: SYMBOL,
            tag: tag,
            description: description
          });
          if (!DESCRIPTORS) symbol.description = description;
          return symbol;
        };

        var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
          return _typeof2(it) == 'symbol';
        } : function (it) {
          return Object(it) instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(O, P, Attributes) {
          if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
          anObject(O);
          var key = toPrimitive(P, true);
          anObject(Attributes);

          if (has(AllSymbols, key)) {
            if (!Attributes.enumerable) {
              if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
              O[HIDDEN][key] = true;
            } else {
              if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
              Attributes = nativeObjectCreate(Attributes, {
                enumerable: createPropertyDescriptor(0, false)
              });
            }

            return setSymbolDescriptor(O, key, Attributes);
          }

          return nativeDefineProperty(O, key, Attributes);
        };

        var $defineProperties = function defineProperties(O, Properties) {
          anObject(O);
          var properties = toIndexedObject(Properties);
          var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
          $forEach(keys, function (key) {
            if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
          });
          return O;
        };

        var $create = function create(O, Properties) {
          return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(V) {
          var P = toPrimitive(V, true);
          var enumerable = nativePropertyIsEnumerable.call(this, P);
          if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
          return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
          var it = toIndexedObject(O);
          var key = toPrimitive(P, true);
          if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
          var descriptor = nativeGetOwnPropertyDescriptor(it, key);

          if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
            descriptor.enumerable = true;
          }

          return descriptor;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(O) {
          var names = nativeGetOwnPropertyNames(toIndexedObject(O));
          var result = [];
          $forEach(names, function (key) {
            if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
          });
          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
          var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
          var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
          var result = [];
          $forEach(names, function (key) {
            if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
              result.push(AllSymbols[key]);
            }
          });
          return result;
        }; // `Symbol` constructor
        // https://tc39.github.io/ecma262/#sec-symbol-constructor


        if (!NATIVE_SYMBOL) {
          $Symbol = function _Symbol3() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
            var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
            var tag = uid(description);

            var setter = function setter(value) {
              if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
            };

            if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
              configurable: true,
              set: setter
            });
            return wrap(tag, description);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return getInternalState(this).tag;
          });
          redefine($Symbol, 'withoutSetter', function (description) {
            return wrap(uid(description), description);
          });
          propertyIsEnumerableModule.f = $propertyIsEnumerable;
          definePropertyModule.f = $defineProperty;
          getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
          getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
          getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

          wrappedWellKnownSymbolModule.f = function (name) {
            return wrap(wellKnownSymbol(name), name);
          };

          if (DESCRIPTORS) {
            // https://github.com/tc39/proposal-Symbol-description
            nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
              configurable: true,
              get: function description() {
                return getInternalState(this).description;
              }
            });

            if (!IS_PURE) {
              redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
                unsafe: true
              });
            }
          }
        }

        $({
          global: true,
          wrap: true,
          forced: !NATIVE_SYMBOL,
          sham: !NATIVE_SYMBOL
        }, {
          Symbol: $Symbol
        });
        $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
          defineWellKnownSymbol(name);
        });
        $({
          target: SYMBOL,
          stat: true,
          forced: !NATIVE_SYMBOL
        }, {
          // `Symbol.for` method
          // https://tc39.github.io/ecma262/#sec-symbol.for
          'for': function _for(key) {
            var string = String(key);
            if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
            var symbol = $Symbol(string);
            StringToSymbolRegistry[string] = symbol;
            SymbolToStringRegistry[symbol] = string;
            return symbol;
          },
          // `Symbol.keyFor` method
          // https://tc39.github.io/ecma262/#sec-symbol.keyfor
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
            if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
          },
          useSetter: function useSetter() {
            USE_SETTER = true;
          },
          useSimple: function useSimple() {
            USE_SETTER = false;
          }
        });
        $({
          target: 'Object',
          stat: true,
          forced: !NATIVE_SYMBOL,
          sham: !DESCRIPTORS
        }, {
          // `Object.create` method
          // https://tc39.github.io/ecma262/#sec-object.create
          create: $create,
          // `Object.defineProperty` method
          // https://tc39.github.io/ecma262/#sec-object.defineproperty
          defineProperty: $defineProperty,
          // `Object.defineProperties` method
          // https://tc39.github.io/ecma262/#sec-object.defineproperties
          defineProperties: $defineProperties,
          // `Object.getOwnPropertyDescriptor` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor
        });
        $({
          target: 'Object',
          stat: true,
          forced: !NATIVE_SYMBOL
        }, {
          // `Object.getOwnPropertyNames` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
          getOwnPropertyNames: $getOwnPropertyNames,
          // `Object.getOwnPropertySymbols` method
          // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
        // https://bugs.chromium.org/p/v8/issues/detail?id=3443

        $({
          target: 'Object',
          stat: true,
          forced: fails(function () {
            getOwnPropertySymbolsModule.f(1);
          })
        }, {
          getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return getOwnPropertySymbolsModule.f(toObject(it));
          }
        }); // `JSON.stringify` method behavior with symbols
        // https://tc39.github.io/ecma262/#sec-json.stringify

        if ($stringify) {
          var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
            var symbol = $Symbol(); // MS Edge converts symbol values to JSON as {}

            return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
            || $stringify({
              a: symbol
            }) != '{}' // V8 throws on boxed symbols
            || $stringify(Object(symbol)) != '{}';
          });
          $({
            target: 'JSON',
            stat: true,
            forced: FORCED_JSON_STRINGIFY
          }, {
            // eslint-disable-next-line no-unused-vars
            stringify: function stringify(it, replacer, space) {
              var args = [it];
              var index = 1;
              var $replacer;

              while (arguments.length > index) {
                args.push(arguments[index++]);
              }

              $replacer = replacer;
              if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

              if (!isArray(replacer)) replacer = function replacer(key, value) {
                if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                if (!isSymbol(value)) return value;
              };
              args[1] = replacer;
              return $stringify.apply(null, args);
            }
          });
        } // `Symbol.prototype[@@toPrimitive]` method
        // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive


        if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
          createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
        } // `Symbol.prototype[@@toStringTag]` property
        // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag


        setToStringTag($Symbol, SYMBOL);
        hiddenKeys[HIDDEN] = true;
        /***/
      },

      /***/
      "a623":
      /***/
      function a623(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var $every = __webpack_require__("b727").every;

        var arrayMethodIsStrict = __webpack_require__("a640");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var STRICT_METHOD = arrayMethodIsStrict('every');
        var USES_TO_LENGTH = arrayMethodUsesToLength('every'); // `Array.prototype.every` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.every

        $({
          target: 'Array',
          proto: true,
          forced: !STRICT_METHOD || !USES_TO_LENGTH
        }, {
          every: function every(callbackfn
          /* , thisArg */
          ) {
            return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "a630":
      /***/
      function a630(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var from = __webpack_require__("4df4");

        var checkCorrectnessOfIteration = __webpack_require__("1c7e");

        var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
          Array.from(iterable);
        }); // `Array.from` method
        // https://tc39.github.io/ecma262/#sec-array.from

        $({
          target: 'Array',
          stat: true,
          forced: INCORRECT_ITERATION
        }, {
          from: from
        });
        /***/
      },

      /***/
      "a640":
      /***/
      function a640(module, exports, __webpack_require__) {
        "use strict";

        var fails = __webpack_require__("d039");

        module.exports = function (METHOD_NAME, argument) {
          var method = [][METHOD_NAME];
          return !!method && fails(function () {
            // eslint-disable-next-line no-useless-call,no-throw-literal
            method.call(null, argument || function () {
              throw 1;
            }, 1);
          });
        };
        /***/

      },

      /***/
      "a691":
      /***/
      function a691(module, exports) {
        var ceil = Math.ceil;
        var floor = Math.floor; // `ToInteger` abstract operation
        // https://tc39.github.io/ecma262/#sec-tointeger

        module.exports = function (argument) {
          return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
        };
        /***/

      },

      /***/
      "a9e3":
      /***/
      function a9e3(module, exports, __webpack_require__) {
        "use strict";

        var DESCRIPTORS = __webpack_require__("83ab");

        var global = __webpack_require__("da84");

        var isForced = __webpack_require__("94ca");

        var redefine = __webpack_require__("6eeb");

        var has = __webpack_require__("5135");

        var classof = __webpack_require__("c6b6");

        var inheritIfRequired = __webpack_require__("7156");

        var toPrimitive = __webpack_require__("c04e");

        var fails = __webpack_require__("d039");

        var create = __webpack_require__("7c73");

        var getOwnPropertyNames = __webpack_require__("241c").f;

        var getOwnPropertyDescriptor = __webpack_require__("06cf").f;

        var defineProperty = __webpack_require__("9bf2").f;

        var trim = __webpack_require__("58a8").trim;

        var NUMBER = 'Number';
        var NativeNumber = global[NUMBER];
        var NumberPrototype = NativeNumber.prototype; // Opera ~12 has broken Object#toString

        var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER; // `ToNumber` abstract operation
        // https://tc39.github.io/ecma262/#sec-tonumber

        var toNumber = function toNumber(argument) {
          var it = toPrimitive(argument, false);
          var first, third, radix, maxCode, digits, length, index, code;

          if (typeof it == 'string' && it.length > 2) {
            it = trim(it);
            first = it.charCodeAt(0);

            if (first === 43 || first === 45) {
              third = it.charCodeAt(2);
              if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
            } else if (first === 48) {
              switch (it.charCodeAt(1)) {
                case 66:
                case 98:
                  radix = 2;
                  maxCode = 49;
                  break;
                // fast equal of /^0b[01]+$/i

                case 79:
                case 111:
                  radix = 8;
                  maxCode = 55;
                  break;
                // fast equal of /^0o[0-7]+$/i

                default:
                  return +it;
              }

              digits = it.slice(2);
              length = digits.length;

              for (index = 0; index < length; index++) {
                code = digits.charCodeAt(index); // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols

                if (code < 48 || code > maxCode) return NaN;
              }

              return parseInt(digits, radix);
            }
          }

          return +it;
        }; // `Number` constructor
        // https://tc39.github.io/ecma262/#sec-number-constructor


        if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
          var NumberWrapper = function Number(value) {
            var it = arguments.length < 1 ? 0 : value;
            var dummy = this;
            return dummy instanceof NumberWrapper // check on 1..constructor(foo) case
            && (BROKEN_CLASSOF ? fails(function () {
              NumberPrototype.valueOf.call(dummy);
            }) : classof(dummy) != NUMBER) ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
          };

          for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : ( // ES3:
          'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
          'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
            if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
              defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
            }
          }

          NumberWrapper.prototype = NumberPrototype;
          NumberPrototype.constructor = NumberWrapper;
          redefine(global, NUMBER, NumberWrapper);
        }
        /***/

      },

      /***/
      "ac1f":
      /***/
      function ac1f(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var exec = __webpack_require__("9263");

        $({
          target: 'RegExp',
          proto: true,
          forced: /./.exec !== exec
        }, {
          exec: exec
        });
        /***/
      },

      /***/
      "ad6d":
      /***/
      function ad6d(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__("825a"); // `RegExp.prototype.flags` getter implementation
        // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags


        module.exports = function () {
          var that = anObject(this);
          var result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.dotAll) result += 's';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/

      },

      /***/
      "ae40":
      /***/
      function ae40(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var fails = __webpack_require__("d039");

        var has = __webpack_require__("5135");

        var defineProperty = Object.defineProperty;
        var cache = {};

        var thrower = function thrower(it) {
          throw it;
        };

        module.exports = function (METHOD_NAME, options) {
          if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
          if (!options) options = {};
          var method = [][METHOD_NAME];
          var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
          var argument0 = has(options, 0) ? options[0] : thrower;
          var argument1 = has(options, 1) ? options[1] : undefined;
          return cache[METHOD_NAME] = !!method && !fails(function () {
            if (ACCESSORS && !DESCRIPTORS) return true;
            var O = {
              length: -1
            };
            if (ACCESSORS) defineProperty(O, 1, {
              enumerable: true,
              get: thrower
            });else O[1] = 1;
            method.call(O, argument0, argument1);
          });
        };
        /***/

      },

      /***/
      "ae93":
      /***/
      function ae93(module, exports, __webpack_require__) {
        "use strict";

        var getPrototypeOf = __webpack_require__("e163");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var has = __webpack_require__("5135");

        var wellKnownSymbol = __webpack_require__("b622");

        var IS_PURE = __webpack_require__("c430");

        var ITERATOR = wellKnownSymbol('iterator');
        var BUGGY_SAFARI_ITERATORS = false;

        var returnThis = function returnThis() {
          return this;
        }; // `%IteratorPrototype%` object
        // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object


        var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

        if ([].keys) {
          arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

          if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
            PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
          }
        }

        if (IteratorPrototype == undefined) IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
          createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
        }

        module.exports = {
          IteratorPrototype: IteratorPrototype,
          BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
        };
        /***/
      },

      /***/
      "b041":
      /***/
      function b041(module, exports, __webpack_require__) {
        "use strict";

        var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");

        var classof = __webpack_require__("f5df"); // `Object.prototype.toString` method implementation
        // https://tc39.github.io/ecma262/#sec-object.prototype.tostring


        module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
          return '[object ' + classof(this) + ']';
        };
        /***/
      },

      /***/
      "b0c0":
      /***/
      function b0c0(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__("83ab");

        var defineProperty = __webpack_require__("9bf2").f;

        var FunctionPrototype = Function.prototype;
        var FunctionPrototypeToString = FunctionPrototype.toString;
        var nameRE = /^\s*function ([^ (]*)/;
        var NAME = 'name'; // Function instances `.name` property
        // https://tc39.github.io/ecma262/#sec-function-instances-name

        if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
          defineProperty(FunctionPrototype, NAME, {
            configurable: true,
            get: function get() {
              try {
                return FunctionPrototypeToString.call(this).match(nameRE)[1];
              } catch (error) {
                return '';
              }
            }
          });
        }
        /***/

      },

      /***/
      "b622":
      /***/
      function b622(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var shared = __webpack_require__("5692");

        var has = __webpack_require__("5135");

        var uid = __webpack_require__("90e3");

        var NATIVE_SYMBOL = __webpack_require__("4930");

        var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

        var WellKnownSymbolsStore = shared('wks');
        var _Symbol4 = global.Symbol;
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? _Symbol4 : _Symbol4 && _Symbol4.withoutSetter || uid;

        module.exports = function (name) {
          if (!has(WellKnownSymbolsStore, name)) {
            if (NATIVE_SYMBOL && has(_Symbol4, name)) WellKnownSymbolsStore[name] = _Symbol4[name];else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
          }

          return WellKnownSymbolsStore[name];
        };
        /***/

      },

      /***/
      "b64b":
      /***/
      function b64b(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var toObject = __webpack_require__("7b0b");

        var nativeKeys = __webpack_require__("df75");

        var fails = __webpack_require__("d039");

        var FAILS_ON_PRIMITIVES = fails(function () {
          nativeKeys(1);
        }); // `Object.keys` method
        // https://tc39.github.io/ecma262/#sec-object.keys

        $({
          target: 'Object',
          stat: true,
          forced: FAILS_ON_PRIMITIVES
        }, {
          keys: function keys(it) {
            return nativeKeys(toObject(it));
          }
        });
        /***/
      },

      /***/
      "b727":
      /***/
      function b727(module, exports, __webpack_require__) {
        var bind = __webpack_require__("0366");

        var IndexedObject = __webpack_require__("44ad");

        var toObject = __webpack_require__("7b0b");

        var toLength = __webpack_require__("50c4");

        var arraySpeciesCreate = __webpack_require__("65f0");

        var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation

        var createMethod = function createMethod(TYPE) {
          var IS_MAP = TYPE == 1;
          var IS_FILTER = TYPE == 2;
          var IS_SOME = TYPE == 3;
          var IS_EVERY = TYPE == 4;
          var IS_FIND_INDEX = TYPE == 6;
          var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
          return function ($this, callbackfn, that, specificCreate) {
            var O = toObject($this);
            var self = IndexedObject(O);
            var boundFunction = bind(callbackfn, that, 3);
            var length = toLength(self.length);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate;
            var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
            var value, result;

            for (; length > index; index++) {
              if (NO_HOLES || index in self) {
                value = self[index];
                result = boundFunction(value, index, O);

                if (TYPE) {
                  if (IS_MAP) target[index] = result; // map
                  else if (result) switch (TYPE) {
                      case 3:
                        return true;
                      // some

                      case 5:
                        return value;
                      // find

                      case 6:
                        return index;
                      // findIndex

                      case 2:
                        push.call(target, value);
                      // filter
                    } else if (IS_EVERY) return false; // every
                }
              }
            }

            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
          };
        };

        module.exports = {
          // `Array.prototype.forEach` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
          forEach: createMethod(0),
          // `Array.prototype.map` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.map
          map: createMethod(1),
          // `Array.prototype.filter` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.filter
          filter: createMethod(2),
          // `Array.prototype.some` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.some
          some: createMethod(3),
          // `Array.prototype.every` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.every
          every: createMethod(4),
          // `Array.prototype.find` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.find
          find: createMethod(5),
          // `Array.prototype.findIndex` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
          findIndex: createMethod(6)
        };
        /***/
      },

      /***/
      "bcf7":
      /***/
      function bcf7(module, exports, __webpack_require__) {
        var QueryHandler = __webpack_require__("9020");

        var each = __webpack_require__("217d").each;
        /**
         * Represents a single media query, manages it's state and registered handlers for this query
         *
         * @constructor
         * @param {string} query the media query string
         * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
         */


        function MediaQuery(query, isUnconditional) {
          this.query = query;
          this.isUnconditional = isUnconditional;
          this.handlers = [];
          this.mql = window.matchMedia(query);
          var self = this;

          this.listener = function (mql) {
            // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
            self.mql = mql.currentTarget || mql;
            self.assess();
          };

          this.mql.addListener(this.listener);
        }

        MediaQuery.prototype = {
          constuctor: MediaQuery,

          /**
           * add a handler for this query, triggering if already active
           *
           * @param {object} handler
           * @param {function} handler.match callback for when query is activated
           * @param {function} [handler.unmatch] callback for when query is deactivated
           * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
           * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
           */
          addHandler: function addHandler(handler) {
            var qh = new QueryHandler(handler);
            this.handlers.push(qh);
            this.matches() && qh.on();
          },

          /**
           * removes the given handler from the collection, and calls it's destroy methods
           *
           * @param {object || function} handler the handler to remove
           */
          removeHandler: function removeHandler(handler) {
            var handlers = this.handlers;
            each(handlers, function (h, i) {
              if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
              }
            });
          },

          /**
           * Determine whether the media query should be considered a match
           *
           * @return {Boolean} true if media query can be considered a match, false otherwise
           */
          matches: function matches() {
            return this.mql.matches || this.isUnconditional;
          },

          /**
           * Clears all handlers and unbinds events
           */
          clear: function clear() {
            each(this.handlers, function (handler) {
              handler.destroy();
            });
            this.mql.removeListener(this.listener);
            this.handlers.length = 0; //clear array
          },

          /*
              * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
              */
          assess: function assess() {
            var action = this.matches() ? 'on' : 'off';
            each(this.handlers, function (handler) {
              handler[action]();
            });
          }
        };
        module.exports = MediaQuery;
        /***/
      },

      /***/
      "c04e":
      /***/
      function c04e(module, exports, __webpack_require__) {
        var isObject = __webpack_require__("861d"); // `ToPrimitive` abstract operation
        // https://tc39.github.io/ecma262/#sec-toprimitive
        // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (input, PREFERRED_STRING) {
          if (!isObject(input)) return input;
          var fn, val;
          if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
          if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
          if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "c195":
      /***/
      function c195(module, exports, __webpack_require__) {
        var MediaQuery = __webpack_require__("bcf7");

        var Util = __webpack_require__("217d");

        var each = Util.each;
        var isFunction = Util.isFunction;
        var isArray = Util.isArray;
        /**
         * Allows for registration of query handlers.
         * Manages the query handler's state and is responsible for wiring up browser events
         *
         * @constructor
         */

        function MediaQueryDispatch() {
          if (!window.matchMedia) {
            throw new Error('matchMedia not present, legacy browsers require a polyfill');
          }

          this.queries = {};
          this.browserIsIncapable = !window.matchMedia('only all').matches;
        }

        MediaQueryDispatch.prototype = {
          constructor: MediaQueryDispatch,

          /**
           * Registers a handler for the given media query
           *
           * @param {string} q the media query
           * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
           * @param {function} options.match fired when query matched
           * @param {function} [options.unmatch] fired when a query is no longer matched
           * @param {function} [options.setup] fired when handler first triggered
           * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
           * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
           */
          register: function register(q, options, shouldDegrade) {
            var queries = this.queries,
                isUnconditional = shouldDegrade && this.browserIsIncapable;

            if (!queries[q]) {
              queries[q] = new MediaQuery(q, isUnconditional);
            } //normalise to object in an array


            if (isFunction(options)) {
              options = {
                match: options
              };
            }

            if (!isArray(options)) {
              options = [options];
            }

            each(options, function (handler) {
              if (isFunction(handler)) {
                handler = {
                  match: handler
                };
              }

              queries[q].addHandler(handler);
            });
            return this;
          },

          /**
           * unregisters a query and all it's handlers, or a specific handler for a query
           *
           * @param {string} q the media query to target
           * @param {object || function} [handler] specific handler to unregister
           */
          unregister: function unregister(q, handler) {
            var query = this.queries[q];

            if (query) {
              if (handler) {
                query.removeHandler(handler);
              } else {
                query.clear();
                delete this.queries[q];
              }
            }

            return this;
          }
        };
        module.exports = MediaQueryDispatch;
        /***/
      },

      /***/
      "c430":
      /***/
      function c430(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "c6b6":
      /***/
      function c6b6(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "c6cd":
      /***/
      function c6cd(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var setGlobal = __webpack_require__("ce4e");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || setGlobal(SHARED, {});
        module.exports = store;
        /***/
      },

      /***/
      "c832":
      /***/
      function c832(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /**
          * lodash (Custom Build) <https://lodash.com/>
          * Build: `lodash modularize exports="npm" -o ./`
          * Copyright jQuery Foundation and other contributors <https://jquery.org/>
          * Released under MIT license <https://lodash.com/license>
          * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
          * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
          */

          /** Used as the `TypeError` message for "Functions" methods. */
          var FUNC_ERROR_TEXT = 'Expected a function';
          /** Used to stand-in for `undefined` hash values. */

          var HASH_UNDEFINED = '__lodash_hash_undefined__';
          /** Used as references for various `Number` constants. */

          var INFINITY = 1 / 0;
          /** `Object#toString` result references. */

          var funcTag = '[object Function]',
              genTag = '[object GeneratorFunction]',
              symbolTag = '[object Symbol]';
          /** Used to match property names within property paths. */

          var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
              reIsPlainProp = /^\w*$/,
              reLeadingDot = /^\./,
              rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
          /**
           * Used to match `RegExp`
           * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
           */

          var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
          /** Used to match backslashes in property paths. */

          var reEscapeChar = /\\(\\)?/g;
          /** Used to detect host constructors (Safari). */

          var reIsHostCtor = /^\[object .+?Constructor\]$/;
          /** Detect free variable `global` from Node.js. */

          var freeGlobal = _typeof2(global) == 'object' && global && global.Object === Object && global;
          /** Detect free variable `self`. */

          var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof2(self)) == 'object' && self && self.Object === Object && self;
          /** Used as a reference to the global object. */

          var root = freeGlobal || freeSelf || Function('return this')();
          /**
           * Gets the value at `key` of `object`.
           *
           * @private
           * @param {Object} [object] The object to query.
           * @param {string} key The key of the property to get.
           * @returns {*} Returns the property value.
           */

          function getValue(object, key) {
            return object == null ? undefined : object[key];
          }
          /**
           * Checks if `value` is a host object in IE < 9.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
           */


          function isHostObject(value) {
            // Many host objects are `Object` objects that can coerce to strings
            // despite having improperly defined `toString` methods.
            var result = false;

            if (value != null && typeof value.toString != 'function') {
              try {
                result = !!(value + '');
              } catch (e) {}
            }

            return result;
          }
          /** Used for built-in method references. */


          var arrayProto = Array.prototype,
              funcProto = Function.prototype,
              objectProto = Object.prototype;
          /** Used to detect overreaching core-js shims. */

          var coreJsData = root['__core-js_shared__'];
          /** Used to detect methods masquerading as native. */

          var maskSrcKey = function () {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
          }();
          /** Used to resolve the decompiled source of functions. */


          var funcToString = funcProto.toString;
          /** Used to check objects for own properties. */

          var hasOwnProperty = objectProto.hasOwnProperty;
          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */

          var objectToString = objectProto.toString;
          /** Used to detect if a method is native. */

          var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
          /** Built-in value references. */

          var _Symbol5 = root.Symbol,
              splice = arrayProto.splice;
          /* Built-in method references that are verified to be native. */

          var Map = getNative(root, 'Map'),
              nativeCreate = getNative(Object, 'create');
          /** Used to convert symbols to primitives and strings. */

          var symbolProto = _Symbol5 ? _Symbol5.prototype : undefined,
              symbolToString = symbolProto ? symbolProto.toString : undefined;
          /**
           * Creates a hash object.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */

          function Hash(entries) {
            var index = -1,
                length = entries ? entries.length : 0;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the hash.
           *
           * @private
           * @name clear
           * @memberOf Hash
           */


          function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
          }
          /**
           * Removes `key` and its value from the hash.
           *
           * @private
           * @name delete
           * @memberOf Hash
           * @param {Object} hash The hash to modify.
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */


          function hashDelete(key) {
            return this.has(key) && delete this.__data__[key];
          }
          /**
           * Gets the hash value for `key`.
           *
           * @private
           * @name get
           * @memberOf Hash
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */


          function hashGet(key) {
            var data = this.__data__;

            if (nativeCreate) {
              var result = data[key];
              return result === HASH_UNDEFINED ? undefined : result;
            }

            return hasOwnProperty.call(data, key) ? data[key] : undefined;
          }
          /**
           * Checks if a hash value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf Hash
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */


          function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
          }
          /**
           * Sets the hash `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf Hash
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the hash instance.
           */


          function hashSet(key, value) {
            var data = this.__data__;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
          } // Add methods to `Hash`.


          Hash.prototype.clear = hashClear;
          Hash.prototype['delete'] = hashDelete;
          Hash.prototype.get = hashGet;
          Hash.prototype.has = hashHas;
          Hash.prototype.set = hashSet;
          /**
           * Creates an list cache object.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */

          function ListCache(entries) {
            var index = -1,
                length = entries ? entries.length : 0;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the list cache.
           *
           * @private
           * @name clear
           * @memberOf ListCache
           */


          function listCacheClear() {
            this.__data__ = [];
          }
          /**
           * Removes `key` and its value from the list cache.
           *
           * @private
           * @name delete
           * @memberOf ListCache
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */


          function listCacheDelete(key) {
            var data = this.__data__,
                index = assocIndexOf(data, key);

            if (index < 0) {
              return false;
            }

            var lastIndex = data.length - 1;

            if (index == lastIndex) {
              data.pop();
            } else {
              splice.call(data, index, 1);
            }

            return true;
          }
          /**
           * Gets the list cache value for `key`.
           *
           * @private
           * @name get
           * @memberOf ListCache
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */


          function listCacheGet(key) {
            var data = this.__data__,
                index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
          }
          /**
           * Checks if a list cache value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf ListCache
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */


          function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
          }
          /**
           * Sets the list cache `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf ListCache
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the list cache instance.
           */


          function listCacheSet(key, value) {
            var data = this.__data__,
                index = assocIndexOf(data, key);

            if (index < 0) {
              data.push([key, value]);
            } else {
              data[index][1] = value;
            }

            return this;
          } // Add methods to `ListCache`.


          ListCache.prototype.clear = listCacheClear;
          ListCache.prototype['delete'] = listCacheDelete;
          ListCache.prototype.get = listCacheGet;
          ListCache.prototype.has = listCacheHas;
          ListCache.prototype.set = listCacheSet;
          /**
           * Creates a map cache object to store key-value pairs.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */

          function MapCache(entries) {
            var index = -1,
                length = entries ? entries.length : 0;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the map.
           *
           * @private
           * @name clear
           * @memberOf MapCache
           */


          function mapCacheClear() {
            this.__data__ = {
              'hash': new Hash(),
              'map': new (Map || ListCache)(),
              'string': new Hash()
            };
          }
          /**
           * Removes `key` and its value from the map.
           *
           * @private
           * @name delete
           * @memberOf MapCache
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */


          function mapCacheDelete(key) {
            return getMapData(this, key)['delete'](key);
          }
          /**
           * Gets the map value for `key`.
           *
           * @private
           * @name get
           * @memberOf MapCache
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */


          function mapCacheGet(key) {
            return getMapData(this, key).get(key);
          }
          /**
           * Checks if a map value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf MapCache
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */


          function mapCacheHas(key) {
            return getMapData(this, key).has(key);
          }
          /**
           * Sets the map `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf MapCache
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the map cache instance.
           */


          function mapCacheSet(key, value) {
            getMapData(this, key).set(key, value);
            return this;
          } // Add methods to `MapCache`.


          MapCache.prototype.clear = mapCacheClear;
          MapCache.prototype['delete'] = mapCacheDelete;
          MapCache.prototype.get = mapCacheGet;
          MapCache.prototype.has = mapCacheHas;
          MapCache.prototype.set = mapCacheSet;
          /**
           * Gets the index at which the `key` is found in `array` of key-value pairs.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} key The key to search for.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */

          function assocIndexOf(array, key) {
            var length = array.length;

            while (length--) {
              if (eq(array[length][0], key)) {
                return length;
              }
            }

            return -1;
          }
          /**
           * The base implementation of `_.get` without support for default values.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {Array|string} path The path of the property to get.
           * @returns {*} Returns the resolved value.
           */


          function baseGet(object, path) {
            path = isKey(path, object) ? [path] : castPath(path);
            var index = 0,
                length = path.length;

            while (object != null && index < length) {
              object = object[toKey(path[index++])];
            }

            return index && index == length ? object : undefined;
          }
          /**
           * The base implementation of `_.isNative` without bad shim checks.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a native function,
           *  else `false`.
           */


          function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) {
              return false;
            }

            var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
          }
          /**
           * The base implementation of `_.toString` which doesn't convert nullish
           * values to empty strings.
           *
           * @private
           * @param {*} value The value to process.
           * @returns {string} Returns the string.
           */


          function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') {
              return value;
            }

            if (isSymbol(value)) {
              return symbolToString ? symbolToString.call(value) : '';
            }

            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
          }
          /**
           * Casts `value` to a path array if it's not one.
           *
           * @private
           * @param {*} value The value to inspect.
           * @returns {Array} Returns the cast property path array.
           */


          function castPath(value) {
            return isArray(value) ? value : stringToPath(value);
          }
          /**
           * Gets the data for `map`.
           *
           * @private
           * @param {Object} map The map to query.
           * @param {string} key The reference key.
           * @returns {*} Returns the map data.
           */


          function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
          }
          /**
           * Gets the native function at `key` of `object`.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {string} key The key of the method to get.
           * @returns {*} Returns the function if it's native, else `undefined`.
           */


          function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
          }
          /**
           * Checks if `value` is a property name and not a property path.
           *
           * @private
           * @param {*} value The value to check.
           * @param {Object} [object] The object to query keys on.
           * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
           */


          function isKey(value, object) {
            if (isArray(value)) {
              return false;
            }

            var type = _typeof2(value);

            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
              return true;
            }

            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
          }
          /**
           * Checks if `value` is suitable for use as unique object key.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
           */


          function isKeyable(value) {
            var type = _typeof2(value);

            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
          }
          /**
           * Checks if `func` has its source masked.
           *
           * @private
           * @param {Function} func The function to check.
           * @returns {boolean} Returns `true` if `func` is masked, else `false`.
           */


          function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
          }
          /**
           * Converts `string` to a property path array.
           *
           * @private
           * @param {string} string The string to convert.
           * @returns {Array} Returns the property path array.
           */


          var stringToPath = memoize(function (string) {
            string = toString(string);
            var result = [];

            if (reLeadingDot.test(string)) {
              result.push('');
            }

            string.replace(rePropName, function (match, number, quote, string) {
              result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
          });
          /**
           * Converts `value` to a string key if it's not a string or symbol.
           *
           * @private
           * @param {*} value The value to inspect.
           * @returns {string|symbol} Returns the key.
           */

          function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) {
              return value;
            }

            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
          }
          /**
           * Converts `func` to its source code.
           *
           * @private
           * @param {Function} func The function to process.
           * @returns {string} Returns the source code.
           */


          function toSource(func) {
            if (func != null) {
              try {
                return funcToString.call(func);
              } catch (e) {}

              try {
                return func + '';
              } catch (e) {}
            }

            return '';
          }
          /**
           * Creates a function that memoizes the result of `func`. If `resolver` is
           * provided, it determines the cache key for storing the result based on the
           * arguments provided to the memoized function. By default, the first argument
           * provided to the memoized function is used as the map cache key. The `func`
           * is invoked with the `this` binding of the memoized function.
           *
           * **Note:** The cache is exposed as the `cache` property on the memoized
           * function. Its creation may be customized by replacing the `_.memoize.Cache`
           * constructor with one whose instances implement the
           * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
           * method interface of `delete`, `get`, `has`, and `set`.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Function
           * @param {Function} func The function to have its output memoized.
           * @param {Function} [resolver] The function to resolve the cache key.
           * @returns {Function} Returns the new memoized function.
           * @example
           *
           * var object = { 'a': 1, 'b': 2 };
           * var other = { 'c': 3, 'd': 4 };
           *
           * var values = _.memoize(_.values);
           * values(object);
           * // => [1, 2]
           *
           * values(other);
           * // => [3, 4]
           *
           * object.a = 2;
           * values(object);
           * // => [1, 2]
           *
           * // Modify the result cache.
           * values.cache.set(object, ['a', 'b']);
           * values(object);
           * // => ['a', 'b']
           *
           * // Replace `_.memoize.Cache`.
           * _.memoize.Cache = WeakMap;
           */


          function memoize(func, resolver) {
            if (typeof func != 'function' || resolver && typeof resolver != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }

            var memoized = function memoized() {
              var args = arguments,
                  key = resolver ? resolver.apply(this, args) : args[0],
                  cache = memoized.cache;

              if (cache.has(key)) {
                return cache.get(key);
              }

              var result = func.apply(this, args);
              memoized.cache = cache.set(key, result);
              return result;
            };

            memoized.cache = new (memoize.Cache || MapCache)();
            return memoized;
          } // Assign cache to `_.memoize`.


          memoize.Cache = MapCache;
          /**
           * Performs a
           * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
           * comparison between two values to determine if they are equivalent.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to compare.
           * @param {*} other The other value to compare.
           * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
           * @example
           *
           * var object = { 'a': 1 };
           * var other = { 'a': 1 };
           *
           * _.eq(object, object);
           * // => true
           *
           * _.eq(object, other);
           * // => false
           *
           * _.eq('a', 'a');
           * // => true
           *
           * _.eq('a', Object('a'));
           * // => false
           *
           * _.eq(NaN, NaN);
           * // => true
           */

          function eq(value, other) {
            return value === other || value !== value && other !== other;
          }
          /**
           * Checks if `value` is classified as an `Array` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an array, else `false`.
           * @example
           *
           * _.isArray([1, 2, 3]);
           * // => true
           *
           * _.isArray(document.body.children);
           * // => false
           *
           * _.isArray('abc');
           * // => false
           *
           * _.isArray(_.noop);
           * // => false
           */


          var isArray = Array.isArray;
          /**
           * Checks if `value` is classified as a `Function` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a function, else `false`.
           * @example
           *
           * _.isFunction(_);
           * // => true
           *
           * _.isFunction(/abc/);
           * // => false
           */

          function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 8-9 which returns 'object' for typed array and other constructors.
            var tag = isObject(value) ? objectToString.call(value) : '';
            return tag == funcTag || tag == genTag;
          }
          /**
           * Checks if `value` is the
           * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
           * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an object, else `false`.
           * @example
           *
           * _.isObject({});
           * // => true
           *
           * _.isObject([1, 2, 3]);
           * // => true
           *
           * _.isObject(_.noop);
           * // => true
           *
           * _.isObject(null);
           * // => false
           */


          function isObject(value) {
            var type = _typeof2(value);

            return !!value && (type == 'object' || type == 'function');
          }
          /**
           * Checks if `value` is object-like. A value is object-like if it's not `null`
           * and has a `typeof` result of "object".
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
           * @example
           *
           * _.isObjectLike({});
           * // => true
           *
           * _.isObjectLike([1, 2, 3]);
           * // => true
           *
           * _.isObjectLike(_.noop);
           * // => false
           *
           * _.isObjectLike(null);
           * // => false
           */


          function isObjectLike(value) {
            return !!value && _typeof2(value) == 'object';
          }
          /**
           * Checks if `value` is classified as a `Symbol` primitive or object.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
           * @example
           *
           * _.isSymbol(Symbol.iterator);
           * // => true
           *
           * _.isSymbol('abc');
           * // => false
           */


          function isSymbol(value) {
            return _typeof2(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
          }
          /**
           * Converts `value` to a string. An empty string is returned for `null`
           * and `undefined` values. The sign of `-0` is preserved.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to process.
           * @returns {string} Returns the string.
           * @example
           *
           * _.toString(null);
           * // => ''
           *
           * _.toString(-0);
           * // => '-0'
           *
           * _.toString([1, 2, 3]);
           * // => '1,2,3'
           */


          function toString(value) {
            return value == null ? '' : baseToString(value);
          }
          /**
           * Gets the value at `path` of `object`. If the resolved value is
           * `undefined`, the `defaultValue` is returned in its place.
           *
           * @static
           * @memberOf _
           * @since 3.7.0
           * @category Object
           * @param {Object} object The object to query.
           * @param {Array|string} path The path of the property to get.
           * @param {*} [defaultValue] The value returned for `undefined` resolved values.
           * @returns {*} Returns the resolved value.
           * @example
           *
           * var object = { 'a': [{ 'b': { 'c': 3 } }] };
           *
           * _.get(object, 'a[0].b.c');
           * // => 3
           *
           * _.get(object, ['a', '0', 'b', 'c']);
           * // => 3
           *
           * _.get(object, 'a.b.c', 'default');
           * // => 'default'
           */


          function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
          }

          module.exports = get;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));
        /***/
      },

      /***/
      "c8ba":
      /***/
      function c8ba(module, exports) {
        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if ((typeof window === "undefined" ? "undefined" : _typeof2(window)) === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },

      /***/
      "c975":
      /***/
      function c975(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var $indexOf = __webpack_require__("4d64").indexOf;

        var arrayMethodIsStrict = __webpack_require__("a640");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var nativeIndexOf = [].indexOf;
        var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
        var STRICT_METHOD = arrayMethodIsStrict('indexOf');
        var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', {
          ACCESSORS: true,
          1: 0
        }); // `Array.prototype.indexOf` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.indexof

        $({
          target: 'Array',
          proto: true,
          forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH
        }, {
          indexOf: function indexOf(searchElement
          /* , fromIndex = 0 */
          ) {
            return NEGATIVE_ZERO // convert -0 to +0
            ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "ca84":
      /***/
      function ca84(module, exports, __webpack_require__) {
        var has = __webpack_require__("5135");

        var toIndexedObject = __webpack_require__("fc6a");

        var indexOf = __webpack_require__("4d64").indexOf;

        var hiddenKeys = __webpack_require__("d012");

        module.exports = function (object, names) {
          var O = toIndexedObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            !has(hiddenKeys, key) && has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~indexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "cc12":
      /***/
      function cc12(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var isObject = __webpack_require__("861d");

        var document = global.document; // typeof document.createElement is 'object' in old IE

        var EXISTS = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return EXISTS ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "cca6":
      /***/
      function cca6(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var assign = __webpack_require__("60da"); // `Object.assign` method
        // https://tc39.github.io/ecma262/#sec-object.assign


        $({
          target: 'Object',
          stat: true,
          forced: Object.assign !== assign
        }, {
          assign: assign
        });
        /***/
      },

      /***/
      "ce4e":
      /***/
      function ce4e(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var createNonEnumerableProperty = __webpack_require__("9112");

        module.exports = function (key, value) {
          try {
            createNonEnumerableProperty(global, key, value);
          } catch (error) {
            global[key] = value;
          }

          return value;
        };
        /***/

      },

      /***/
      "d012":
      /***/
      function d012(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "d039":
      /***/
      function d039(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (error) {
            return true;
          }
        };
        /***/

      },

      /***/
      "d066":
      /***/
      function d066(module, exports, __webpack_require__) {
        var path = __webpack_require__("428f");

        var global = __webpack_require__("da84");

        var aFunction = function aFunction(variable) {
          return typeof variable == 'function' ? variable : undefined;
        };

        module.exports = function (namespace, method) {
          return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
        };
        /***/

      },

      /***/
      "d1e7":
      /***/
      function d1e7(module, exports, __webpack_require__) {
        "use strict";

        var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

        var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
          1: 2
        }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable

        exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
          var descriptor = getOwnPropertyDescriptor(this, V);
          return !!descriptor && descriptor.enumerable;
        } : nativePropertyIsEnumerable;
        /***/
      },

      /***/
      "d28b":
      /***/
      function d28b(module, exports, __webpack_require__) {
        var defineWellKnownSymbol = __webpack_require__("746f"); // `Symbol.iterator` well-known symbol
        // https://tc39.github.io/ecma262/#sec-symbol.iterator


        defineWellKnownSymbol('iterator');
        /***/
      },

      /***/
      "d2bb":
      /***/
      function d2bb(module, exports, __webpack_require__) {
        var anObject = __webpack_require__("825a");

        var aPossiblePrototype = __webpack_require__("3bbe"); // `Object.setPrototypeOf` method
        // https://tc39.github.io/ecma262/#sec-object.setprototypeof
        // Works with __proto__ only. Old v8 can't work with null proto objects.

        /* eslint-disable no-proto */


        module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
          var CORRECT_SETTER = false;
          var test = {};
          var setter;

          try {
            setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
            setter.call(test, []);
            CORRECT_SETTER = test instanceof Array;
          } catch (error) {
            /* empty */
          }

          return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
            return O;
          };
        }() : undefined);
        /***/
      },

      /***/
      "d3b7":
      /***/
      function d3b7(module, exports, __webpack_require__) {
        var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");

        var redefine = __webpack_require__("6eeb");

        var toString = __webpack_require__("b041"); // `Object.prototype.toString` method
        // https://tc39.github.io/ecma262/#sec-object.prototype.tostring


        if (!TO_STRING_TAG_SUPPORT) {
          redefine(Object.prototype, 'toString', toString, {
            unsafe: true
          });
        }
        /***/

      },

      /***/
      "d44e":
      /***/
      function d44e(module, exports, __webpack_require__) {
        var defineProperty = __webpack_require__("9bf2").f;

        var has = __webpack_require__("5135");

        var wellKnownSymbol = __webpack_require__("b622");

        var TO_STRING_TAG = wellKnownSymbol('toStringTag');

        module.exports = function (it, TAG, STATIC) {
          if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
            defineProperty(it, TO_STRING_TAG, {
              configurable: true,
              value: TAG
            });
          }
        };
        /***/

      },

      /***/
      "d58f":
      /***/
      function d58f(module, exports, __webpack_require__) {
        var aFunction = __webpack_require__("1c0b");

        var toObject = __webpack_require__("7b0b");

        var IndexedObject = __webpack_require__("44ad");

        var toLength = __webpack_require__("50c4"); // `Array.prototype.{ reduce, reduceRight }` methods implementation


        var createMethod = function createMethod(IS_RIGHT) {
          return function (that, callbackfn, argumentsLength, memo) {
            aFunction(callbackfn);
            var O = toObject(that);
            var self = IndexedObject(O);
            var length = toLength(O.length);
            var index = IS_RIGHT ? length - 1 : 0;
            var i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) while (true) {
              if (index in self) {
                memo = self[index];
                index += i;
                break;
              }

              index += i;

              if (IS_RIGHT ? index < 0 : length <= index) {
                throw TypeError('Reduce of empty array with no initial value');
              }
            }

            for (; IS_RIGHT ? index >= 0 : length > index; index += i) {
              if (index in self) {
                memo = callbackfn(memo, self[index], index, O);
              }
            }

            return memo;
          };
        };

        module.exports = {
          // `Array.prototype.reduce` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
          left: createMethod(false),
          // `Array.prototype.reduceRight` method
          // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
          right: createMethod(true)
        };
        /***/
      },

      /***/
      "d784":
      /***/
      function d784(module, exports, __webpack_require__) {
        "use strict"; // TODO: Remove from `core-js@4` since it's moved to entry points

        __webpack_require__("ac1f");

        var redefine = __webpack_require__("6eeb");

        var fails = __webpack_require__("d039");

        var wellKnownSymbol = __webpack_require__("b622");

        var regexpExec = __webpack_require__("9263");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var SPECIES = wellKnownSymbol('species');
        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
          // #replace needs built-in support for named groups.
          // #match works fine because it just return the exec results, even if it has
          // a "grops" property.
          var re = /./;

          re.exec = function () {
            var result = [];
            result.groups = {
              a: '7'
            };
            return result;
          };

          return ''.replace(re, '$<a>') !== '7';
        }); // IE <= 11 replaces $0 with the whole match, as if it was $&
        // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0

        var REPLACE_KEEPS_$0 = function () {
          return 'a'.replace(/./, '$0') === '$0';
        }();

        var REPLACE = wellKnownSymbol('replace'); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string

        var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
          if (/./[REPLACE]) {
            return /./[REPLACE]('a', '$0') === '';
          }

          return false;
        }(); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        // Weex JS has frozen built-in prototypes, so use try / catch wrapper


        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
          var re = /(?:)/;
          var originalExec = re.exec;

          re.exec = function () {
            return originalExec.apply(this, arguments);
          };

          var result = 'ab'.split(re);
          return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
        });

        module.exports = function (KEY, length, exec, sham) {
          var SYMBOL = wellKnownSymbol(KEY);
          var DELEGATES_TO_SYMBOL = !fails(function () {
            // String methods call symbol-named RegEp methods
            var O = {};

            O[SYMBOL] = function () {
              return 7;
            };

            return ''[KEY](O) != 7;
          });
          var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;

            if (KEY === 'split') {
              // We can't use real regex here since it causes deoptimization
              // and serious performance degradation in V8
              // https://github.com/zloirock/core-js/issues/306
              re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
              // a new one. We need to return the patched regex when creating the new one.

              re.constructor = {};

              re.constructor[SPECIES] = function () {
                return re;
              };

              re.flags = '';
              re[SYMBOL] = /./[SYMBOL];
            }

            re.exec = function () {
              execCalled = true;
              return null;
            };

            re[SYMBOL]('');
            return !execCalled;
          });

          if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
              if (regexp.exec === regexpExec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  // The native String method already delegates to @@method (this
                  // polyfilled function), leasing to infinite recursion.
                  // We avoid it by directly calling the native @@method method.
                  return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                  };
                }

                return {
                  done: true,
                  value: nativeMethod.call(str, regexp, arg2)
                };
              }

              return {
                done: false
              };
            }, {
              REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
            });
            var stringMethod = methods[0];
            var regexMethod = methods[1];
            redefine(String.prototype, KEY, stringMethod);
            redefine(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
            // 21.2.5.11 RegExp.prototype[@@split](string, limit)
            ? function (string, arg) {
              return regexMethod.call(string, this, arg);
            } // 21.2.5.6 RegExp.prototype[@@match](string)
            // 21.2.5.9 RegExp.prototype[@@search](string)
            : function (string) {
              return regexMethod.call(string, this);
            });
          }

          if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
        };
        /***/

      },

      /***/
      "d81d":
      /***/
      function d81d(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var $map = __webpack_require__("b727").map;

        var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map'); // FF49- issue

        var USES_TO_LENGTH = arrayMethodUsesToLength('map'); // `Array.prototype.map` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.map
        // with adding support of @@species

        $({
          target: 'Array',
          proto: true,
          forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
        }, {
          map: function map(callbackfn
          /* , thisArg */
          ) {
            return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "da84":
      /***/
      function da84(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          var check = function check(it) {
            return it && it.Math == Math && it;
          }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


          module.exports = // eslint-disable-next-line no-undef
          check((typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) == 'object' && globalThis) || check((typeof window === "undefined" ? "undefined" : _typeof2(window)) == 'object' && window) || check((typeof self === "undefined" ? "undefined" : _typeof2(self)) == 'object' && self) || check(_typeof2(global) == 'object' && global) || // eslint-disable-next-line no-new-func
          Function('return this')();
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));
        /***/
      },

      /***/
      "dbb4":
      /***/
      function dbb4(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var DESCRIPTORS = __webpack_require__("83ab");

        var ownKeys = __webpack_require__("56ef");

        var toIndexedObject = __webpack_require__("fc6a");

        var getOwnPropertyDescriptorModule = __webpack_require__("06cf");

        var createProperty = __webpack_require__("8418"); // `Object.getOwnPropertyDescriptors` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors


        $({
          target: 'Object',
          stat: true,
          sham: !DESCRIPTORS
        }, {
          getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
            var O = toIndexedObject(object);
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            var keys = ownKeys(O);
            var result = {};
            var index = 0;
            var key, descriptor;

            while (keys.length > index) {
              descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
              if (descriptor !== undefined) createProperty(result, key, descriptor);
            }

            return result;
          }
        });
        /***/
      },

      /***/
      "ddb0":
      /***/
      function ddb0(module, exports, __webpack_require__) {
        var global = __webpack_require__("da84");

        var DOMIterables = __webpack_require__("fdbc");

        var ArrayIteratorMethods = __webpack_require__("e260");

        var createNonEnumerableProperty = __webpack_require__("9112");

        var wellKnownSymbol = __webpack_require__("b622");

        var ITERATOR = wellKnownSymbol('iterator');
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var ArrayValues = ArrayIteratorMethods.values;

        for (var COLLECTION_NAME in DOMIterables) {
          var Collection = global[COLLECTION_NAME];
          var CollectionPrototype = Collection && Collection.prototype;

          if (CollectionPrototype) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
              createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
            } catch (error) {
              CollectionPrototype[ITERATOR] = ArrayValues;
            }

            if (!CollectionPrototype[TO_STRING_TAG]) {
              createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
            }

            if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
              // some Chrome versions have non-configurable methods on DOMTokenList
              if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
              } catch (error) {
                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
              }
            }
          }
        }
        /***/

      },

      /***/
      "df75":
      /***/
      function df75(module, exports, __webpack_require__) {
        var internalObjectKeys = __webpack_require__("ca84");

        var enumBugKeys = __webpack_require__("7839"); // `Object.keys` method
        // https://tc39.github.io/ecma262/#sec-object.keys


        module.exports = Object.keys || function keys(O) {
          return internalObjectKeys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "e01a":
      /***/
      function e01a(module, exports, __webpack_require__) {
        "use strict"; // `Symbol.prototype.description` getter
        // https://tc39.github.io/ecma262/#sec-symbol.prototype.description

        var $ = __webpack_require__("23e7");

        var DESCRIPTORS = __webpack_require__("83ab");

        var global = __webpack_require__("da84");

        var has = __webpack_require__("5135");

        var isObject = __webpack_require__("861d");

        var defineProperty = __webpack_require__("9bf2").f;

        var copyConstructorProperties = __webpack_require__("e893");

        var NativeSymbol = global.Symbol;

        if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) || // Safari 12 bug
        NativeSymbol().description !== undefined)) {
          var EmptyStringDescriptionStore = {}; // wrap Symbol constructor for correct work with undefined description

          var SymbolWrapper = function _Symbol6() {
            var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
            var result = this instanceof SymbolWrapper ? new NativeSymbol(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
            : description === undefined ? NativeSymbol() : NativeSymbol(description);
            if (description === '') EmptyStringDescriptionStore[result] = true;
            return result;
          };

          copyConstructorProperties(SymbolWrapper, NativeSymbol);
          var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
          symbolPrototype.constructor = SymbolWrapper;
          var symbolToString = symbolPrototype.toString;

          var _native = String(NativeSymbol('test')) == 'Symbol(test)';

          var regexp = /^Symbol\((.*)\)[^)]+$/;
          defineProperty(symbolPrototype, 'description', {
            configurable: true,
            get: function description() {
              var symbol = isObject(this) ? this.valueOf() : this;
              var string = symbolToString.call(symbol);
              if (has(EmptyStringDescriptionStore, symbol)) return '';
              var desc = _native ? string.slice(7, -1) : string.replace(regexp, '$1');
              return desc === '' ? undefined : desc;
            }
          });
          $({
            global: true,
            forced: true
          }, {
            Symbol: SymbolWrapper
          });
        }
        /***/

      },

      /***/
      "e163":
      /***/
      function e163(module, exports, __webpack_require__) {
        var has = __webpack_require__("5135");

        var toObject = __webpack_require__("7b0b");

        var sharedKey = __webpack_require__("f772");

        var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

        var IE_PROTO = sharedKey('IE_PROTO');
        var ObjectPrototype = Object.prototype; // `Object.getPrototypeOf` method
        // https://tc39.github.io/ecma262/#sec-object.getprototypeof

        module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectPrototype : null;
        };
        /***/
      },

      /***/
      "e177":
      /***/
      function e177(module, exports, __webpack_require__) {
        var fails = __webpack_require__("d039");

        module.exports = !fails(function () {
          function F() {
            /* empty */
          }

          F.prototype.constructor = null;
          return Object.getPrototypeOf(new F()) !== F.prototype;
        });
        /***/
      },

      /***/
      "e260":
      /***/
      function e260(module, exports, __webpack_require__) {
        "use strict";

        var toIndexedObject = __webpack_require__("fc6a");

        var addToUnscopables = __webpack_require__("44d2");

        var Iterators = __webpack_require__("3f8c");

        var InternalStateModule = __webpack_require__("69f3");

        var defineIterator = __webpack_require__("7dd0");

        var ARRAY_ITERATOR = 'Array Iterator';
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.entries
        // `Array.prototype.keys` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.keys
        // `Array.prototype.values` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.values
        // `Array.prototype[@@iterator]` method
        // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
        // `CreateArrayIterator` internal method
        // https://tc39.github.io/ecma262/#sec-createarrayiterator

        module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
          setInternalState(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated),
            // target
            index: 0,
            // next index
            kind: kind // kind

          }); // `%ArrayIteratorPrototype%.next` method
          // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
        }, function () {
          var state = getInternalState(this);
          var target = state.target;
          var kind = state.kind;
          var index = state.index++;

          if (!target || index >= target.length) {
            state.target = undefined;
            return {
              value: undefined,
              done: true
            };
          }

          if (kind == 'keys') return {
            value: index,
            done: false
          };
          if (kind == 'values') return {
            value: target[index],
            done: false
          };
          return {
            value: [index, target[index]],
            done: false
          };
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
        // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
        // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject

        Iterators.Arguments = Iterators.Array; // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "e439":
      /***/
      function e439(module, exports, __webpack_require__) {
        var $ = __webpack_require__("23e7");

        var fails = __webpack_require__("d039");

        var toIndexedObject = __webpack_require__("fc6a");

        var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;

        var DESCRIPTORS = __webpack_require__("83ab");

        var FAILS_ON_PRIMITIVES = fails(function () {
          nativeGetOwnPropertyDescriptor(1);
        });
        var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES; // `Object.getOwnPropertyDescriptor` method
        // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor

        $({
          target: 'Object',
          stat: true,
          forced: FORCED,
          sham: !DESCRIPTORS
        }, {
          getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
            return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
          }
        });
        /***/
      },

      /***/
      "e538":
      /***/
      function e538(module, exports, __webpack_require__) {
        var wellKnownSymbol = __webpack_require__("b622");

        exports.f = wellKnownSymbol;
        /***/
      },

      /***/
      "e893":
      /***/
      function e893(module, exports, __webpack_require__) {
        var has = __webpack_require__("5135");

        var ownKeys = __webpack_require__("56ef");

        var getOwnPropertyDescriptorModule = __webpack_require__("06cf");

        var definePropertyModule = __webpack_require__("9bf2");

        module.exports = function (target, source) {
          var keys = ownKeys(source);
          var defineProperty = definePropertyModule.f;
          var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
          }
        };
        /***/

      },

      /***/
      "e8b5":
      /***/
      function e8b5(module, exports, __webpack_require__) {
        var classof = __webpack_require__("c6b6"); // `IsArray` abstract operation
        // https://tc39.github.io/ecma262/#sec-isarray


        module.exports = Array.isArray || function isArray(arg) {
          return classof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "e95a":
      /***/
      function e95a(module, exports, __webpack_require__) {
        var wellKnownSymbol = __webpack_require__("b622");

        var Iterators = __webpack_require__("3f8c");

        var ITERATOR = wellKnownSymbol('iterator');
        var ArrayPrototype = Array.prototype; // check on default Array iterator

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "eaf9":
      /***/
      function eaf9(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3b81");
        /* harmony import */


        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
        /* unused harmony reexport * */

        /* unused harmony default export */


        var _unused_webpack_default_export = _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a;
        /***/
      },

      /***/
      "f013":
      /***/
      function f013(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdb2");
        /* harmony import */


        var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
        /* unused harmony reexport * */

        /* unused harmony default export */


        var _unused_webpack_default_export = _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a;
        /***/
      },

      /***/
      "f5df":
      /***/
      function f5df(module, exports, __webpack_require__) {
        var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");

        var classofRaw = __webpack_require__("c6b6");

        var wellKnownSymbol = __webpack_require__("b622");

        var TO_STRING_TAG = wellKnownSymbol('toStringTag'); // ES3 wrong here

        var CORRECT_ARGUMENTS = classofRaw(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (error) {
            /* empty */
          }
        }; // getting tag from ES6+ `Object.prototype.toString`


        module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
          var O, tag, result;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag // builtinTag case
          : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
          : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
        };
        /***/
      },

      /***/
      "f6fd":
      /***/
      function f6fd(module, exports) {
        // document.currentScript polyfill by Adam Miller
        // MIT license
        (function (document) {
          var currentScript = "currentScript",
              scripts = document.getElementsByTagName('script'); // Live NodeList collection
          // If browser needs currentScript polyfill, add get currentScript() to the document object

          if (!(currentScript in document)) {
            Object.defineProperty(document, currentScript, {
              get: function get() {
                // IE 6-10 supports script readyState
                // IE 10+ support stack trace
                try {
                  throw new Error();
                } catch (err) {
                  // Find the second match for the "at" string to get file src url from stack.
                  // Specifically works with the format of stack traces in IE.
                  var i,
                      res = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(err.stack) || [false])[1]; // For all scripts on the page, if src matches or if ready state is interactive, return the script tag

                  for (i in scripts) {
                    if (scripts[i].src == res || scripts[i].readyState == "interactive") {
                      return scripts[i];
                    }
                  } // If no match, return null


                  return null;
                }
              }
            });
          }
        })(document);
        /***/

      },

      /***/
      "f772":
      /***/
      function f772(module, exports, __webpack_require__) {
        var shared = __webpack_require__("5692");

        var uid = __webpack_require__("90e3");

        var keys = shared('keys');

        module.exports = function (key) {
          return keys[key] || (keys[key] = uid(key));
        };
        /***/

      },

      /***/
      "f7fe":
      /***/
      function f7fe(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /**
          * lodash (Custom Build) <https://lodash.com/>
          * Build: `lodash modularize exports="npm" -o ./`
          * Copyright jQuery Foundation and other contributors <https://jquery.org/>
          * Released under MIT license <https://lodash.com/license>
          * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
          * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
          */

          /** Used as the `TypeError` message for "Functions" methods. */
          var FUNC_ERROR_TEXT = 'Expected a function';
          /** Used as references for various `Number` constants. */

          var NAN = 0 / 0;
          /** `Object#toString` result references. */

          var symbolTag = '[object Symbol]';
          /** Used to match leading and trailing whitespace. */

          var reTrim = /^\s+|\s+$/g;
          /** Used to detect bad signed hexadecimal string values. */

          var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
          /** Used to detect binary string values. */

          var reIsBinary = /^0b[01]+$/i;
          /** Used to detect octal string values. */

          var reIsOctal = /^0o[0-7]+$/i;
          /** Built-in method references without a dependency on `root`. */

          var freeParseInt = parseInt;
          /** Detect free variable `global` from Node.js. */

          var freeGlobal = _typeof2(global) == 'object' && global && global.Object === Object && global;
          /** Detect free variable `self`. */

          var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof2(self)) == 'object' && self && self.Object === Object && self;
          /** Used as a reference to the global object. */

          var root = freeGlobal || freeSelf || Function('return this')();
          /** Used for built-in method references. */

          var objectProto = Object.prototype;
          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */

          var objectToString = objectProto.toString;
          /* Built-in method references for those with the same name as other `lodash` methods. */

          var nativeMax = Math.max,
              nativeMin = Math.min;
          /**
           * Gets the timestamp of the number of milliseconds that have elapsed since
           * the Unix epoch (1 January 1970 00:00:00 UTC).
           *
           * @static
           * @memberOf _
           * @since 2.4.0
           * @category Date
           * @returns {number} Returns the timestamp.
           * @example
           *
           * _.defer(function(stamp) {
           *   console.log(_.now() - stamp);
           * }, _.now());
           * // => Logs the number of milliseconds it took for the deferred invocation.
           */

          var now = function now() {
            return root.Date.now();
          };
          /**
           * Creates a debounced function that delays invoking `func` until after `wait`
           * milliseconds have elapsed since the last time the debounced function was
           * invoked. The debounced function comes with a `cancel` method to cancel
           * delayed `func` invocations and a `flush` method to immediately invoke them.
           * Provide `options` to indicate whether `func` should be invoked on the
           * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
           * with the last arguments provided to the debounced function. Subsequent
           * calls to the debounced function return the result of the last `func`
           * invocation.
           *
           * **Note:** If `leading` and `trailing` options are `true`, `func` is
           * invoked on the trailing edge of the timeout only if the debounced function
           * is invoked more than once during the `wait` timeout.
           *
           * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
           * until to the next tick, similar to `setTimeout` with a timeout of `0`.
           *
           * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
           * for details over the differences between `_.debounce` and `_.throttle`.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Function
           * @param {Function} func The function to debounce.
           * @param {number} [wait=0] The number of milliseconds to delay.
           * @param {Object} [options={}] The options object.
           * @param {boolean} [options.leading=false]
           *  Specify invoking on the leading edge of the timeout.
           * @param {number} [options.maxWait]
           *  The maximum time `func` is allowed to be delayed before it's invoked.
           * @param {boolean} [options.trailing=true]
           *  Specify invoking on the trailing edge of the timeout.
           * @returns {Function} Returns the new debounced function.
           * @example
           *
           * // Avoid costly calculations while the window size is in flux.
           * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
           *
           * // Invoke `sendMail` when clicked, debouncing subsequent calls.
           * jQuery(element).on('click', _.debounce(sendMail, 300, {
           *   'leading': true,
           *   'trailing': false
           * }));
           *
           * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
           * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
           * var source = new EventSource('/stream');
           * jQuery(source).on('message', debounced);
           *
           * // Cancel the trailing debounced invocation.
           * jQuery(window).on('popstate', debounced.cancel);
           */


          function debounce(func, wait, options) {
            var lastArgs,
                lastThis,
                maxWait,
                result,
                timerId,
                lastCallTime,
                lastInvokeTime = 0,
                leading = false,
                maxing = false,
                trailing = true;

            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }

            wait = toNumber(wait) || 0;

            if (isObject(options)) {
              leading = !!options.leading;
              maxing = 'maxWait' in options;
              maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
              trailing = 'trailing' in options ? !!options.trailing : trailing;
            }

            function invokeFunc(time) {
              var args = lastArgs,
                  thisArg = lastThis;
              lastArgs = lastThis = undefined;
              lastInvokeTime = time;
              result = func.apply(thisArg, args);
              return result;
            }

            function leadingEdge(time) {
              // Reset any `maxWait` timer.
              lastInvokeTime = time; // Start the timer for the trailing edge.

              timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

              return leading ? invokeFunc(time) : result;
            }

            function remainingWait(time) {
              var timeSinceLastCall = time - lastCallTime,
                  timeSinceLastInvoke = time - lastInvokeTime,
                  result = wait - timeSinceLastCall;
              return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
            }

            function shouldInvoke(time) {
              var timeSinceLastCall = time - lastCallTime,
                  timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
              // trailing edge, the system time has gone backwards and we're treating
              // it as the trailing edge, or we've hit the `maxWait` limit.

              return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }

            function timerExpired() {
              var time = now();

              if (shouldInvoke(time)) {
                return trailingEdge(time);
              } // Restart the timer.


              timerId = setTimeout(timerExpired, remainingWait(time));
            }

            function trailingEdge(time) {
              timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
              // debounced at least once.

              if (trailing && lastArgs) {
                return invokeFunc(time);
              }

              lastArgs = lastThis = undefined;
              return result;
            }

            function cancel() {
              if (timerId !== undefined) {
                clearTimeout(timerId);
              }

              lastInvokeTime = 0;
              lastArgs = lastCallTime = lastThis = timerId = undefined;
            }

            function flush() {
              return timerId === undefined ? result : trailingEdge(now());
            }

            function debounced() {
              var time = now(),
                  isInvoking = shouldInvoke(time);
              lastArgs = arguments;
              lastThis = this;
              lastCallTime = time;

              if (isInvoking) {
                if (timerId === undefined) {
                  return leadingEdge(lastCallTime);
                }

                if (maxing) {
                  // Handle invocations in a tight loop.
                  timerId = setTimeout(timerExpired, wait);
                  return invokeFunc(lastCallTime);
                }
              }

              if (timerId === undefined) {
                timerId = setTimeout(timerExpired, wait);
              }

              return result;
            }

            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
          }
          /**
           * Checks if `value` is the
           * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
           * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an object, else `false`.
           * @example
           *
           * _.isObject({});
           * // => true
           *
           * _.isObject([1, 2, 3]);
           * // => true
           *
           * _.isObject(_.noop);
           * // => true
           *
           * _.isObject(null);
           * // => false
           */


          function isObject(value) {
            var type = _typeof2(value);

            return !!value && (type == 'object' || type == 'function');
          }
          /**
           * Checks if `value` is object-like. A value is object-like if it's not `null`
           * and has a `typeof` result of "object".
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
           * @example
           *
           * _.isObjectLike({});
           * // => true
           *
           * _.isObjectLike([1, 2, 3]);
           * // => true
           *
           * _.isObjectLike(_.noop);
           * // => false
           *
           * _.isObjectLike(null);
           * // => false
           */


          function isObjectLike(value) {
            return !!value && _typeof2(value) == 'object';
          }
          /**
           * Checks if `value` is classified as a `Symbol` primitive or object.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
           * @example
           *
           * _.isSymbol(Symbol.iterator);
           * // => true
           *
           * _.isSymbol('abc');
           * // => false
           */


          function isSymbol(value) {
            return _typeof2(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
          }
          /**
           * Converts `value` to a number.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to process.
           * @returns {number} Returns the number.
           * @example
           *
           * _.toNumber(3.2);
           * // => 3.2
           *
           * _.toNumber(Number.MIN_VALUE);
           * // => 5e-324
           *
           * _.toNumber(Infinity);
           * // => Infinity
           *
           * _.toNumber('3.2');
           * // => 3.2
           */


          function toNumber(value) {
            if (typeof value == 'number') {
              return value;
            }

            if (isSymbol(value)) {
              return NAN;
            }

            if (isObject(value)) {
              var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
              value = isObject(other) ? other + '' : other;
            }

            if (typeof value != 'string') {
              return value === 0 ? value : +value;
            }

            value = value.replace(reTrim, '');
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
          }

          module.exports = debounce;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__("c8ba"));
        /***/
      },

      /***/
      "fb15":
      /***/
      function fb15(module, __webpack_exports__, __webpack_require__) {
        "use strict"; // ESM COMPAT FLAG

        __webpack_require__.r(__webpack_exports__); // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
        // This file is imported into lib/wc client bundles.


        if (typeof window !== 'undefined') {
          if (true) {
            __webpack_require__("f6fd");
          }

          var setPublicPath_i;

          if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
            __webpack_require__.p = setPublicPath_i[1]; // eslint-disable-line
          }
        } // Indicate to webpack that this file can be concatenated

        /* harmony default export */


        var setPublicPath = null; // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js

        var es_array_filter = __webpack_require__("4de4"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js


        var es_array_for_each = __webpack_require__("4160"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js


        var es_array_join = __webpack_require__("a15b"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js


        var es_array_map = __webpack_require__("d81d"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js


        var es_array_slice = __webpack_require__("fb6a"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js


        var es_object_values = __webpack_require__("07ac"); // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js


        var web_dom_collections_for_each = __webpack_require__("159b"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js


        var es_symbol = __webpack_require__("a4d3"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js


        var es_object_get_own_property_descriptor = __webpack_require__("e439"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js


        var es_object_get_own_property_descriptors = __webpack_require__("dbb4"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js


        var es_object_keys = __webpack_require__("b64b"); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js


        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js


        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        } // EXTERNAL MODULE: ./node_modules/json2mq/index.js


        var json2mq = __webpack_require__("a48b");

        var json2mq_default = /*#__PURE__*/__webpack_require__.n(json2mq); // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/mixinPropsUpdated.vue?vue&type=script&lang=js&

        /* harmony default export */


        var mixinPropsUpdatedvue_type_script_lang_js_ = {
          computed: {
            isPropsUpdated: function isPropsUpdated() {
              var _this = this; // Read props that need to be listened for changes.


              Object.keys(this.$props).forEach(function (key) {
                return _this[key];
              }); // Return a different value each time. `Date.now()` is not guaranteed to be unique.
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties

              return this.updateSwitch = !this.updateSwitch;
            }
          },
          watch: {
            isPropsUpdated: function isPropsUpdated() {
              if (typeof this.onPropsUpdated === 'function') {
                this.onPropsUpdated();
              }
            }
          }
        }; // CONCATENATED MODULE: ./src/mixinPropsUpdated.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_mixinPropsUpdatedvue_type_script_lang_js_ = mixinPropsUpdatedvue_type_script_lang_js_; // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js

        /* globals __VUE_SSR_CONTEXT__ */
        // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
        // This module is a runtime utility for cleaner component module output and will
        // be included in the final webpack user bundle.

        function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier,
        /* server only */
        shadowMode
        /* vue-cli only */
        ) {
          // Vue.extend constructor export interop
          var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports; // render functions

          if (render) {
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            options._compiled = true;
          } // functional template


          if (functionalTemplate) {
            options.functional = true;
          } // scopedId


          if (scopeId) {
            options._scopeId = 'data-v-' + scopeId;
          }

          var hook;

          if (moduleIdentifier) {
            // server build
            hook = function hook(context) {
              // 2.3 injection
              context = context || // cached call
              this.$vnode && this.$vnode.ssrContext || // stateful
              this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
              // 2.2 with runInNewContext: true

              if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
              } // inject component styles


              if (injectStyles) {
                injectStyles.call(this, context);
              } // register component module identifier for async chunk inferrence


              if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
              }
            }; // used by ssr in case component is cached and beforeCreate
            // never gets called


            options._ssrRegister = hook;
          } else if (injectStyles) {
            hook = shadowMode ? function () {
              injectStyles.call(this, this.$root.$options.shadowRoot);
            } : injectStyles;
          }

          if (hook) {
            if (options.functional) {
              // for template-only hot-reload because in that case the render fn doesn't
              // go through the normalizer
              options._injectStyles = hook; // register for functional component in vue file

              var originalRender = options.render;

              options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
              };
            } else {
              // inject component registration as beforeCreate hook
              var existing = options.beforeCreate;
              options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
            }
          }

          return {
            exports: scriptExports,
            options: options
          };
        } // CONCATENATED MODULE: ./src/mixinPropsUpdated.vue


        var mixinPropsUpdated_render, staticRenderFns;
        /* normalize component */

        var component = normalizeComponent(src_mixinPropsUpdatedvue_type_script_lang_js_, mixinPropsUpdated_render, staticRenderFns, false, null, null, null);
        /* harmony default export */

        var mixinPropsUpdated = component.exports; // EXTERNAL MODULE: ./node_modules/lodash.pick/index.js

        var lodash_pick = __webpack_require__("88bc");

        var lodash_pick_default = /*#__PURE__*/__webpack_require__.n(lodash_pick); // EXTERNAL MODULE: ./node_modules/lodash.assign/index.js


        var lodash_assign = __webpack_require__("42a0");

        var lodash_assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign); // EXTERNAL MODULE: ./node_modules/lodash.get/index.js


        var lodash_get = __webpack_require__("c832");

        var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get); // CONCATENATED MODULE: ./src/vNodeUtils.js


        var vNodeUtils_mergeVNodeData = function mergeVNodeData(vnode, name, obj) {
          if (!vnode) {
            return;
          }

          vnode.data = vnode.data || {};
          vnode.data[name] = _objectSpread2({}, vnode.data[name], {}, obj);
        };

        var setVNodeData = function setVNodeData(vnode, name, value) {
          if (!vnode) {
            return;
          }

          vnode.data = vnode.data || {};
          vnode.data[name] = value;
        };

        var DATA_KEYS = ['class', 'staticClass', 'style', 'attrs', 'props', 'domProps', 'on', 'nativeOn', 'directives', 'scopesSlots', 'slot', 'ref', 'key'];

        function mutateKey(key) {
          return '' + key + "-cloned-cid";
        }

        function extractData(vnode, isComp) {
          var data = lodash_pick_default()(vnode.data, DATA_KEYS);

          if (isComp) {
            var cOpts = vnode.componentOptions;
            lodash_assign_default()(data, {
              props: cOpts.propsData,
              on: cOpts.listeners
            });
          }

          if (data.key) {
            data.key = mutateKey(data.key);
          }

          return data;
        }

        var cloneVNode = function cloneVNode(vnode) {
          // use the context that the original vnode was created in.
          var h = vnode.context && vnode.context.$createElement;
          var isComp = !!vnode.componentOptions;
          var isText = !vnode.tag; // this will also match comments but those will be dropped, essentially

          var children = isComp ? vnode.componentOptions.children : vnode.children;
          if (isText) return vnode.text;
          var data = extractData(vnode, isComp);
          var tag = isComp ? vnode.componentOptions.Ctor : vnode.tag;
          var childNodes = children ? children.map(function (c) {
            return cloneVNode(c);
          }) : undefined;
          return h(tag, data, childNodes);
        };

        var vNodeUtils_copyClassesFrom = function copyClassesFrom(vnode, from) {
          var _from$data = from.data,
              data = _from$data === void 0 ? {} : _from$data;
          setVNodeData(vnode, 'staticClass', data.staticClass);
          vNodeUtils_mergeVNodeData(vnode, 'class', _objectSpread2({}, data["class"], {}, from));
        };

        var vNodeUtils_getData = function getData(vnode, path, defaultValue) {
          if (!vnode) {
            return;
          }

          var data = vnode.data || {};
          return typeof path === 'undefined' ? data : lodash_get_default()(data, path, defaultValue);
        };

        var vNodeUtils_getStyle = function getStyle(vnode) {
          return _objectSpread2({}, vNodeUtils_getData(vnode, 'staticStyle', {}), {}, vNodeUtils_getData(vnode, 'style', {}));
        }; // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js


        var es_array_concat = __webpack_require__("99af"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js


        var es_array_every = __webpack_require__("a623"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js


        var es_array_from = __webpack_require__("a630"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js


        var es_array_index_of = __webpack_require__("c975"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js


        var es_array_reduce = __webpack_require__("13d5"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js


        var es_number_constructor = __webpack_require__("a9e3"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js


        var es_regexp_exec = __webpack_require__("ac1f"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js


        var es_string_iterator = __webpack_require__("3ca3"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js


        var es_string_match = __webpack_require__("466d"); // CONCATENATED MODULE: ./src/innerSliderUtils.js


        var canUseDOM = function canUseDOM() {
          return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
        };

        var getPreClones = function getPreClones(spec) {
          if (spec.unslick || !spec.infinite) {
            return 0;
          }

          if (spec.variableWidth) {
            return spec.slideCount;
          }

          return spec.slidesToShow + (spec.centerMode ? 1 : 0);
        };

        var getPostClones = function getPostClones(spec) {
          if (spec.unslick || !spec.infinite) {
            return 0;
          }

          return spec.slideCount;
        };

        var innerSliderUtils_keyHandler = function keyHandler(e, accessibility, rtl) {
          if (e.target.tagName.match('TEXTAREA|INPUT|SELECT') || !accessibility) return '';
          if (e.keyCode === 37) return rtl ? 'next' : 'previous';
          if (e.keyCode === 39) return rtl ? 'previous' : 'next';
          return '';
        };

        var siblingDirection = function siblingDirection(spec) {
          if (spec.targetSlide > spec.currentSlide) {
            if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
              return 'left';
            }

            return 'right';
          } else {
            if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
              return 'right';
            }

            return 'left';
          }
        };

        var slidesOnRight = function slidesOnRight(_ref) {
          var slidesToShow = _ref.slidesToShow,
              centerMode = _ref.centerMode,
              rtl = _ref.rtl,
              centerPadding = _ref.centerPadding; // returns no of slides on the right of active slide

          if (centerMode) {
            var right = (slidesToShow - 1) / 2 + 1;
            if (parseInt(centerPadding) > 0) right += 1;
            if (rtl && slidesToShow % 2 === 0) right += 1;
            return right;
          }

          if (rtl) {
            return 0;
          }

          return slidesToShow - 1;
        };

        var slidesOnLeft = function slidesOnLeft(_ref2) {
          var slidesToShow = _ref2.slidesToShow,
              centerMode = _ref2.centerMode,
              rtl = _ref2.rtl,
              centerPadding = _ref2.centerPadding; // returns no of slides on the left of active slide

          if (centerMode) {
            var left = (slidesToShow - 1) / 2 + 1;
            if (parseInt(centerPadding) > 0) left += 1;
            if (!rtl && slidesToShow % 2 === 0) left += 1;
            return left;
          }

          if (rtl) {
            return slidesToShow - 1;
          }

          return 0;
        }; // startIndex that needs to be present


        var lazyStartIndex = function lazyStartIndex(spec) {
          return spec.currentSlide - lazySlidesOnLeft(spec);
        };

        var lazyEndIndex = function lazyEndIndex(spec) {
          return spec.currentSlide + lazySlidesOnRight(spec);
        };

        var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
          return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
        };

        var lazySlidesOnRight = function lazySlidesOnRight(spec) {
          return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
        };

        var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
          var onDemandSlides = [];
          var startIndex = lazyStartIndex(spec);
          var endIndex = lazyEndIndex(spec);

          for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
            if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
              onDemandSlides.push(slideIndex);
            }
          }

          return onDemandSlides;
        };

        var innerSliderUtils_changeSlide = function changeSlide(spec, options) {
          var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
          var slidesToScroll = spec.slidesToScroll,
              slidesToShow = spec.slidesToShow,
              slideCount = spec.slideCount,
              currentSlide = spec.currentSlide,
              lazyLoad = spec.lazyLoad,
              infinite = spec.infinite;
          unevenOffset = slideCount % slidesToScroll !== 0;
          indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

          if (options.message === 'previous') {
            slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
            targetSlide = currentSlide - slideOffset;

            if (lazyLoad && !infinite) {
              previousInt = currentSlide - slideOffset;
              targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
            }
          } else if (options.message === 'next') {
            slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
            targetSlide = currentSlide + slideOffset;

            if (lazyLoad && !infinite) {
              targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
            }
          } else if (options.message === 'dots') {
            // Click on dots
            targetSlide = options.index * options.slidesToScroll;

            if (targetSlide === options.currentSlide) {
              return null;
            }
          } else if (options.message === 'children') {
            // Click on the slides
            targetSlide = options.index;

            if (targetSlide === options.currentSlide) {
              return null;
            }

            if (infinite) {
              var direction = siblingDirection(_objectSpread2({}, spec, {
                targetSlide: targetSlide
              }));

              if (targetSlide > options.currentSlide && direction === 'left') {
                targetSlide = targetSlide - slideCount;
              } else if (targetSlide < options.currentSlide && direction === 'right') {
                targetSlide = targetSlide + slideCount;
              }
            }
          } else if (options.message === 'index') {
            targetSlide = Number(options.index);

            if (targetSlide === options.currentSlide) {
              return null;
            }
          }

          return targetSlide;
        };

        var filterUndefined = function filterUndefined(props) {
          return Object.keys(props).filter(function (key) {
            return props[key] !== undefined;
          }).reduce(function (obj, key) {
            obj[key] = props[key];
            return obj;
          }, {});
        };

        var filterUndefinedOrNull = function filterUndefinedOrNull(props) {
          return Object.keys(props).filter(function (key) {
            return props[key] !== undefined && props[key] !== null;
          }).reduce(function (obj, key) {
            obj[key] = props[key];
            return obj;
          }, {});
        };

        var innerSliderUtils_swipeStart = function swipeStart(e, swipe, draggable) {
          if (!swipe || !draggable && e.type.indexOf('mouse') !== -1) return '';
          return {
            dragging: true,
            touchObject: {
              startX: e.touches ? e.touches[0].pageX : e.clientX,
              startY: e.touches ? e.touches[0].pageY : e.clientY,
              curX: e.touches ? e.touches[0].pageX : e.clientX,
              curY: e.touches ? e.touches[0].pageY : e.clientY
            }
          };
        };

        var innerSliderUtils_swipeMove = function swipeMove(e, spec) {
          // spec also contains, trackRef and slideIndex
          var scrolling = spec.scrolling,
              animating = spec.animating,
              vertical = spec.vertical,
              swipeToSlide = spec.swipeToSlide,
              verticalSwiping = spec.verticalSwiping,
              rtl = spec.rtl,
              currentSlide = spec.currentSlide,
              edgeFriction = spec.edgeFriction,
              edgeDragged = spec.edgeDragged,
              onEdge = spec.onEdge,
              swiped = spec.swiped,
              swiping = spec.swiping,
              slideCount = spec.slideCount,
              slidesToScroll = spec.slidesToScroll,
              infinite = spec.infinite,
              touchObject = spec.touchObject,
              swipeEvent = spec.swipeEvent,
              listHeight = spec.listHeight,
              listWidth = spec.listWidth;
          if (scrolling) return;
          if (animating) return e.preventDefault();
          if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
          var swipeLeft,
              state = {};
          var curLeft = getTrackLeft(spec);
          touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
          touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
          touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
          var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

          if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
            return {
              scrolling: true
            };
          }

          if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
          var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
          if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
          var dotCount = Math.ceil(slideCount / slidesToScroll);
          var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
          var touchSwipeLength = touchObject.swipeLength;

          if (!infinite) {
            if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left' || !canGoNext(spec) && swipeDirection === 'left') {
              touchSwipeLength = touchObject.swipeLength * edgeFriction;

              if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state['edgeDragged'] = true;
              }
            }
          }

          if (!swiped && swipeEvent) {
            swipeEvent(swipeDirection);
            state['swiped'] = true;
          }

          if (!vertical) {
            if (!rtl) {
              swipeLeft = curLeft + touchSwipeLength * positionOffset;
            } else {
              swipeLeft = curLeft - touchSwipeLength * positionOffset;
            }
          } else {
            swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
          }

          if (verticalSwiping) {
            swipeLeft = curLeft + touchSwipeLength * positionOffset;
          }

          state = _objectSpread2({}, state, {
            touchObject: touchObject,
            swipeLeft: swipeLeft,
            trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
              left: swipeLeft
            }))
          });

          if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
            return state;
          }

          if (touchObject.swipeLength > 10) {
            state['swiping'] = true;
            e.preventDefault();
          }

          return state;
        };

        var innerSliderUtils_swipeEnd = function swipeEnd(e, spec) {
          var dragging = spec.dragging,
              swipe = spec.swipe,
              touchObject = spec.touchObject,
              listWidth = spec.listWidth,
              touchThreshold = spec.touchThreshold,
              verticalSwiping = spec.verticalSwiping,
              listHeight = spec.listHeight,
              currentSlide = spec.currentSlide,
              swipeToSlide = spec.swipeToSlide,
              scrolling = spec.scrolling,
              onSwipe = spec.onSwipe;

          if (!dragging) {
            if (swipe) e.preventDefault();
            return {};
          }

          var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
          var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

          var state = {
            dragging: false,
            edgeDragged: false,
            scrolling: false,
            swiping: false,
            swiped: false,
            swipeLeft: null,
            touchObject: {}
          };

          if (scrolling) {
            return state;
          }

          if (!touchObject.swipeLength) {
            return state;
          }

          if (touchObject.swipeLength > minSwipe) {
            e.preventDefault();

            if (onSwipe) {
              onSwipe(swipeDirection);
            }

            var slideCount, newSlide;

            switch (swipeDirection) {
              case 'left':
              case 'up':
                newSlide = currentSlide + getSlideCount(spec);
                slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
                state['currentDirection'] = 0;
                break;

              case 'right':
              case 'down':
                newSlide = currentSlide - getSlideCount(spec);
                slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
                state['currentDirection'] = 1;
                break;

              default:
                slideCount = currentSlide;
            }

            state['triggerSlideHandler'] = slideCount;
          } else {
            // Adjust the track back to it's original position.
            var currentLeft = getTrackLeft(spec);
            state['trackStyle'] = getTrackAnimateCSS(_objectSpread2({}, spec, {
              left: currentLeft
            }));
          }

          return state;
        };

        var getNavigableIndexes = function getNavigableIndexes(spec) {
          var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
          var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
          var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
          var indexes = [];

          while (breakpoint < max) {
            indexes.push(breakpoint);
            breakpoint = counter + spec.slidesToScroll;
            counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
          }

          return indexes;
        };

        var checkNavigable = function checkNavigable(spec, index) {
          var navigables = getNavigableIndexes(spec);
          var prevNavigable = 0;

          if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
          } else {
            for (var n in navigables) {
              if (index < navigables[n]) {
                index = prevNavigable;
                break;
              }

              prevNavigable = navigables[n];
            }
          }

          return index;
        };

        var getSlideCount = function getSlideCount(spec) {
          var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

          if (spec.swipeToSlide) {
            var swipedSlide;
            var slickList = spec.listRef;
            var slides = slickList.querySelectorAll('.slick-slide');
            Array.from(slides).every(function (slide) {
              if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
                  swipedSlide = slide;
                  return false;
                }
              } else {
                if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
                  swipedSlide = slide;
                  return false;
                }
              }

              return true;
            });

            if (!swipedSlide) {
              return 0;
            }

            var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
            var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
            return slidesTraversed;
          } else {
            return spec.slidesToScroll;
          }
        }; // given an object and a list of keys, return new object with given keys


        var extractObject = function extractObject(spec, keys) {
          var newObject = {};
          keys.forEach(function (key) {
            return newObject[key] = spec[key];
          });
          return newObject;
        };

        var PROP_KEYS = {
          TRACK: ['fade', 'cssEase', 'speed', 'infinite', 'centerMode', 'currentSlide', 'lazyLoad', 'lazyLoadedList', 'rtl', 'slideWidth', 'slideHeight', 'listHeight', 'vertical', 'slidesToShow', 'slidesToScroll', 'slideCount', 'trackStyle', 'variableWidth', 'unslick', 'centerPadding'],
          DOT: ['dotsClass', 'slideCount', 'slidesToShow', 'currentSlide', 'slidesToScroll', 'children', 'customPaging', 'infinite'],
          ARROW: ['infinite', 'centerMode', 'currentSlide', 'slideCount', 'slidesToShow', 'prevArrow', 'nextArrow']
        }; // whether or not we can go next

        var canGoNext = function canGoNext(spec) {
          var canGo = true;

          if (!spec.infinite) {
            if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
              canGo = false;
            } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
              canGo = false;
            }
          }

          return canGo;
        };

        var innerSliderUtils_slideHandler = function slideHandler(spec) {
          var waitForAnimate = spec.waitForAnimate,
              animating = spec.animating,
              fade = spec.fade,
              infinite = spec.infinite,
              index = spec.index,
              slideCount = spec.slideCount,
              lazyLoadedList = spec.lazyLoadedList,
              lazyLoad = spec.lazyLoad,
              currentSlide = spec.currentSlide,
              centerMode = spec.centerMode,
              slidesToScroll = spec.slidesToScroll,
              slidesToShow = spec.slidesToShow,
              useCSS = spec.useCSS;
          if (waitForAnimate && animating) return {};
          var animationSlide = index,
              finalSlide,
              animationLeft,
              finalLeft;
          var state = {},
              nextState = {};

          if (fade) {
            if (!infinite && (index < 0 || index >= slideCount)) return {};

            if (index < 0) {
              animationSlide = index + slideCount;
            } else if (index >= slideCount) {
              animationSlide = index - slideCount;
            }

            if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
              lazyLoadedList.push(animationSlide);
            }

            state = {
              animating: true,
              currentSlide: animationSlide,
              lazyLoadedList: lazyLoadedList
            };
            nextState = {
              animating: false
            };
          } else {
            finalSlide = animationSlide;

            if (animationSlide < 0) {
              finalSlide = animationSlide + slideCount;
              if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
            } else if (!canGoNext(spec) && animationSlide > currentSlide) {
              animationSlide = finalSlide = currentSlide;
            } else if (centerMode && animationSlide >= slideCount) {
              animationSlide = infinite ? slideCount : slideCount - 1;
              finalSlide = infinite ? 0 : slideCount - 1;
            } else if (animationSlide >= slideCount) {
              finalSlide = animationSlide - slideCount;
              if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
            }

            animationLeft = getTrackLeft(_objectSpread2({}, spec, {
              slideIndex: animationSlide
            }));
            finalLeft = getTrackLeft(_objectSpread2({}, spec, {
              slideIndex: finalSlide
            }));

            if (!infinite) {
              if (animationLeft === finalLeft) animationSlide = finalSlide;
              animationLeft = finalLeft;
            }

            lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread2({}, spec, {
              currentSlide: animationSlide
            })));

            if (!useCSS) {
              state = {
                currentSlide: finalSlide,
                trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
                  left: finalLeft
                })),
                lazyLoadedList: lazyLoadedList
              };
            } else {
              state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: getTrackAnimateCSS(_objectSpread2({}, spec, {
                  left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList
              };
              nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
                  left: finalLeft
                })),
                swipeLeft: null
              };
            }
          }

          return {
            state: state,
            nextState: nextState
          };
        }; // get width of an element


        var getWidth = function getWidth(elem) {
          return elem && elem.offsetWidth || 0;
        };

        var getHeight = function getHeight(elem) {
          return elem && elem.offsetHeight || 0;
        };

        var getSwipeDirection = function getSwipeDirection(touchObject) {
          var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var xDist, yDist, r, swipeAngle;
          xDist = touchObject.startX - touchObject.curX;
          yDist = touchObject.startY - touchObject.curY;
          r = Math.atan2(yDist, xDist);
          swipeAngle = Math.round(r * 180 / Math.PI);

          if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
          }

          if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
            return 'left';
          }

          if (swipeAngle >= 135 && swipeAngle <= 225) {
            return 'right';
          }

          if (verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
              return 'up';
            } else {
              return 'down';
            }
          }

          return 'vertical';
        }; // get initialized state


        var initializedState = function initializedState(spec) {
          // spec also contains listRef, trackRef
          var slideCount = spec.children.length;
          var listWidth = Math.ceil(getWidth(spec.listRef));
          var trackWidth = Math.ceil(getWidth(spec.trackRef));
          var slideWidth;

          if (!spec.vertical) {
            var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

            if (typeof spec.centerPadding === 'string' && spec.centerPadding.slice(-1) === '%') {
              centerPaddingAdj *= listWidth / 100;
            }

            slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
          } else {
            slideWidth = listWidth;
          }

          var slideHeight = spec.listRef && getHeight(spec.listRef.querySelector('[data-index="0"]'));
          var listHeight = slideHeight * spec.slidesToShow;
          var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

          if (spec.rtl && spec.currentSlide === undefined) {
            currentSlide = slideCount - 1 - spec.initialSlide;
          }

          var lazyLoadedList = spec.lazyLoadedList || [];
          var slidesToLoad = getOnDemandLazySlides({
            currentSlide: currentSlide,
            lazyLoadedList: lazyLoadedList
          }, spec);
          lazyLoadedList.concat(slidesToLoad);
          var state = {
            slideCount: slideCount,
            slideWidth: slideWidth,
            listWidth: listWidth,
            trackWidth: trackWidth,
            currentSlide: currentSlide,
            slideHeight: slideHeight,
            listHeight: listHeight,
            lazyLoadedList: lazyLoadedList
          };

          if (spec.autoplaying === null && spec.autoplay) {
            state['autoplaying'] = 'playing';
          }

          return state;
        };

        var getTrackLeft = function getTrackLeft(spec) {
          if (spec.unslick) {
            return 0;
          }

          checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
          var slideIndex = spec.slideIndex,
              trackRef = spec.trackRef,
              infinite = spec.infinite,
              centerMode = spec.centerMode,
              slideCount = spec.slideCount,
              slidesToShow = spec.slidesToShow,
              slidesToScroll = spec.slidesToScroll,
              slideWidth = spec.slideWidth,
              listWidth = spec.listWidth,
              variableWidth = spec.variableWidth,
              slideHeight = spec.slideHeight,
              fade = spec.fade,
              vertical = spec.vertical;
          var slideOffset = 0;
          var targetLeft;
          var targetSlide;
          var verticalOffset = 0;

          if (fade || spec.slideCount === 1) {
            return 0;
          }

          var slidesToOffset = 0;

          if (infinite) {
            slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
            // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

            if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
              slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
            } // shift current slide to center of the frame


            if (centerMode) {
              slidesToOffset += parseInt(slidesToShow / 2);
            }
          } else {
            if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
              slidesToOffset = slidesToShow - slideCount % slidesToScroll;
            }

            if (centerMode) {
              slidesToOffset = parseInt(slidesToShow / 2);
            }
          }

          slideOffset = slidesToOffset * slideWidth;
          verticalOffset = slidesToOffset * slideHeight;

          if (!vertical) {
            targetLeft = slideIndex * slideWidth * -1 + slideOffset;
          } else {
            targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
          }

          if (variableWidth === true) {
            var targetSlideIndex;
            var trackElem = trackRef.$el;
            targetSlideIndex = slideIndex + getPreClones(spec);
            targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
            targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

            if (centerMode === true) {
              targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
              targetSlide = trackElem && trackElem.children[targetSlideIndex];
              targetLeft = 0;

              for (var slide = 0; slide < targetSlideIndex; slide++) {
                targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
              }

              targetLeft -= parseInt(spec.centerPadding);
              targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
            }
          }

          return targetLeft;
        };

        var getTotalSlides = function getTotalSlides(spec) {
          return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
        };

        var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
          return keysArray.reduce(function (value, key) {
            return value && spec.hasOwnProperty(key);
          }, true) ? null : console.error('Keys Missing:', spec);
        }; // eslint-disable-line no-console


        var innerSliderUtils_getTrackCSS = function getTrackCSS(spec) {
          checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
          var trackWidth, trackHeight;
          var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

          if (!spec.vertical) {
            trackWidth = getTotalSlides(spec) * spec.slideWidth;
          } else {
            trackHeight = trackChildren * spec.slideHeight;
          }

          var style = {
            opacity: 1,
            transition: '',
            WebkitTransition: ''
          };

          if (spec.useTransform) {
            var WebkitTransform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
            var transform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
            var msTransform = !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)';
            style = _objectSpread2({}, style, {
              WebkitTransform: WebkitTransform,
              transform: transform,
              msTransform: msTransform
            });
          } else {
            if (spec.vertical) {
              style['top'] = spec.left;
            } else {
              style['left'] = spec.left;
            }
          }

          if (spec.fade) style = {
            opacity: 1
          };
          if (trackWidth) style.width = trackWidth + 'px';
          if (trackHeight) style.height = trackHeight + 'px'; // Fallback for IE8

          if (window && !window.addEventListener && window.attachEvent) {
            if (!spec.vertical) {
              style.marginLeft = spec.left + 'px';
            } else {
              style.marginTop = spec.left + 'px';
            }
          }

          return style;
        };

        var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
          checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
          var style = innerSliderUtils_getTrackCSS(spec); // useCSS is true by default so it can be undefined

          if (spec.useTransform) {
            style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
            style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
          } else {
            if (spec.vertical) {
              style.transition = 'top ' + spec.speed + 'ms ' + spec.cssEase;
            } else {
              style.transition = 'left ' + spec.speed + 'ms ' + spec.cssEase;
            }
          }

          return style;
        }; // CONCATENATED MODULE: ./src/defaultProps.js


        var defaultProps_props = {
          accessibility: {
            type: Boolean,
            "default": true
          },
          adaptiveHeight: {
            type: Boolean,
            "default": false
          },
          arrows: {
            type: Boolean,
            "default": true
          },
          asNavFor: {
            type: Object,
            "default": null
          },
          autoplay: {
            type: Boolean,
            "default": false
          },
          autoplaySpeed: {
            type: Number,
            "default": 3000
          },
          centerMode: {
            type: Boolean,
            "default": false
          },
          centerPadding: {
            type: String,
            "default": '50px'
          },
          cssEase: {
            type: String,
            "default": 'ease'
          },
          dots: {
            type: Boolean,
            "default": false
          },
          dotsClass: {
            type: String,
            "default": 'slick-dots'
          },
          draggable: {
            type: Boolean,
            "default": true
          },
          edgeFriction: {
            type: Number,
            "default": 0.35
          },
          fade: {
            type: Boolean,
            "default": false
          },
          focusOnSelect: {
            type: Boolean,
            "default": false
          },
          infinite: {
            type: Boolean,
            "default": true
          },
          initialSlide: {
            type: Number,
            "default": 0
          },
          lazyLoad: {
            type: String,
            "default": null
          },
          pauseOnDotsHover: {
            type: Boolean,
            "default": false
          },
          pauseOnFocus: {
            type: Boolean,
            "default": false
          },
          pauseOnHover: {
            type: Boolean,
            "default": true
          },
          responsive: {
            type: Array,
            "default": null
          },
          rows: {
            type: Number,
            "default": 1
          },
          rtl: {
            type: Boolean,
            "default": false
          },
          slidesPerRow: {
            type: Number,
            "default": 1
          },
          slidesToScroll: {
            type: Number,
            "default": 1
          },
          slidesToShow: {
            type: Number,
            "default": 1
          },
          speed: {
            type: Number,
            "default": 500
          },
          swipe: {
            type: Boolean,
            "default": true
          },
          swipeToSlide: {
            type: Boolean,
            "default": false
          },
          touchMove: {
            type: Boolean,
            "default": true
          },
          touchThreshold: {
            type: Number,
            "default": 5
          },
          useCSS: {
            type: Boolean,
            "default": true
          },
          useTransform: {
            type: Boolean,
            "default": true
          },
          variableWidth: {
            type: Boolean,
            "default": false
          },
          vertical: {
            type: Boolean,
            "default": false
          },
          waitForAnimate: {
            type: Boolean,
            "default": true
          }
        };
        var defaultValues = Object.keys(defaultProps_props).reduce(function (acc, key) {
          acc[key] = defaultProps_props[key]["default"];
          return acc;
        }, {});
        var types = Object.keys(defaultProps_props).reduce(function (acc, key) {
          acc[key] = defaultProps_props[key].type;
          return acc;
        }, {}); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js

        var es_object_assign = __webpack_require__("cca6"); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js


        function _objectWithoutPropertiesLoose(source, excluded) {
          if (source == null) return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i;

          for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
          }

          return target;
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js


        function _objectWithoutProperties(source, excluded) {
          if (source == null) return {};

          var target = _objectWithoutPropertiesLoose(source, excluded);

          var key, i;

          if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
              key = sourceSymbolKeys[i];
              if (excluded.indexOf(key) >= 0) continue;
              if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
              target[key] = source[key];
            }
          }

          return target;
        } // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js


        var es_symbol_description = __webpack_require__("e01a"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js


        var es_symbol_iterator = __webpack_require__("d28b"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js


        var es_array_iterator = __webpack_require__("e260"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js


        var es_object_to_string = __webpack_require__("d3b7"); // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js


        var web_dom_collections_iterator = __webpack_require__("ddb0"); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js


        function _typeof(obj) {
          "@babel/helpers - typeof";

          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof(obj);
        } // EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js


        var ResizeObserver_es = __webpack_require__("6dd8"); // EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js


        var lodash_debounce = __webpack_require__("f7fe");

        var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce); // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderTrack.vue?vue&type=script&lang=js&


        var getSlideClasses = function getSlideClasses(spec) {
          var slickActive, slickCenter, slickCloned;
          var centerOffset, index;

          if (spec.rtl) {
            index = spec.slideCount - 1 - spec.index;
          } else {
            index = spec.index;
          }

          slickCloned = index < 0 || index >= spec.slideCount;

          if (spec.centerMode) {
            centerOffset = Math.floor(spec.slidesToShow / 2);
            slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

            if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
              slickActive = true;
            }
          } else {
            slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
          }

          var slickCurrent = index === spec.currentSlide;
          return {
            'slick-slide': true,
            'slick-active': slickActive,
            'slick-center': slickCenter,
            'slick-cloned': slickCloned,
            'slick-current': slickCurrent // dubious in case of RTL

          };
        };

        var getSlideStyle = function getSlideStyle(spec) {
          var style = {};

          if (spec.variableWidth === undefined || spec.variableWidth === false) {
            style.width = typeof spec.slideWidth === 'number' ? "".concat(spec.slideWidth, "px") : spec.slideWidth;
          }

          if (spec.fade) {
            style.position = 'relative';

            if (spec.vertical) {
              style.top = "".concat(-spec.index * parseInt(spec.slideHeight), "px");
            } else {
              style.left = "".concat(-spec.index * parseInt(spec.slideWidth), "px");
            }

            style.opacity = spec.currentSlide === spec.index ? 1 : 0;
            style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
          }

          return style;
        };

        var getKey = function getKey(child, fallbackKey) {
          return child.key != null && String(child.key) || fallbackKey;
        };
        /* harmony default export */


        var SliderTrackvue_type_script_lang_js_ = {
          name: 'SliderTrack',
          props: PROP_KEYS.TRACK,
          methods: {
            cloneSlide: function cloneSlide(slide, options) {
              var _this = this;

              var clone = cloneVNode(slide);
              clone.key = options.key;
              vNodeUtils_mergeVNodeData(clone, 'class', options["class"]);
              vNodeUtils_mergeVNodeData(clone, 'attrs', options.attrs);
              vNodeUtils_mergeVNodeData(clone, 'style', options.style);
              vNodeUtils_mergeVNodeData(clone, 'on', {
                click: function click(e) {
                  vNodeUtils_getData(slide, 'on.click', function () {})(e);

                  _this.$emit('childClicked', options.childOnClickOptions);
                }
              });
              return clone;
            },
            renderSlides: function renderSlides(spec, children) {
              var _this2 = this;

              var h = this.$createElement;
              var key;
              var slides = [];
              var preCloneSlides = [];
              var postCloneSlides = [];
              var childrenCount = children.length;
              var startIndex = lazyStartIndex(spec);
              var endIndex = lazyEndIndex(spec);
              children.forEach(function (elem, index) {
                var child;
                var childOnClickOptions = {
                  message: 'children',
                  index: index,
                  slidesToScroll: spec.slidesToScroll,
                  currentSlide: spec.currentSlide
                }; // in case of lazyLoad, whether or not we want to fetch the slide

                if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
                  child = elem;
                } else {
                  child = h("div");
                }

                var childStyle = getSlideStyle(_objectSpread2({}, spec, {
                  index: index
                }));
                var slideClasses = getSlideClasses(_objectSpread2({}, spec, {
                  index: index
                })); // push a cloned element of the desired slide

                slides.push(_this2.cloneSlide(child, {
                  key: 'original' + getKey(child, index),
                  "class": slideClasses,
                  style: _objectSpread2({
                    outline: 'none'
                  }, childStyle),
                  attrs: {
                    tabIndex: '-1',
                    'data-index': index,
                    'aria-hidden': "".concat(!slideClasses['slick-active'])
                  },
                  childOnClickOptions: childOnClickOptions
                })); // if slide needs to be precloned or postcloned

                if (spec.infinite && spec.fade === false && childrenCount > spec.slidesToShow) {
                  var preCloneNo = childrenCount - index;

                  if (preCloneNo <= getPreClones(spec) && childrenCount !== spec.slidesToShow) {
                    key = -preCloneNo;

                    if (key >= startIndex) {
                      child = elem;
                    }

                    slideClasses = getSlideClasses(_objectSpread2({}, spec, {
                      index: key
                    }));
                    preCloneSlides.push(_this2.cloneSlide(child, {
                      key: 'precloned' + getKey(child, key),
                      "class": slideClasses,
                      style: childStyle,
                      attrs: {
                        tabIndex: '-1',
                        'data-index': key,
                        'aria-hidden': "".concat(!slideClasses['slick-active'])
                      },
                      childOnClickOptions: childOnClickOptions
                    }));
                  }

                  if (childrenCount !== spec.slidesToShow) {
                    key = childrenCount + index;

                    if (key < endIndex) {
                      child = elem;
                    }

                    slideClasses = getSlideClasses(_objectSpread2({}, spec, {
                      index: key
                    }));
                    postCloneSlides.push(_this2.cloneSlide(child, {
                      key: 'postcloned' + getKey(child, key),
                      "class": slideClasses,
                      style: childStyle,
                      attrs: {
                        tabIndex: '-1',
                        'data-index': key,
                        'aria-hidden': "".concat(!slideClasses['slick-active'])
                      },
                      childOnClickOptions: childOnClickOptions
                    }));
                  }
                }
              }, this);

              if (spec.rtl) {
                return preCloneSlides.concat(slides, postCloneSlides).reverse();
              } else {
                return preCloneSlides.concat(slides, postCloneSlides);
              }
            }
          },
          render: function render() {
            var h = arguments[0];
            var slides = this.renderSlides(this.$props, this.$slots["default"]);
            return h("div", {
              "class": {
                'slick-track': true,
                'slick-center': this.$props.centerMode
              },
              "style": this.trackStyle
            }, [slides]);
          }
        }; // CONCATENATED MODULE: ./src/SliderTrack.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_SliderTrackvue_type_script_lang_js_ = SliderTrackvue_type_script_lang_js_; // EXTERNAL MODULE: ./src/SliderTrack.vue?vue&type=style&index=0&id=e4caeaf8&scoped=true&lang=css&

        var SliderTrackvue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css_ = __webpack_require__("6ea2"); // CONCATENATED MODULE: ./src/SliderTrack.vue


        var SliderTrack_render, SliderTrack_staticRenderFns;
        /* normalize component */

        var SliderTrack_component = normalizeComponent(src_SliderTrackvue_type_script_lang_js_, SliderTrack_render, SliderTrack_staticRenderFns, false, null, "e4caeaf8", null);
        /* harmony default export */

        var SliderTrack = SliderTrack_component.exports; // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js

        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;

          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js


        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js


        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
        } // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js


        var es_function_name = __webpack_require__("b0c0"); // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js


        var es_regexp_to_string = __webpack_require__("25f0"); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js


        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(n);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js


        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js


        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        } // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderArrow.vue?vue&type=script&lang=js&

        /* harmony default export */


        var SliderArrowvue_type_script_lang_js_ = {
          name: 'SliderArrow',
          props: [].concat(_toConsumableArray(PROP_KEYS.ARROW), ['type']),
          render: function render() {
            var _this = this;

            var h = arguments[0];
            var classes = {
              'slick-arrow': true
            };
            var clickable = true;
            var arrow;
            var option = {
              currentSlide: this.currentSlide,
              slideCount: this.slideCount
            };

            if (this.type === 'previous') {
              classes['slick-prev'] = true;

              if (!this.infinite && (this.currentSlide === 0 || this.slideCount <= this.slidesToShow)) {
                classes['slick-disabled'] = true;
                clickable = false;
              }

              option.key = '0';
              arrow = this.prevArrow ? this.prevArrow(option)[0] : h("button", {
                "attrs": {
                  "type": "button",
                  "data-role": "none"
                },
                "style": "display: block;"
              }, ["Previous"]);
            } else {
              classes['slick-next'] = true;

              if (!canGoNext(this.$props)) {
                classes['slick-disabled'] = true;
                clickable = false;
              }

              option.key = '1';
              arrow = this.nextArrow ? this.nextArrow(option)[0] : h("button", {
                "attrs": {
                  "type": "button",
                  "data-role": "none"
                },
                "style": "display: block;"
              }, ["Next"]);
            }

            setVNodeData(arrow, 'key', option.key);
            vNodeUtils_mergeVNodeData(arrow, 'class', classes);
            vNodeUtils_mergeVNodeData(arrow, 'on', {
              click: function click() {
                if (clickable) {
                  _this.$emit('arrowClicked', {
                    message: _this.type
                  });
                }
              }
            });
            return arrow;
          }
        }; // CONCATENATED MODULE: ./src/SliderArrow.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_SliderArrowvue_type_script_lang_js_ = SliderArrowvue_type_script_lang_js_; // EXTERNAL MODULE: ./src/SliderArrow.vue?vue&type=style&index=0&id=21137603&scoped=true&lang=css&

        var SliderArrowvue_type_style_index_0_id_21137603_scoped_true_lang_css_ = __webpack_require__("f013"); // CONCATENATED MODULE: ./src/SliderArrow.vue


        var SliderArrow_render, SliderArrow_staticRenderFns;
        /* normalize component */

        var SliderArrow_component = normalizeComponent(src_SliderArrowvue_type_script_lang_js_, SliderArrow_render, SliderArrow_staticRenderFns, false, null, "21137603", null);
        /* harmony default export */

        var SliderArrow = SliderArrow_component.exports; // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js

        var es_string_split = __webpack_require__("1276"); // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderDots.vue?vue&type=script&lang=js&


        var getDotCount = function getDotCount(spec) {
          var dots;

          if (spec.infinite) {
            dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
          } else {
            dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
          }

          return dots;
        };
        /* harmony default export */


        var SliderDotsvue_type_script_lang_js_ = {
          name: 'SliderDots',
          props: PROP_KEYS.DOT,
          render: function render() {
            var _this = this;

            var h = arguments[0];
            var dotCount = getDotCount({
              slideCount: this.slideCount,
              slidesToScroll: this.slidesToScroll,
              slidesToShow: this.slidesToShow,
              infinite: this.infinite
            }); // Apply join & split to Array to pre-fill it for IE8
            //
            // Credit: http://stackoverflow.com/a/13735425/1849458

            var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
              var leftBound = i * _this.slidesToScroll;
              var rightBound = i * _this.slidesToScroll + (_this.slidesToScroll - 1);
              var className = {
                'slick-active': _this.currentSlide >= leftBound && _this.currentSlide <= rightBound
              };
              var dotOptions = {
                message: 'dots',
                index: i,
                slidesToScroll: _this.slidesToScroll,
                currentSlide: _this.currentSlide
              };
              var customPaging = _this.customPaging ? _this.customPaging(i)[0] : h("button", [i + 1]);
              return h("li", {
                "key": i,
                "class": className,
                "on": {
                  "click": function click() {
                    return _this.$emit('dotClicked', dotOptions);
                  }
                }
              }, [customPaging]);
            });
            var wrapperStyle = {
              display: 'block'
            };

            var wrapperClass = _defineProperty({}, this.dotsClass, true);

            return h("ul", {
              "style": wrapperStyle,
              "class": wrapperClass
            }, [dots]);
          }
        }; // CONCATENATED MODULE: ./src/SliderDots.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_SliderDotsvue_type_script_lang_js_ = SliderDotsvue_type_script_lang_js_; // CONCATENATED MODULE: ./src/SliderDots.vue

        var SliderDots_render, SliderDots_staticRenderFns;
        /* normalize component */

        var SliderDots_component = normalizeComponent(src_SliderDotsvue_type_script_lang_js_, SliderDots_render, SliderDots_staticRenderFns, false, null, null, null);
        /* harmony default export */

        var SliderDots = SliderDots_component.exports; // CONCATENATED MODULE: ./src/initialState.js

        /* harmony default export */

        var initialState = {
          animating: false,
          autoplaying: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          dragging: false,
          edgeDragged: false,
          initialized: false,
          lazyLoadedList: [],
          listHeight: null,
          listWidth: null,
          scrolling: false,
          slideHeight: null,
          slideWidth: null,
          swipeLeft: null,
          swiped: false,
          // used by swipeEvent. differentites between touch and swipe.
          swiping: false,
          touchObject: {
            startX: 0,
            startY: 0,
            curX: 0,
            curY: 0
          },
          trackStyle: {},
          trackWidth: 0
        }; // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/InnerSlider.vue?vue&type=script&lang=js&

        /* harmony default export */

        var InnerSlidervue_type_script_lang_js_ = {
          name: 'InnerSlider',
          components: {
            SliderTrack: SliderTrack,
            SliderArrow: SliderArrow,
            SliderDots: SliderDots
          },
          mixins: [mixinPropsUpdated],
          inheritAttrs: false,
          props: _objectSpread2({}, defaultProps_props, {
            unslick: {
              type: Boolean,
              "default": false
            },
            prevArrow: Function,
            nextArrow: Function,
            customPaging: Function
          }),
          data: function data() {
            return _objectSpread2({}, initialState, {
              currentSlide: this.initialSlide
            });
          },
          computed: {
            slideCount: function slideCount() {
              return this.$slots["default"].length;
            },
            spec: function spec() {
              return _objectSpread2({}, this.$props, {}, this.$data, {
                slideCount: this.slideCount
              });
            }
          },
          created: function created() {
            // non-reactive data
            this.callbackTimers = [];
            this.clickable = true;
            this.debouncedResize = null;
            this.ssrInit();
            this.$parent.$emit('init');

            if (this.lazyLoad) {
              var slidesToLoad = getOnDemandLazySlides(this.spec);

              if (slidesToLoad.length > 0) {
                this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
                this.$parent.$emit('lazyLoad', slidesToLoad);
              }
            }
          },
          mounted: function mounted() {
            var _this = this;

            var spec = _objectSpread2({
              listRef: this.$refs.list,
              trackRef: this.$refs.track,
              children: this.$slots["default"]
            }, this.$props);

            this.updateState(spec, true);
            this.adaptHeight();

            if (this.autoPlay) {
              this.autoPlay('update');
            }

            if (this.lazyLoad === 'progressive') {
              this.lazyLoadTimer = setInterval(this.progressiveLazyLoad, 1000);
            }

            this.ro = new ResizeObserver_es["a"
            /* default */
            ](function () {
              if (_this.animating) {
                _this.onWindowResized(false); // don't set trackStyle hence don't break animation


                _this.callbackTimers.push(setTimeout(function () {
                  return _this.onWindowResized();
                }, _this.speed));
              } else {
                _this.onWindowResized();
              }
            });
            this.ro.observe(this.$refs.list);
            Array.prototype.forEach.call(this.$refs.list.querySelectorAll('.slick-slide'), function (slide) {
              slide.onfocus = _this.pauseOnFocus ? _this.onSlideFocus : null;
              slide.onblur = _this.pauseOnFocus ? _this.onSlideBlur : null;
            });

            if (window.addEventListener) {
              window.addEventListener('resize', this.onWindowResized);
            } else {
              window.attachEvent('onresize', this.onWindowResized);
            }
          },
          updated: function updated() {
            this.checkImagesLoad();
            this.$parent.$emit('reInit');

            if (this.lazyLoad) {
              var slidesToLoad = getOnDemandLazySlides(_objectSpread2({}, this.$props, {}, this.$data));

              if (slidesToLoad.length > 0) {
                this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
                this.$parent.$emit('lazyLoad', slidesToLoad);
              }
            }

            this.adaptHeight();
          },
          beforeDestroy: function beforeDestroy() {
            this.ro.unobserve(this.$refs.list);

            if (this.animationEndCallback) {
              clearTimeout(this.animationEndCallback);
            }

            if (this.lazyLoadTimer) {
              clearInterval(this.lazyLoadTimer);
            }

            if (this.callbackTimers.length) {
              this.callbackTimers.forEach(function (timer) {
                return clearTimeout(timer);
              });
              this.callbackTimers = [];
            }

            if (window.addEventListener) {
              window.removeEventListener('resize', this.onWindowResized);
            } else {
              window.detachEvent('onresize', this.onWindowResized);
            }

            if (this.autoplayTimer) {
              clearInterval(this.autoplayTimer);
            }
          },
          methods: {
            onPropsUpdated: function onPropsUpdated() {
              var nextProps = this.$props;

              var spec = _objectSpread2({
                listRef: this.$refs.list,
                trackRef: this.$refs.track,
                children: this.$slots["default"]
              }, nextProps, {}, this.$data);

              var setTrackStyle = false;

              for (var _i = 0, _Object$keys = Object.keys(this.$props); _i < _Object$keys.length; _i++) {
                var key = _Object$keys[_i];

                if (!nextProps.hasOwnProperty(key)) {
                  setTrackStyle = true;
                  break;
                }

                if (_typeof(nextProps[key]) === 'object' || typeof nextProps[key] === 'function') {
                  continue;
                }

                if (nextProps[key] !== this.$props[key]) {
                  setTrackStyle = true;
                  break;
                }
              }

              this.updateState(spec, setTrackStyle);

              if (this.currentSlide >= this.slideCount) {
                this.changeSlide({
                  message: 'index',
                  index: this.slideCount - nextProps.slidesToShow,
                  currentSlide: this.currentSlide
                });
              }

              if (nextProps.autoplay) {
                this.autoPlay('update');
              } else {
                this.pause('paused');
              }
            },
            updateState: function updateState(spec, setTrackStyle) {
              var updatedState = initializedState(spec);
              spec = _objectSpread2({}, spec, {}, updatedState, {
                slideIndex: updatedState.currentSlide
              });
              var targetLeft = getTrackLeft(spec);
              spec = _objectSpread2({}, spec, {
                left: targetLeft
              });
              var trackStyle = innerSliderUtils_getTrackCSS(spec);

              if (setTrackStyle || this.slideCount !== spec.children.length) {
                updatedState['trackStyle'] = trackStyle;
              }

              Object.assign(this.$data, updatedState);
            },
            adaptHeight: function adaptHeight() {
              if (this.adaptiveHeight && this.$refs.list) {
                var elem = this.$refs.list.querySelector("[data-index=\"".concat(this.currentSlide, "\"]"));
                this.$refs.list.style.height = getHeight(elem) + 'px';
              }
            },
            ssrInit: function ssrInit() {
              var preClones = getPreClones(this.spec);
              var postClones = getPostClones(this.spec);

              if (this.variableWidth) {
                var trackWidth = [],
                    trackLeft = [];
                var childrenWidths = [];
                this.$slots["default"].forEach(function (child) {
                  var _getStyle = vNodeUtils_getStyle(child),
                      width = _getStyle.width;

                  childrenWidths.push(width);
                  trackWidth.push(width);
                });

                for (var i = 0; i < preClones; i++) {
                  trackLeft.push(childrenWidths[childrenWidths.length - 1 - i]);
                  trackWidth.push(childrenWidths[childrenWidths.length - 1 - i]);
                }

                for (var _i2 = 0; _i2 < postClones; _i2++) {
                  trackWidth.push(childrenWidths[_i2]);
                }

                for (var _i3 = 0; _i3 < this.currentSlide; _i3++) {
                  trackLeft.push(childrenWidths[_i3]);
                } // filter undefined


                trackWidth = trackWidth.filter(function (o) {
                  return o;
                });
                trackLeft = trackLeft.filter(function (o) {
                  return o;
                });
                var trackStyle = {
                  width: "calc(".concat(trackWidth.join(' + '), ")"),
                  left: "calc(".concat(trackLeft.map(function (o) {
                    return "-".concat(o);
                  }).join(' + '), ")")
                };

                if (this.centerMode) {
                  var currentWidth = childrenWidths[this.currentSlide];
                  trackStyle.left = "calc(".concat(trackLeft.map(function (o) {
                    return "-".concat(o);
                  }).join(' + '), " + (100% - ").concat(currentWidth, ") / 2 )");
                }

                this.trackStyle = trackStyle;
              } else {
                var slideCount = preClones + postClones + this.slideCount;

                var _trackWidth = 100 / this.slidesToShow * slideCount;

                var slideWidth = 100 / slideCount;

                var _trackLeft = -slideWidth * (preClones + this.currentSlide) * _trackWidth / 100;

                if (this.centerMode) {
                  _trackLeft += (100 - slideWidth * _trackWidth / 100) / 2;
                }

                this.slideWidth = slideWidth + '%';
                this.trackStyle = {
                  width: _trackWidth + '%',
                  left: _trackLeft + '%'
                };
              }
            },
            slideHandler: function slideHandler(index) {
              var _this2 = this;

              var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var asNavFor = this.asNavFor,
                  speed = this.speed; // capture currentslide before state is updated

              var currentSlide = this.currentSlide;

              var _slideHandler2 = innerSliderUtils_slideHandler(_objectSpread2({
                index: index
              }, this.$props, {}, this.$data, {
                trackRef: this.$refs.track,
                useCSS: this.useCSS && !dontAnimate
              })),
                  state = _slideHandler2.state,
                  nextState = _slideHandler2.nextState;

              if (!state) return;
              this.$parent.$emit('beforeChange', currentSlide, state.currentSlide);
              var slidesToLoad = state.lazyLoadedList.filter(function (value) {
                return _this2.lazyLoadedList.indexOf(value) < 0;
              });

              if (slidesToLoad.length) {
                this.$parent.$emit('lazyLoad', slidesToLoad);
              }

              Object.assign(this.$data, state);

              if (asNavFor) {
                asNavFor.goTo(index);
              }

              if (!nextState) return;
              this.animationEndCallback = setTimeout(function () {
                var animating = nextState.animating,
                    firstBatch = _objectWithoutProperties(nextState, ["animating"]);

                Object.assign(_this2.$data, firstBatch);

                _this2.callbackTimers.push(setTimeout(function () {
                  _this2.animating = animating;
                }, 10));

                _this2.$parent.$emit('afterChange', state.currentSlide); // delete this.animationEndCallback


                _this2.animationEndCallback = undefined;
              }, speed);
            },
            onWindowResized: function onWindowResized(setTrackStyle) {
              var _this3 = this;

              if (this.debouncedResize) this.debouncedResize.cancel();
              this.debouncedResize = lodash_debounce_default()(function () {
                return _this3.resizeWindow(setTrackStyle);
              }, 50);
              this.debouncedResize();
            },
            resizeWindow: function resizeWindow() {
              var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

              if (!(this.$refs.track && this.$refs.track.$el)) {
                return;
              }

              var spec = _objectSpread2({
                listRef: this.$refs.list,
                trackRef: this.$refs.track,
                children: this.$slots["default"]
              }, this.$props, {}, this.$data);

              this.updateState(spec, setTrackStyle);

              if (this.autoplay) {
                this.autoPlay('update');
              } else {
                this.pause('paused');
              } // animating state should be cleared while resizing, otherwise autoplay stops working


              this.animating = false;
              clearTimeout(this.animationEndCallback); // delete this.animationEndCallback

              this.animationEndCallback = undefined;
            },
            checkImagesLoad: function checkImagesLoad() {
              var _this4 = this;

              var images = this.$refs.list.querySelectorAll('.slick-slide img');
              var imagesCount = images.length,
                  loadedCount = 0;
              Array.prototype.forEach.call(images, function (image) {
                var handler = function handler() {
                  return ++loadedCount && loadedCount >= imagesCount && _this4.onWindowResized();
                };

                if (!image.onclick) {
                  image.onclick = function () {
                    return image.parentNode.focus();
                  };
                } else {
                  var prevClickHandler = image.onclick;

                  image.onclick = function () {
                    prevClickHandler();
                    image.parentNode.focus();
                  };
                }

                if (!image.onload) {
                  if (_this4.lazyLoad) {
                    image.onload = function () {
                      _this4.adaptHeight();

                      _this4.callbackTimers.push(setTimeout(_this4.onWindowResized, _this4.speed));
                    };
                  } else {
                    image.onload = handler;

                    image.onerror = function () {
                      handler();

                      _this4.$parent.$emit('lazyLoadError');
                    };
                  }
                }
              });
            },
            progressiveLazyLoad: function progressiveLazyLoad() {
              var slidesToLoad = [];

              var spec = _objectSpread2({}, this.$props, {}, this.$data);

              for (var index = this.currentSlide; index < this.slideCount + getPostClones(spec); index++) {
                if (this.lazyLoadedList.indexOf(index) < 0) {
                  slidesToLoad.push(index);
                  break;
                }
              }

              for (var _index = this.currentSlide - 1; _index >= -getPreClones(spec); _index--) {
                if (this.lazyLoadedList.indexOf(_index) < 0) {
                  slidesToLoad.push(_index);
                  break;
                }
              }

              if (slidesToLoad.length > 0) {
                this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
                this.$parent.$emit('lazyLoad', slidesToLoad);
              } else {
                if (this.lazyLoadTimer) {
                  clearInterval(this.lazyLoadTimer); // delete this.lazyLoadTimer;

                  this.lazyLoadTimer = undefined;
                }
              }
            },
            clickHandler: function clickHandler(e) {
              if (this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
              }

              this.clickable = true;
            },
            keyHandler: function keyHandler(e) {
              var dir = innerSliderUtils_keyHandler(e, this.accessibility, this.rtl);
              dir !== '' && this.changeSlide({
                message: dir
              });
            },
            changeSlide: function changeSlide(options) {
              var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

              var spec = _objectSpread2({}, this.$props, {}, this.$data);

              var targetSlide = innerSliderUtils_changeSlide(spec, options);
              if (targetSlide !== 0 && !targetSlide) return;

              if (dontAnimate === true) {
                this.slideHandler(targetSlide, dontAnimate);
              } else {
                this.slideHandler(targetSlide);
              }
            },
            swipeStart: function swipeStart(e) {
              if (this.verticalSwiping) {
                this.disableBodyScroll();
              }

              var state = innerSliderUtils_swipeStart(e, this.swipe, this.draggable);

              if (state !== '') {
                Object.assign(this.$data, state);
              }
            },
            swipeMove: function swipeMove(e) {
              var _this5 = this;

              var state = innerSliderUtils_swipeMove(e, _objectSpread2({}, this.$props, {}, this.$data, {
                trackRef: this.$refs.track,
                listRef: this.$refs.list,
                slideIndex: this.currentSlide,
                onEdge: function onEdge(e) {
                  return _this5.$parent.$emit('edge', e);
                },
                swipeEvent: function swipeEvent(e) {
                  return _this5.$parent.$emit('swipe', e);
                }
              }));
              if (!state) return;

              if (state['swiping']) {
                this.clickable = false;
              }

              Object.assign(this.$data, state);
            },
            swipeEnd: function swipeEnd(e) {
              var state = innerSliderUtils_swipeEnd(e, _objectSpread2({}, this.$props, {}, this.$data, {
                trackRef: this.$refs.track,
                listRef: this.$refs.list,
                slideIndex: this.currentSlide
              }));
              if (!state) return;
              var triggerSlideHandler = state['triggerSlideHandler']; // delete state["triggerSlideHandler"];

              this.triggerSlideHandler = undefined;
              Object.assign(this.$data, state);
              if (triggerSlideHandler === undefined) return;
              this.slideHandler(triggerSlideHandler);

              if (this.verticalSwiping) {
                this.enableBodyScroll();
              }
            },
            prev: function prev() {
              var _this6 = this; // this and fellow methods are wrapped in setTimeout
              // to make sure initialize setState has happened before
              // any of such methods are called


              this.callbackTimers.push(setTimeout(function () {
                return _this6.changeSlide({
                  message: 'previous'
                });
              }, 0));
            },
            next: function next() {
              var _this7 = this;

              this.callbackTimers.push(setTimeout(function () {
                return _this7.changeSlide({
                  message: 'next'
                });
              }, 0));
            },
            goTo: function goTo(slide) {
              var _this8 = this;

              var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              slide = Number(slide);
              if (isNaN(slide)) return '';
              this.callbackTimers.push(setTimeout(function () {
                return _this8.changeSlide({
                  message: 'index',
                  index: slide,
                  currentSlide: _this8.currentSlide
                }, dontAnimate);
              }, 0));
            },
            play: function play() {
              var nextIndex;

              if (this.rtl) {
                nextIndex = this.currentSlide - this.slidesToScroll;
              } else {
                if (canGoNext(_objectSpread2({}, this.$props, {}, this.$data))) {
                  nextIndex = this.currentSlide + this.slidesToScroll;
                } else {
                  return false;
                }
              }

              this.slideHandler(nextIndex);
            },
            autoPlay: function autoPlay(playType) {
              if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
              }

              var autoplaying = this.autoplaying;

              if (playType === 'update') {
                if (autoplaying === 'hovered' || autoplaying === 'focused' || autoplaying === 'paused') {
                  return;
                }
              } else if (playType === 'leave') {
                if (autoplaying === 'paused' || autoplaying === 'focused') {
                  return;
                }
              } else if (playType === 'blur') {
                if (autoplaying === 'paused' || autoplaying === 'hovered') {
                  return;
                }
              }

              this.autoplayTimer = setInterval(this.play, this.autoplaySpeed + 50);
              this.autoplaying = 'playing';
            },
            pause: function pause(pauseType) {
              if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
                this.autoplayTimer = null;
              }

              var autoplaying = this.autoplaying;

              if (pauseType === 'paused') {
                this.autoplaying = 'paused';
              } else if (pauseType === 'focused') {
                if (autoplaying === 'hovered' || autoplaying === 'playing') {
                  this.autoplaying = 'focused';
                }
              } else {
                // pauseType  is 'hovered'
                if (autoplaying === 'playing') {
                  this.autoplaying = 'hovered';
                }
              }
            },
            onDotsOver: function onDotsOver() {
              this.autoplay && this.pause('hovered');
            },
            onDotsLeave: function onDotsLeave() {
              this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
            },
            onTrackOver: function onTrackOver() {
              this.autoplay && this.pause('hovered');
            },
            onTrackLeave: function onTrackLeave() {
              this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
            },
            onSlideFocus: function onSlideFocus() {
              this.autoplay && this.pause('focused');
            },
            onSlideBlur: function onSlideBlur() {
              this.autoplay && this.autoplaying === 'focused' && this.autoPlay('blur');
            },
            selectHandler: function selectHandler(options) {
              if (this.focusOnSelect) {
                this.changeSlide(options);
              }
            }
          },
          render: function render() {
            var h = arguments[0];
            var className = {
              'slick-slider': true,
              'slick-initialized': true,
              'slick-vertical': this.vertical
            };
            var trackProps = extractObject(this.spec, PROP_KEYS.TRACK);
            trackProps = filterUndefined(_objectSpread2({}, trackProps));
            var pauseOnHover = this.pauseOnHover;
            var trackNativeOn = filterUndefined({
              mouseenter: pauseOnHover ? this.onTrackOver : undefined,
              mouseover: pauseOnHover ? this.onTrackOver : undefined,
              mouseleave: pauseOnHover ? this.onTrackLeave : undefined
            });
            var dots;

            if (this.dots === true && this.slideCount >= this.slidesToShow) {
              var dotProps = extractObject(this.spec, PROP_KEYS.DOT);
              var pauseOnDotsHover = this.pauseOnDotsHover;
              var dotNativeOn = filterUndefined({
                mouseenter: pauseOnDotsHover ? this.onDotsLeave : undefined,
                mouseover: pauseOnDotsHover ? this.onDotsOver : undefined,
                mouseleave: pauseOnDotsHover ? this.onDotsLeave : undefined
              });
              dots = h(SliderDots, {
                "props": _objectSpread2({}, dotProps),
                "nativeOn": _objectSpread2({}, dotNativeOn),
                "on": {
                  "dotClicked": this.changeSlide
                }
              });
            }

            var prevArrow, nextArrow;
            var arrowProps = extractObject(this.spec, PROP_KEYS.ARROW);

            if (this.arrows) {
              prevArrow = h(SliderArrow, {
                "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
                  type: 'previous'
                })),
                "on": {
                  "arrowClicked": this.changeSlide
                }
              });
              nextArrow = h(SliderArrow, {
                "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
                  type: 'next'
                })),
                "on": {
                  "arrowClicked": this.changeSlide
                }
              });
            }

            var verticalHeightStyle = {};

            if (this.vertical) {
              verticalHeightStyle = {
                height: "".concat(this.listHeight, "px")
              };
            }

            var centerPaddingStyle = {};

            if (this.vertical === false) {
              if (this.centerMode === true) {
                centerPaddingStyle = {
                  padding: '0px ' + this.centerPadding
                };
              }
            } else {
              if (this.centerMode === true) {
                centerPaddingStyle = {
                  padding: this.centerPadding + ' 0px'
                };
              }
            }

            var listStyle = _objectSpread2({}, this.$parent.$vnode.data.style);

            if (!this.unslick) {
              listStyle = _objectSpread2({}, listStyle, {}, filterUndefinedOrNull(verticalHeightStyle), {}, centerPaddingStyle);
            }

            var accessibility = this.accessibility,
                dragging = this.dragging,
                touchMove = this.touchMove;
            var listOn = filterUndefined({
              click: this.clickHandler,
              mousedown: touchMove ? this.swipeStart : undefined,
              mousemove: dragging && touchMove ? this.swipeMove : undefined,
              mouseup: touchMove ? this.swipeEnd : undefined,
              mouseleave: dragging && touchMove ? this.swipeEnd : undefined,
              touchstart: touchMove ? this.swipeStart : undefined,
              touchmove: dragging && touchMove ? this.swipeMove : undefined,
              touchend: touchMove ? this.swipeEnd : undefined,
              touchcancel: dragging && touchMove ? this.swipeEnd : undefined,
              keydown: accessibility ? this.keyHandler : undefined
            });
            return h("div", {
              "class": className,
              "attrs": {
                "dir": !this.unslick ? 'ltr' : false
              }
            }, [!this.unslick ? prevArrow : '', h("div", {
              "ref": "list",
              "class": 'slick-list',
              "on": _objectSpread2({}, listOn),
              "style": listStyle
            }, [h(SliderTrack, {
              "ref": "track",
              "props": _objectSpread2({}, trackProps),
              "nativeOn": _objectSpread2({}, trackNativeOn),
              "on": {
                "childClicked": this.selectHandler
              }
            }, [this.$slots["default"]])]), !this.unslick ? nextArrow : '', !this.unslick ? dots : '']);
          }
        }; // CONCATENATED MODULE: ./src/InnerSlider.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_InnerSlidervue_type_script_lang_js_ = InnerSlidervue_type_script_lang_js_; // EXTERNAL MODULE: ./src/InnerSlider.vue?vue&type=style&index=0&id=3d1a4f76&scoped=true&lang=css&

        var InnerSlidervue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css_ = __webpack_require__("eaf9"); // CONCATENATED MODULE: ./src/InnerSlider.vue


        var InnerSlider_render, InnerSlider_staticRenderFns;
        /* normalize component */

        var InnerSlider_component = normalizeComponent(src_InnerSlidervue_type_script_lang_js_, InnerSlider_render, InnerSlider_staticRenderFns, false, null, "3d1a4f76", null);
        /* harmony default export */

        var InnerSlider = InnerSlider_component.exports; // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VueSlickCarousel.vue?vue&type=script&lang=js&

        var enquire = canUseDOM() && __webpack_require__("8e95");
        /* harmony default export */


        var VueSlickCarouselvue_type_script_lang_js_ = {
          name: 'VueSlickCarousel',
          components: {
            InnerSlider: InnerSlider
          },
          mixins: [mixinPropsUpdated],
          inheritAttrs: false,
          props: defaultProps_props,
          data: function data() {
            return {
              breakpoint: null
            };
          },
          computed: {
            settings: function settings() {
              var _this = this;

              var props = filterUndefined(this.$props);
              var settings;
              var newProps;

              if (this.breakpoint) {
                newProps = this.responsive.filter(function (resp) {
                  return resp.breakpoint === _this.breakpoint;
                });
                settings = newProps[0].settings === 'unslick' ? 'unslick' : _objectSpread2({}, defaultValues, {}, props, {}, newProps[0].settings);
              } else {
                settings = _objectSpread2({}, defaultValues, {}, props);
              } // force scrolling by one if centerMode is on


              if (settings.centerMode) {
                if (settings.slidesToScroll > 1 && "production" !== 'production') {
                  // eslint-disable-next-line no-console
                  console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
                }

                settings.slidesToScroll = 1;
              } // force showing one slide and scrolling by one if the fade mode is on


              if (settings.fade) {
                if (settings.slidesToShow > 1 && "production" !== 'production') {
                  // eslint-disable-next-line no-console
                  console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
                }

                if (settings.slidesToScroll > 1 && "production" !== 'production') {
                  // eslint-disable-next-line no-console
                  console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
                }

                settings.slidesToShow = 1;
                settings.slidesToScroll = 1;
              } // rows and slidesPerRow logic is handled here


              if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                // eslint-disable-next-line no-console
                console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                settings.variableWidth = false;
              }

              return settings;
            }
          },
          created: function created() {
            this.makeBreakpoints();
          },
          beforeDestroy: function beforeDestroy() {
            this.clearBreakpoints();
          },
          methods: {
            prev: function prev() {
              this.$refs.innerSlider.prev();
            },
            next: function next() {
              this.$refs.innerSlider.next();
            },
            goTo: function goTo(slide) {
              var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              this.$refs.innerSlider.goTo(slide, dontAnimate);
            },
            pause: function pause() {
              this.$refs.innerSlider.pause('paused');
            },
            play: function play() {
              this.$refs.innerSlider.autoPlay('play');
            },
            onPropsUpdated: function onPropsUpdated() {
              this.clearBreakpoints();
              this.makeBreakpoints();
            },
            clearBreakpoints: function clearBreakpoints() {
              this.responsiveMediaHandlers.forEach(function (obj) {
                return enquire.unregister(obj.query, obj.handler);
              });
              this.responsiveMediaHandlers = [];
            },
            media: function media(query, handler) {
              // javascript handler for  css media query
              // when not using server side rendering
              if (!canUseDOM()) {
                return;
              }

              enquire.register(query, handler);
              this.responsiveMediaHandlers.push({
                query: query,
                handler: handler
              });
            },
            makeBreakpoints: function makeBreakpoints() {
              var _this2 = this;

              this.breakpoint = null;
              this.responsiveMediaHandlers = []; // handles responsive breakpoints

              if (this.responsive) {
                var breakpoints = this.responsive.map(function (breakpt) {
                  return breakpt.breakpoint;
                }); // sort them in increasing order of their numerical value

                breakpoints.sort(function (x, y) {
                  return x - y;
                });
                breakpoints.forEach(function (breakpoint, index) {
                  // media query for each breakpoint
                  var mediaQuery = json2mq_default()({
                    minWidth: index === 0 ? 0 : breakpoints[index - 1] + 1,
                    maxWidth: breakpoint
                  });

                  _this2.media(mediaQuery, function () {
                    _this2.breakpoint = breakpoint;
                  });
                }); // Register media query for full screen. Need to support resize from small to large
                // convert javascript object to media query string

                var query = json2mq_default()({
                  minWidth: breakpoints.slice(-1)[0]
                });
                this.media(query, function () {
                  _this2.breakpoint = null;
                });
              }
            }
          },
          render: function render() {
            var h = arguments[0];
            var settings = this.settings;
            var children = this.$slots["default"] || [];

            if (settings === 'unslick') {
              return h("div", {
                "class": "regular slider"
              }, [children]);
            }

            settings.prevArrow = this.$scopedSlots.prevArrow;
            settings.nextArrow = this.$scopedSlots.nextArrow;
            settings.customPaging = this.$scopedSlots.customPaging;
            children = children.filter(function (child) {
              return !!child.tag;
            });
            var newChildren = [];
            var currentWidth = null;

            for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
              var newSlide = [];

              for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
                var row = [];

                for (var k = j; k < j + settings.slidesPerRow; k += 1) {
                  if (settings.variableWidth && vNodeUtils_getStyle(children[k])) {
                    currentWidth = vNodeUtils_getStyle(children[k]).width;
                  }

                  if (k >= children.length) break;
                  var clonedVNode = cloneVNode(children[k]);
                  setVNodeData(clonedVNode, 'key', 100 * i + 10 * j + k);
                  vNodeUtils_mergeVNodeData(clonedVNode, 'attrs', {
                    tabIndex: -1
                  });
                  vNodeUtils_mergeVNodeData(clonedVNode, 'style', {
                    width: "".concat(100 / settings.slidesPerRow, "%"),
                    display: 'inline-block'
                  });
                  row.push(clonedVNode);
                }

                newSlide.push(h("div", {
                  "key": 10 * i + j
                }, [row]));
              }

              if (settings.variableWidth) {
                newChildren.push(h("div", {
                  "key": i,
                  "style": {
                    width: currentWidth
                  }
                }, [newSlide]));
              } else {
                newChildren.push(h("div", {
                  "key": i
                }, [newSlide]));
              }
            }

            if (newChildren.length <= settings.slidesToShow) {
              settings.unslick = true;
            }

            return h(InnerSlider, {
              "ref": "innerSlider",
              "props": _objectSpread2({}, settings),
              "key": Object.values(settings).join('')
            }, [newChildren]);
          }
        }; // CONCATENATED MODULE: ./src/VueSlickCarousel.vue?vue&type=script&lang=js&

        /* harmony default export */

        var src_VueSlickCarouselvue_type_script_lang_js_ = VueSlickCarouselvue_type_script_lang_js_; // CONCATENATED MODULE: ./src/VueSlickCarousel.vue

        var VueSlickCarousel_render, VueSlickCarousel_staticRenderFns;
        /* normalize component */

        var VueSlickCarousel_component = normalizeComponent(src_VueSlickCarouselvue_type_script_lang_js_, VueSlickCarousel_render, VueSlickCarousel_staticRenderFns, false, null, null, null);
        /* harmony default export */

        var VueSlickCarousel = VueSlickCarousel_component.exports; // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js

        /* harmony default export */

        var entry_lib = __webpack_exports__["default"] = VueSlickCarousel;
        /***/
      },

      /***/
      "fb6a":
      /***/
      function fb6a(module, exports, __webpack_require__) {
        "use strict";

        var $ = __webpack_require__("23e7");

        var isObject = __webpack_require__("861d");

        var isArray = __webpack_require__("e8b5");

        var toAbsoluteIndex = __webpack_require__("23cb");

        var toLength = __webpack_require__("50c4");

        var toIndexedObject = __webpack_require__("fc6a");

        var createProperty = __webpack_require__("8418");

        var wellKnownSymbol = __webpack_require__("b622");

        var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

        var arrayMethodUsesToLength = __webpack_require__("ae40");

        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
        var USES_TO_LENGTH = arrayMethodUsesToLength('slice', {
          ACCESSORS: true,
          0: 0,
          1: 2
        });
        var SPECIES = wellKnownSymbol('species');
        var nativeSlice = [].slice;
        var max = Math.max; // `Array.prototype.slice` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.slice
        // fallback for not array-like ES3 strings and DOM objects

        $({
          target: 'Array',
          proto: true,
          forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
        }, {
          slice: function slice(start, end) {
            var O = toIndexedObject(this);
            var length = toLength(O.length);
            var k = toAbsoluteIndex(start, length);
            var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

            var Constructor, result, n;

            if (isArray(O)) {
              Constructor = O.constructor; // cross-realm fallback

              if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
                Constructor = undefined;
              } else if (isObject(Constructor)) {
                Constructor = Constructor[SPECIES];
                if (Constructor === null) Constructor = undefined;
              }

              if (Constructor === Array || Constructor === undefined) {
                return nativeSlice.call(O, k, fin);
              }
            }

            result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));

            for (n = 0; k < fin; k++, n++) {
              if (k in O) createProperty(result, n, O[k]);
            }

            result.length = n;
            return result;
          }
        });
        /***/
      },

      /***/
      "fc6a":
      /***/
      function fc6a(module, exports, __webpack_require__) {
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__("44ad");

        var requireObjectCoercible = __webpack_require__("1d80");

        module.exports = function (it) {
          return IndexedObject(requireObjectCoercible(it));
        };
        /***/

      },

      /***/
      "fdb2":
      /***/
      function fdb2(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "fdbc":
      /***/
      function fdbc(module, exports) {
        // iterable DOM collections
        // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
        module.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0
        };
        /***/
      },

      /***/
      "fdbf":
      /***/
      function fdbf(module, exports, __webpack_require__) {
        var NATIVE_SYMBOL = __webpack_require__("4930");

        module.exports = NATIVE_SYMBOL // eslint-disable-next-line no-undef
        && !Symbol.sham // eslint-disable-next-line no-undef
        && _typeof2(Symbol.iterator) == 'symbol';
        /***/
      }
      /******/

    })["default"]
  );
});